import krutogidon_extrimalno_ostriy_chipsio_thumbnail from '../assets/images/game-collection-thumbnails/krutogidon_extrimalno_ostriy_chipsio-thumbnail.png';
import Neuderzhimye_Edinorozhki_18 from '../assets/images/game-collection-thumbnails/Neuderzhimye_Edinorozhki_18+.png';
import Munchkin from '../assets/images/game-collection-thumbnails/Munchkin.png';
import vzryvnye_kotyata from '../assets/images/game-collection-thumbnails/vzryvnye_kotyata.png';
import Bunker from '../assets/images/game-collection-thumbnails/Bunker.png';
import ya_ne_chelovek from '../assets/images/game-collection-thumbnails/ya_ne_chelovek.png';
import vnutri_lapenko from '../assets/images/game-collection-thumbnails/vnutri_lapenko.png';
import citadels_classic from '../assets/images/game-collection-thumbnails/citadels_classic.png';
import Vsmortit_Vsjo from '../assets/images/game-collection-thumbnails/Vsmortit_Vsjo.png';
import Strashnye_Skazki from '../assets/images/game-collection-thumbnails/Strashnye_Skazki.png';
import Neuderzhimye_Edinorozhki from '../assets/images/game-collection-thumbnails/Neuderzhimye_Edinorozhki.png';
import Taverna_Krasnyj_Drakon from '../assets/images/game-collection-thumbnails/Taverna_Krasnyj_Drakon.png';
import memy from '../assets/images/game-collection-thumbnails/memy.png';
import Nechto from '../assets/images/game-collection-thumbnails/Nechto.png';
import spyfall_new from '../assets/images/game-collection-thumbnails/spyfall_new.png';
import Sudniy_Den from '../assets/images/game-collection-thumbnails/Sudniy_Den.png';
import Tramvay_Smerti from '../assets/images/game-collection-thumbnails/Tramvay_Smerti.png';
import Conex from '../assets/images/game-collection-thumbnails/Conex.png';
import Ekivoki from '../assets/images/game-collection-thumbnails/Ekivoki.png';
import Gnomi_Vrediteli from '../assets/images/game-collection-thumbnails/Gnomi_Vrediteli.png';
import Samyiy_ujasnyiy_chelovek from '../assets/images/game-collection-thumbnails/Samyiy_ujasnyiy_chelovek.png';
import kucha_voprosov from '../assets/images/game-collection-thumbnails/kucha_voprosov.png';
import Codenames from '../assets/images/game-collection-thumbnails/Codenames.png';
import Munchkin_Warhammer_40000 from '../assets/images/game-collection-thumbnails/Munchkin_Warhammer-40000.png';
import Fak_moy_mozg from '../assets/images/game-collection-thumbnails/Fak_moy_mozg.png';
import JKI_UjasArkhama from '../assets/images/game-collection-thumbnails/JKI_UjasArkhama.png';
import EldritchHorror from '../assets/images/game-collection-thumbnails/EldritchHorror.png';
import hrebty_bezumiya_kniga_igra from '../assets/images/game-collection-thumbnails/hrebty_bezumiya_kniga_igra.png';
import unfathomable from '../assets/images/game-collection-thumbnails/unfathomable.png';
import The_Shadow_Over_Innsmouth_front from '../assets/images/game-collection-thumbnails/The_Shadow_Over_Innsmouth_front.png';
import YArost_Drakuly from '../assets/images/game-collection-thumbnails/YArost_Drakuly.png';
import Nuar from '../assets/images/game-collection-thumbnails/Nuar.png';
import Paranormal from '../assets/images/game-collection-thumbnails/Paranormal.png';
import Sherlok_box from '../assets/images/game-collection-thumbnails/Sherlok_box.png';
import AH_Final_Hour from '../assets/images/game-collection-thumbnails/AH_Final-Hour.png';
import Mafiya_Vsya_Semya_V_Sbore_Maski from '../assets/images/game-collection-thumbnails/Mafiya_Vsya_Semya_V_Sbore_Maski.png';
import Mesto_Prestupleniya_Srednevekovye from '../assets/images/game-collection-thumbnails/Mesto_Prestupleniya_Srednevekovye.png';
import duna_sekrety_velikih_domov from '../assets/images/game-collection-thumbnails/duna_sekrety_velikih_domov.png';
import Mistrium from '../assets/images/game-collection-thumbnails/Mistrium.png';
import Spycon from '../assets/images/game-collection-thumbnails/Spycon.png';
import Mortum from '../assets/images/game-collection-thumbnails/Mortum.png';
import detektivnye_hroniki_flamandskoe_zaveschanie from '../assets/images/game-collection-thumbnails/detektivnye_hroniki_flamandskoe_zaveschanie.png';
import smertelnie_materialy from '../assets/images/game-collection-thumbnails/smertelnie_materialy.png';
import Odnajdi_V_Chikago from '../assets/images/game-collection-thumbnails/Odnajdi_V_Chikago.png';
import Similo_myths from '../assets/images/game-collection-thumbnails/Similo_myths.png';
import pochtoviy_yaschik from '../assets/images/game-collection-thumbnails/pochtoviy_yaschik.png';
import Mesto_prestuplenia_Prekrasnaya_epokha from '../assets/images/game-collection-thumbnails/Mesto_prestuplenia_Prekrasnaya_epokha.png';
import Uotergate from '../assets/images/game-collection-thumbnails/Uotergate.png';
import Venskiy_Svyaznoi from '../assets/images/game-collection-thumbnails/Venskiy_Svyaznoi.png';
import Sledstvie from '../assets/images/game-collection-thumbnails/Sledstvie.png';
import Soprotivlenie from '../assets/images/game-collection-thumbnails/Soprotivlenie.png';
import Bogy_Olimpa from '../assets/images/game-collection-thumbnails/Bogy_Olimpa.png';
import Bang_Star_Wars from '../assets/images/game-collection-thumbnails/Bang_Star_Wars.png';
import Gravity_Falls_Memory from '../assets/images/game-collection-thumbnails/Gravity_Falls_Memory.png';
import krosmaster_arena from '../assets/images/game-collection-thumbnails/krosmaster_arena.png';
import Activity_Travel from '../assets/images/game-collection-thumbnails/Activity_Travel.png';
import LotR_journey_in_middle_earth from '../assets/images/game-collection-thumbnails/LotR_journey-in-middle-earth.png';
import descent_legends_of_the_dark from '../assets/images/game-collection-thumbnails/descent_legends_of_the_dark.png';
import Mansions_of_Madness_box from '../assets/images/game-collection-thumbnails/Mansions-of-Madness_box.png';
import Zombicide_2ed from '../assets/images/game-collection-thumbnails/Zombicide_2ed.png';
import Pathfinder_CG_base from '../assets/images/game-collection-thumbnails/Pathfinder_CG_base.png';
import Zomby_V_Dome_Zarajenie from '../assets/images/game-collection-thumbnails/Zomby_V_Dome_Zarajenie.png';
import Ostrov_duhov from '../assets/images/game-collection-thumbnails/Ostrov_duhov.png';
import Mor_Utopia from '../assets/images/game-collection-thumbnails/Mor_Utopia.png';
import Robinzon_Kruzo_Vtoraya_Redakciya from '../assets/images/game-collection-thumbnails/Robinzon_Kruzo_Vtoraya_Redakciya.png';
import Fallout_Atomic_Bonds from '../assets/images/game-collection-thumbnails/Fallout_Atomic-Bonds.png';
import Nemesida_Voidseeders from '../assets/images/game-collection-thumbnails/Nemesida_Voidseeders.png';
import Chujaya_Planeta from '../assets/images/game-collection-thumbnails/Chujaya_Planeta.png';
import Pandemic from '../assets/images/game-collection-thumbnails/Pandemic.png';
import enciklopediya from '../assets/images/game-collection-thumbnails/enciklopediya.png';
import kosmicheskiy_desant_komix_igra from '../assets/images/game-collection-thumbnails/kosmicheskiy_desant_komix_igra.png';
import SWOuterRim from '../assets/images/game-collection-thumbnails/SWOuterRim.png';
import Runebound from '../assets/images/game-collection-thumbnails/Runebound.png';
import Jakal from '../assets/images/game-collection-thumbnails/Jakal.png';
import voyny_chyornoy_rozy_preispodnyaya from '../assets/images/game-collection-thumbnails/voyny_chyornoy_rozy_preispodnyaya.png';
import Zapret_ostr from '../assets/images/game-collection-thumbnails/Zapret_ostr.png';
import Dungeons from '../assets/images/game-collection-thumbnails/Dungeons.png';
import oltre from '../assets/images/game-collection-thumbnails/oltre.png';
import vechnaya_zima from '../assets/images/game-collection-thumbnails/vechnaya_zima.png';
import Arnaks from '../assets/images/game-collection-thumbnails/Arnaks.png';
import Talisman from '../assets/images/game-collection-thumbnails/Talisman.png';
import Oboroten from '../assets/images/game-collection-thumbnails/Oboroten.png';
import enciklopediya_bolshoe_puteshestvie from '../assets/images/game-collection-thumbnails/enciklopediya_bolshoe_puteshestvie.png';
import Hellboy from '../assets/images/game-collection-thumbnails/Hellboy.png';
import Shakal_Archipelag from '../assets/images/game-collection-thumbnails/Shakal_Archipelag.png';
import epoha_oblakov from '../assets/images/game-collection-thumbnails/epoha_oblakov.png';
import Paleo_NB from '../assets/images/game-collection-thumbnails/Paleo_NB.png';
import istoriya_ricarya from '../assets/images/game-collection-thumbnails/istoriya_ricarya.png';
import Ticket_to_Ride_Europe from '../assets/images/game-collection-thumbnails/Ticket-to-Ride_Europe.png';
import bitva_za_rokugan from '../assets/images/game-collection-thumbnails/bitva-za-rokugan.png';
import gameOfThrones from '../assets/images/game-collection-thumbnails/gameOfThrones.png';
import Ehverdell from '../assets/images/game-collection-thumbnails/Ehverdell.png';
import Small_World from '../assets/images/game-collection-thumbnails/Small-World.png';
import bitoku from '../assets/images/game-collection-thumbnails/bitoku.png';
import CIV02TerraIncognitaBox from '../assets/images/game-collection-thumbnails/CIV02TerraIncognitaBox.png';
import Industry from '../assets/images/game-collection-thumbnails/Industry.png';
import BattleTech from '../assets/images/game-collection-thumbnails/BattleTech.png';
import metro2033 from '../assets/images/game-collection-thumbnails/metro2033.png';
import seven_Chudes from '../assets/images/game-collection-thumbnails/7_Chudes.png';
import Osnovateli_Mrachnoy_Gavani from '../assets/images/game-collection-thumbnails/Osnovateli_Mrachnoy_Gavani.png';
import Sudnyiy_den_proekt_Chistilische from '../assets/images/game-collection-thumbnails/Sudnyiy_den_proekt_Chistilische.png';
import krutogidon_extrimalno_ostriy_chipsio_1 from '../assets/images/game-collection-images/krutogidon_extrimalno_ostriy_chipsio-1.webp';
import krutogidon_extrimalno_ostriy_chipsio_2 from '../assets/images/game-collection-images/krutogidon_extrimalno_ostriy_chipsio-2.webp';
import krutogidon_extrimalno_ostriy_chipsio_3 from '../assets/images/game-collection-images/krutogidon_extrimalno_ostriy_chipsio-3.webp';
import krutogidon_extrimalno_ostriy_chipsio_4 from '../assets/images/game-collection-images/krutogidon_extrimalno_ostriy_chipsio-4.webp';
import krutogidon_extrimalno_ostriy_chipsio_5 from '../assets/images/game-collection-images/krutogidon_extrimalno_ostriy_chipsio-5.webp';
import krutogidon_extrimalno_ostriy_chipsio_6 from '../assets/images/game-collection-images/krutogidon_extrimalno_ostriy_chipsio-6.webp';
import krutogidon_extrimalno_ostriy_chipsio_7 from '../assets/images/game-collection-images/krutogidon_extrimalno_ostriy_chipsio-7.webp';
import krutogidon_extrimalno_ostriy_chipsio_8 from '../assets/images/game-collection-images/krutogidon_extrimalno_ostriy_chipsio-8.webp';
import krutogidon_extrimalno_ostriy_chipsio_9 from '../assets/images/game-collection-images/krutogidon_extrimalno_ostriy_chipsio-9.webp';
import krutogidon_extrimalno_ostriy_chipsio_10 from '../assets/images/game-collection-images/krutogidon_extrimalno_ostriy_chipsio-10.webp';
import Neuderzhimye_Edinorozhki_18_1 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki(18+)1.webp';
import Neuderzhimye_Edinorozhki_18_2 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki(18+)2.webp';
import Neuderzhimye_Edinorozhki_18_3 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki(18+)3.webp';
import Neuderzhimye_Edinorozhki_18_4 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki(18+)4.webp';
import Neuderzhimye_Edinorozhki_18_5 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki(18+)5.webp';
import Neuderzhimye_Edinorozhki_18_6 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki(18+)6.webp';
import Neuderzhimye_Edinorozhki_18_7 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki(18+)7.webp';
import Neuderzhimye_Edinorozhki_18_8 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki(18+)8.webp';
import Munchkin_1 from '../assets/images/game-collection-images/Munchkin-1.webp';
import Munchkin_2 from '../assets/images/game-collection-images/Munchkin-2.webp';
import Munchkin_3 from '../assets/images/game-collection-images/Munchkin-3.webp';
import Munchkin_4 from '../assets/images/game-collection-images/Munchkin-4.webp';
import Munchkin_5 from '../assets/images/game-collection-images/Munchkin-5.webp';
import Munchkin_6 from '../assets/images/game-collection-images/Munchkin-6.webp';
import Munchkin_7 from '../assets/images/game-collection-images/Munchkin-7.webp';
import vzryvnye_kotyata1 from '../assets/images/game-collection-images/vzryvnye_kotyata1.webp';
import vzryvnye_kotyata2 from '../assets/images/game-collection-images/vzryvnye_kotyata2.webp';
import vzryvnye_kotyata3 from '../assets/images/game-collection-images/vzryvnye_kotyata3.webp';
import vzryvnye_kotyata4 from '../assets/images/game-collection-images/vzryvnye_kotyata4.webp';
import vzryvnye_kotyata5 from '../assets/images/game-collection-images/vzryvnye_kotyata5.webp';
import vzryvnye_kotyata6 from '../assets/images/game-collection-images/vzryvnye_kotyata6.webp';
import vzryvnye_kotyata7 from '../assets/images/game-collection-images/vzryvnye_kotyata7.webp';
import vzryvnye_kotyata8 from '../assets/images/game-collection-images/vzryvnye_kotyata8.webp';
import Bunker1 from '../assets/images/game-collection-images/Bunker1.webp';
import Bunker2 from '../assets/images/game-collection-images/Bunker2.webp';
import Bunker3 from '../assets/images/game-collection-images/Bunker3.webp';
import Bunker4 from '../assets/images/game-collection-images/Bunker4.webp';
import Bunker5 from '../assets/images/game-collection-images/Bunker5.webp';
import Bunker6 from '../assets/images/game-collection-images/Bunker6.webp';
import Bunker7 from '../assets/images/game-collection-images/Bunker7.webp';
import Bunker8 from '../assets/images/game-collection-images/Bunker8.webp';
import Bunker9 from '../assets/images/game-collection-images/Bunker9.webp';
import ya_ne_chelovek1 from '../assets/images/game-collection-images/ya_ne_chelovek1.webp';
import ya_ne_chelovek2 from '../assets/images/game-collection-images/ya_ne_chelovek2.webp';
import ya_ne_chelovek3 from '../assets/images/game-collection-images/ya_ne_chelovek3.webp';
import ya_ne_chelovek4 from '../assets/images/game-collection-images/ya_ne_chelovek4.webp';
import ya_ne_chelovek5 from '../assets/images/game-collection-images/ya_ne_chelovek5.webp';
import ya_ne_chelovek6 from '../assets/images/game-collection-images/ya_ne_chelovek6.webp';
import ya_ne_chelovek7 from '../assets/images/game-collection-images/ya_ne_chelovek7.webp';
import ya_ne_chelovek8 from '../assets/images/game-collection-images/ya_ne_chelovek8.webp';
import ya_ne_chelovek9 from '../assets/images/game-collection-images/ya_ne_chelovek9.webp';
import ya_ne_chelovek10 from '../assets/images/game-collection-images/ya_ne_chelovek10.webp';
import ya_ne_chelovek11 from '../assets/images/game-collection-images/ya_ne_chelovek11.webp';
import vnutri_lapenko1 from '../assets/images/game-collection-images/vnutri_lapenko1.webp';
import vnutri_lapenko2 from '../assets/images/game-collection-images/vnutri_lapenko2.webp';
import vnutri_lapenko3 from '../assets/images/game-collection-images/vnutri_lapenko3.webp';
import vnutri_lapenko4 from '../assets/images/game-collection-images/vnutri_lapenko4.webp';
import vnutri_lapenko5 from '../assets/images/game-collection-images/vnutri_lapenko5.webp';
import vnutri_lapenko6 from '../assets/images/game-collection-images/vnutri_lapenko6.webp';
import vnutri_lapenko7 from '../assets/images/game-collection-images/vnutri_lapenko7.webp';
import vnutri_lapenko8 from '../assets/images/game-collection-images/vnutri_lapenko8.webp';
import vnutri_lapenko9 from '../assets/images/game-collection-images/vnutri_lapenko9.webp';
import vnutri_lapenko10 from '../assets/images/game-collection-images/vnutri_lapenko10.webp';
import vnutri_lapenko11 from '../assets/images/game-collection-images/vnutri_lapenko11.webp';
import citadels_classic1 from '../assets/images/game-collection-images/citadels_classic1.webp';
import citadels_classic2 from '../assets/images/game-collection-images/citadels_classic2.webp';
import citadels_classic3 from '../assets/images/game-collection-images/citadels_classic3.webp';
import citadels_classic4 from '../assets/images/game-collection-images/citadels_classic4.webp';
import citadels_classic5 from '../assets/images/game-collection-images/citadels_classic5.webp';
import Vsmortit_Vsjo1 from '../assets/images/game-collection-images/Vsmortit_Vsjo1.webp';
import Vsmortit_Vsjo2 from '../assets/images/game-collection-images/Vsmortit_Vsjo2.webp';
import Vsmortit_Vsjo3 from '../assets/images/game-collection-images/Vsmortit_Vsjo3.webp';
import Vsmortit_Vsjo4 from '../assets/images/game-collection-images/Vsmortit_Vsjo4.webp';
import Vsmortit_Vsjo5 from '../assets/images/game-collection-images/Vsmortit_Vsjo5.webp';
import Vsmortit_Vsjo6 from '../assets/images/game-collection-images/Vsmortit_Vsjo6.webp';
import Vsmortit_Vsjo7 from '../assets/images/game-collection-images/Vsmortit_Vsjo7.webp';
import Vsmortit_Vsjo8 from '../assets/images/game-collection-images/Vsmortit_Vsjo8.webp';
import Vsmortit_Vsjo9 from '../assets/images/game-collection-images/Vsmortit_Vsjo9.webp';
import Strashnye_Skazki1 from '../assets/images/game-collection-images/Strashnye_Skazki1.webp';
import Strashnye_Skazki2 from '../assets/images/game-collection-images/Strashnye_Skazki2.webp';
import Strashnye_Skazki3 from '../assets/images/game-collection-images/Strashnye_Skazki3.webp';
import Strashnye_Skazki4 from '../assets/images/game-collection-images/Strashnye_Skazki4.webp';
import Strashnye_Skazki5 from '../assets/images/game-collection-images/Strashnye_Skazki5.webp';
import Strashnye_Skazki6 from '../assets/images/game-collection-images/Strashnye_Skazki6.webp';
import Strashnye_Skazki7 from '../assets/images/game-collection-images/Strashnye_Skazki7.webp';
import Strashnye_Skazki8 from '../assets/images/game-collection-images/Strashnye_Skazki8.webp';
import Strashnye_Skazki9 from '../assets/images/game-collection-images/Strashnye_Skazki9.webp';
import Strashnye_Skazki10 from '../assets/images/game-collection-images/Strashnye_Skazki10.webp';
import Neuderzhimye_Edinorozhki1 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki1.webp';
import Neuderzhimye_Edinorozhki2 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki2.webp';
import Neuderzhimye_Edinorozhki3 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki3.webp';
import Neuderzhimye_Edinorozhki4 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki4.webp';
import Neuderzhimye_Edinorozhki5 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki5.webp';
import Neuderzhimye_Edinorozhki6 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki6.webp';
import Neuderzhimye_Edinorozhki7 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki7.webp';
import Neuderzhimye_Edinorozhki8 from '../assets/images/game-collection-images/Neuderzhimye_Edinorozhki8.webp';
import Taverna_Krasnyj_Drakon1 from '../assets/images/game-collection-images/Taverna_Krasnyj_Drakon1.webp';
import Taverna_Krasnyj_Drakon2 from '../assets/images/game-collection-images/Taverna_Krasnyj_Drakon2.webp';
import Taverna_Krasnyj_Drakon3 from '../assets/images/game-collection-images/Taverna_Krasnyj_Drakon3.webp';
import Taverna_Krasnyj_Drakon4 from '../assets/images/game-collection-images/Taverna_Krasnyj_Drakon4.webp';
import Taverna_Krasnyj_Drakon5 from '../assets/images/game-collection-images/Taverna_Krasnyj_Drakon5.webp';
import Taverna_Krasnyj_Drakon6 from '../assets/images/game-collection-images/Taverna_Krasnyj_Drakon6.webp';
import Taverna_Krasnyj_Drakon7 from '../assets/images/game-collection-images/Taverna_Krasnyj_Drakon7.webp';
import memy1 from '../assets/images/game-collection-images/memy1.webp';
import memy2 from '../assets/images/game-collection-images/memy2.webp';
import memy3 from '../assets/images/game-collection-images/memy3.webp';
import memy4 from '../assets/images/game-collection-images/memy4.webp';
import memy5 from '../assets/images/game-collection-images/memy5.webp';
import memy6 from '../assets/images/game-collection-images/memy6.webp';
import memy7 from '../assets/images/game-collection-images/memy7.webp';
import memy8 from '../assets/images/game-collection-images/memy8.webp';
import Nechto1 from '../assets/images/game-collection-images/Nechto1.webp';
import Nechto2 from '../assets/images/game-collection-images/Nechto2.webp';
import Nechto3 from '../assets/images/game-collection-images/Nechto3.webp';
import Nechto4 from '../assets/images/game-collection-images/Nechto4.webp';
import Nechto5 from '../assets/images/game-collection-images/Nechto5.webp';
import Nechto6 from '../assets/images/game-collection-images/Nechto6.webp';
import Nechto7 from '../assets/images/game-collection-images/Nechto7.webp';
import Nechto8 from '../assets/images/game-collection-images/Nechto8.webp';
import spyfall_new1 from '../assets/images/game-collection-images/spyfall_new1.webp';
import spyfall_new2 from '../assets/images/game-collection-images/spyfall_new2.webp';
import spyfall_new3 from '../assets/images/game-collection-images/spyfall_new3.webp';
import spyfall_new4 from '../assets/images/game-collection-images/spyfall_new4.webp';
import spyfall_new5 from '../assets/images/game-collection-images/spyfall_new5.webp';
import spyfall_new6 from '../assets/images/game-collection-images/spyfall_new6.webp';
import spyfall_new7 from '../assets/images/game-collection-images/spyfall_new7.webp';
import Sudniy_Den1 from '../assets/images/game-collection-images/Sudniy_Den1.webp';
import Sudniy_Den2 from '../assets/images/game-collection-images/Sudniy_Den2.webp';
import Sudniy_Den3 from '../assets/images/game-collection-images/Sudniy_Den3.webp';
import Sudniy_Den4 from '../assets/images/game-collection-images/Sudniy_Den4.webp';
import Sudniy_Den5 from '../assets/images/game-collection-images/Sudniy_Den5.webp';
import Sudniy_Den6 from '../assets/images/game-collection-images/Sudniy_Den6.webp';
import Sudniy_Den7 from '../assets/images/game-collection-images/Sudniy_Den7.webp';
import Sudniy_Den8 from '../assets/images/game-collection-images/Sudniy_Den8.webp';
import Sudniy_Den9 from '../assets/images/game-collection-images/Sudniy_Den9.webp';
import Sudniy_Den10 from '../assets/images/game-collection-images/Sudniy_Den10.webp';
import Sudniy_Den11 from '../assets/images/game-collection-images/Sudniy_Den11.webp';
import Tramvay_Smerti1 from '../assets/images/game-collection-images/Tramvay_Smerti1.webp';
import Tramvay_Smerti2 from '../assets/images/game-collection-images/Tramvay_Smerti2.webp';
import Tramvay_Smerti3 from '../assets/images/game-collection-images/Tramvay_Smerti3.webp';
import Tramvay_Smerti4 from '../assets/images/game-collection-images/Tramvay_Smerti4.webp';
import Tramvay_Smerti5 from '../assets/images/game-collection-images/Tramvay_Smerti5.webp';
import Tramvay_Smerti6 from '../assets/images/game-collection-images/Tramvay_Smerti6.webp';
import Tramvay_Smerti7 from '../assets/images/game-collection-images/Tramvay_Smerti7.webp';
import Tramvay_Smerti8 from '../assets/images/game-collection-images/Tramvay_Smerti8.webp';
import Tramvay_Smerti9 from '../assets/images/game-collection-images/Tramvay_Smerti9.webp';
import Tramvay_Smerti10 from '../assets/images/game-collection-images/Tramvay_Smerti10.webp';
import Conex1 from '../assets/images/game-collection-images/Conex1.webp';
import Conex2 from '../assets/images/game-collection-images/Conex2.webp';
import Conex3 from '../assets/images/game-collection-images/Conex3.webp';
import Conex4 from '../assets/images/game-collection-images/Conex4.webp';
import Conex5 from '../assets/images/game-collection-images/Conex5.webp';
import Conex6 from '../assets/images/game-collection-images/Conex6.webp';
import Conex7 from '../assets/images/game-collection-images/Conex7.webp';
import Conex8 from '../assets/images/game-collection-images/Conex8.webp';
import Ekivoki1 from '../assets/images/game-collection-images/Ekivoki1.webp';
import Ekivoki2 from '../assets/images/game-collection-images/Ekivoki2.webp';
import Ekivoki3 from '../assets/images/game-collection-images/Ekivoki3.webp';
import Ekivoki4 from '../assets/images/game-collection-images/Ekivoki4.webp';
import Ekivoki5 from '../assets/images/game-collection-images/Ekivoki5.webp';
import Ekivoki6 from '../assets/images/game-collection-images/Ekivoki6.webp';
import Ekivoki7 from '../assets/images/game-collection-images/Ekivoki7.webp';
import Ekivoki8 from '../assets/images/game-collection-images/Ekivoki8.webp';
import Ekivoki9 from '../assets/images/game-collection-images/Ekivoki9.webp';
import Gnomi_Vrediteli1 from '../assets/images/game-collection-images/Gnomi_Vrediteli1.webp';
import Gnomi_Vrediteli2 from '../assets/images/game-collection-images/Gnomi_Vrediteli2.webp';
import Gnomi_Vrediteli3 from '../assets/images/game-collection-images/Gnomi_Vrediteli3.webp';
import Gnomi_Vrediteli4 from '../assets/images/game-collection-images/Gnomi_Vrediteli4.webp';
import Gnomi_Vrediteli5 from '../assets/images/game-collection-images/Gnomi_Vrediteli5.webp';
import Gnomi_Vrediteli6 from '../assets/images/game-collection-images/Gnomi_Vrediteli6.webp';
import Gnomi_Vrediteli7 from '../assets/images/game-collection-images/Gnomi_Vrediteli7.webp';
import Samyiy_ujasnyiy_chelovek1 from '../assets/images/game-collection-images/Samyiy_ujasnyiy_chelovek1.webp';
import Samyiy_ujasnyiy_chelovek2 from '../assets/images/game-collection-images/Samyiy_ujasnyiy_chelovek2.webp';
import Samyiy_ujasnyiy_chelovek3 from '../assets/images/game-collection-images/Samyiy_ujasnyiy_chelovek3.webp';
import Samyiy_ujasnyiy_chelovek4 from '../assets/images/game-collection-images/Samyiy_ujasnyiy_chelovek4.webp';
import Samyiy_ujasnyiy_chelovek5 from '../assets/images/game-collection-images/Samyiy_ujasnyiy_chelovek5.webp';
import Samyiy_ujasnyiy_chelovek6 from '../assets/images/game-collection-images/Samyiy_ujasnyiy_chelovek6.webp';
import Samyiy_ujasnyiy_chelovek7 from '../assets/images/game-collection-images/Samyiy_ujasnyiy_chelovek7.webp';
import Samyiy_ujasnyiy_chelovek8 from '../assets/images/game-collection-images/Samyiy_ujasnyiy_chelovek8.webp';
import Samyiy_ujasnyiy_chelovek9 from '../assets/images/game-collection-images/Samyiy_ujasnyiy_chelovek9.webp';
import Samyiy_ujasnyiy_chelovek10 from '../assets/images/game-collection-images/Samyiy_ujasnyiy_chelovek10.webp';
import kucha_voprosov1 from '../assets/images/game-collection-images/kucha_voprosov1.webp';
import kucha_voprosov2 from '../assets/images/game-collection-images/kucha_voprosov2.webp';
import kucha_voprosov3 from '../assets/images/game-collection-images/kucha_voprosov3.webp';
import kucha_voprosov4 from '../assets/images/game-collection-images/kucha_voprosov4.webp';
import kucha_voprosov5 from '../assets/images/game-collection-images/kucha_voprosov5.webp';
import kucha_voprosov6 from '../assets/images/game-collection-images/kucha_voprosov6.webp';
import kucha_voprosov7 from '../assets/images/game-collection-images/kucha_voprosov7.webp';
import kucha_voprosov8 from '../assets/images/game-collection-images/kucha_voprosov8.webp';
import kucha_voprosov9 from '../assets/images/game-collection-images/kucha_voprosov9.webp';
import Codenames1 from '../assets/images/game-collection-images/Codenames1.webp';
import Codenames2 from '../assets/images/game-collection-images/Codenames2.webp';
import Codenames3 from '../assets/images/game-collection-images/Codenames3.webp';
import Codenames4 from '../assets/images/game-collection-images/Codenames4.webp';
import Codenames5 from '../assets/images/game-collection-images/Codenames5.webp';
import Codenames6 from '../assets/images/game-collection-images/Codenames6.webp';
import Codenames7 from '../assets/images/game-collection-images/Codenames7.webp';
import Codenames8 from '../assets/images/game-collection-images/Codenames8.webp';
import Munchkin_Warhammer_40000_1 from '../assets/images/game-collection-images/Munchkin_Warhammer-40000_1.webp';
import Munchkin_Warhammer_40000_2 from '../assets/images/game-collection-images/Munchkin_Warhammer-40000_2.webp';
import Munchkin_Warhammer_40000_3 from '../assets/images/game-collection-images/Munchkin_Warhammer-40000_3.webp';
import Munchkin_Warhammer_40000_4 from '../assets/images/game-collection-images/Munchkin_Warhammer-40000_4.webp';
import Munchkin_Warhammer_40000_5 from '../assets/images/game-collection-images/Munchkin_Warhammer-40000_5.webp';
import Munchkin_Warhammer_40000_6 from '../assets/images/game-collection-images/Munchkin_Warhammer-40000_6.webp';
import Munchkin_Warhammer_40000_7 from '../assets/images/game-collection-images/Munchkin_Warhammer-40000_7.webp';
import Munchkin_Warhammer_40000_8 from '../assets/images/game-collection-images/Munchkin_Warhammer-40000_8.webp';
import Fak_moy_mozg_1 from '../assets/images/game-collection-images/Fak_moy_mozg_1.webp';
import Fak_moy_mozg_2 from '../assets/images/game-collection-images/Fak_moy_mozg_2.webp';
import Fak_moy_mozg_3 from '../assets/images/game-collection-images/Fak_moy_mozg_3.webp';
import Fak_moy_mozg_4 from '../assets/images/game-collection-images/Fak_moy_mozg_4.webp';
import JKI_UjasArkhama1 from '../assets/images/game-collection-images/JKI_UjasArkhama1.webp';
import JKI_UjasArkhama2 from '../assets/images/game-collection-images/JKI_UjasArkhama2.webp';
import JKI_UjasArkhama3 from '../assets/images/game-collection-images/JKI_UjasArkhama3.webp';
import JKI_UjasArkhama4 from '../assets/images/game-collection-images/JKI_UjasArkhama4.webp';
import JKI_UjasArkhama5 from '../assets/images/game-collection-images/JKI_UjasArkhama5.webp';
import JKI_UjasArkhama6 from '../assets/images/game-collection-images/JKI_UjasArkhama6.webp';
import JKI_UjasArkhama7 from '../assets/images/game-collection-images/JKI_UjasArkhama7.webp';
import JKI_UjasArkhama8 from '../assets/images/game-collection-images/JKI_UjasArkhama8.webp';
import JKI_UjasArkhama9 from '../assets/images/game-collection-images/JKI_UjasArkhama9.webp';
import JKI_UjasArkhama10 from '../assets/images/game-collection-images/JKI_UjasArkhama10.webp';
import JKI_UjasArkhama11 from '../assets/images/game-collection-images/JKI_UjasArkhama11.webp';
import EldritchHorror1 from '../assets/images/game-collection-images/EldritchHorror1.webp';
import EldritchHorror2 from '../assets/images/game-collection-images/EldritchHorror2.webp';
import EldritchHorror3 from '../assets/images/game-collection-images/EldritchHorror3.webp';
import EldritchHorror4 from '../assets/images/game-collection-images/EldritchHorror4.webp';
import EldritchHorror5 from '../assets/images/game-collection-images/EldritchHorror5.webp';
import EldritchHorror6 from '../assets/images/game-collection-images/EldritchHorror6.webp';
import EldritchHorror7 from '../assets/images/game-collection-images/EldritchHorror7.webp';
import EldritchHorror8 from '../assets/images/game-collection-images/EldritchHorror8.webp';
import EldritchHorror9 from '../assets/images/game-collection-images/EldritchHorror9.webp';
import EldritchHorror10 from '../assets/images/game-collection-images/EldritchHorror10.webp';
import hrebty_bezumiya_kniga_igra1 from '../assets/images/game-collection-images/hrebty_bezumiya_kniga_igra1.webp';
import hrebty_bezumiya_kniga_igra2 from '../assets/images/game-collection-images/hrebty_bezumiya_kniga_igra2.webp';
import hrebty_bezumiya_kniga_igra3 from '../assets/images/game-collection-images/hrebty_bezumiya_kniga_igra3.webp';
import hrebty_bezumiya_kniga_igra4 from '../assets/images/game-collection-images/hrebty_bezumiya_kniga_igra4.webp';
import unfathomable1 from '../assets/images/game-collection-images/unfathomable1.webp';
import unfathomable2 from '../assets/images/game-collection-images/unfathomable2.webp';
import unfathomable3 from '../assets/images/game-collection-images/unfathomable3.webp';
import unfathomable4 from '../assets/images/game-collection-images/unfathomable4.webp';
import unfathomable5 from '../assets/images/game-collection-images/unfathomable5.webp';
import unfathomable6 from '../assets/images/game-collection-images/unfathomable6.webp';
import unfathomable7 from '../assets/images/game-collection-images/unfathomable7.webp';
import The_Shadow_Over_Innsmouth_front_1 from '../assets/images/game-collection-images/The_Shadow_Over_Innsmouth_front_1.webp';
import The_Shadow_Over_Innsmouth_front_2 from '../assets/images/game-collection-images/The_Shadow_Over_Innsmouth_front_2.webp';
import The_Shadow_Over_Innsmouth_front_3 from '../assets/images/game-collection-images/The_Shadow_Over_Innsmouth_front_3.webp';
import The_Shadow_Over_Innsmouth_front_4 from '../assets/images/game-collection-images/The_Shadow_Over_Innsmouth_front_4.webp';
import YArost_Drakuly_1 from '../assets/images/game-collection-images/YArost_Drakuly_1.webp';
import YArost_Drakuly_2 from '../assets/images/game-collection-images/YArost_Drakuly_2.webp';
import YArost_Drakuly_3 from '../assets/images/game-collection-images/YArost_Drakuly_3.webp';
import YArost_Drakuly_4 from '../assets/images/game-collection-images/YArost_Drakuly_4.webp';
import YArost_Drakuly_5 from '../assets/images/game-collection-images/YArost_Drakuly_5.webp';
import YArost_Drakuly_6 from '../assets/images/game-collection-images/YArost_Drakuly_6.webp';
import YArost_Drakuly_7 from '../assets/images/game-collection-images/YArost_Drakuly_7.webp';
import YArost_Drakuly_8 from '../assets/images/game-collection-images/YArost_Drakuly_8.webp';
import YArost_Drakuly_9 from '../assets/images/game-collection-images/YArost_Drakuly_9.webp';
import Nuar_1 from '../assets/images/game-collection-images/Nuar_1.webp';
import Nuar_2 from '../assets/images/game-collection-images/Nuar_2.webp';
import Nuar_3 from '../assets/images/game-collection-images/Nuar_3.webp';
import Nuar_4 from '../assets/images/game-collection-images/Nuar_4.webp';
import Nuar_5 from '../assets/images/game-collection-images/Nuar_5.webp';
import Nuar_6 from '../assets/images/game-collection-images/Nuar_6.webp';
import Nuar_7 from '../assets/images/game-collection-images/Nuar_7.webp';
import Nuar_8 from '../assets/images/game-collection-images/Nuar_8.webp';
import Paranormal_1 from '../assets/images/game-collection-images/Paranormal_1.webp';
import Paranormal_2 from '../assets/images/game-collection-images/Paranormal_2.webp';
import Paranormal_3 from '../assets/images/game-collection-images/Paranormal_3.webp';
import Paranormal_4 from '../assets/images/game-collection-images/Paranormal_4.webp';
import Paranormal_5 from '../assets/images/game-collection-images/Paranormal_5.webp';
import Paranormal_6 from '../assets/images/game-collection-images/Paranormal_6.webp';
import Paranormal_7 from '../assets/images/game-collection-images/Paranormal_7.webp';
import Sherlok_box_1 from '../assets/images/game-collection-images/Sherlok_box_1.webp';
import Sherlok_box_2 from '../assets/images/game-collection-images/Sherlok_box_2.webp';
import Sherlok_box_3 from '../assets/images/game-collection-images/Sherlok_box_3.webp';
import Sherlok_box_4 from '../assets/images/game-collection-images/Sherlok_box_4.webp';
import Sherlok_box_5 from '../assets/images/game-collection-images/Sherlok_box_5.webp';
import Sherlok_box_6 from '../assets/images/game-collection-images/Sherlok_box_6.webp';
import Sherlok_box_7 from '../assets/images/game-collection-images/Sherlok_box_7.webp';
import AH_Final_Hour_1 from '../assets/images/game-collection-images/AH_Final-Hour_1.webp';
import AH_Final_Hour_2 from '../assets/images/game-collection-images/AH_Final-Hour_2.webp';
import AH_Final_Hour_3 from '../assets/images/game-collection-images/AH_Final-Hour_3.webp';
import AH_Final_Hour_4 from '../assets/images/game-collection-images/AH_Final-Hour_4.webp';
import AH_Final_Hour_5 from '../assets/images/game-collection-images/AH_Final-Hour_5.webp';
import AH_Final_Hour_6 from '../assets/images/game-collection-images/AH_Final-Hour_6.webp';
import AH_Final_Hour_7 from '../assets/images/game-collection-images/AH_Final-Hour_7.webp';
import AH_Final_Hour_8 from '../assets/images/game-collection-images/AH_Final-Hour_8.webp';
import Mafiya_Vsya_Semya_V_Sbore_Maski_1 from '../assets/images/game-collection-images/Mafiya_Vsya_Semya_V_Sbore_Maski_1.webp';
import Mafiya_Vsya_Semya_V_Sbore_Maski_2 from '../assets/images/game-collection-images/Mafiya_Vsya_Semya_V_Sbore_Maski_2.webp';
import Mafiya_Vsya_Semya_V_Sbore_Maski_3 from '../assets/images/game-collection-images/Mafiya_Vsya_Semya_V_Sbore_Maski_3.webp';
import Mafiya_Vsya_Semya_V_Sbore_Maski_4 from '../assets/images/game-collection-images/Mafiya_Vsya_Semya_V_Sbore_Maski_4.webp';
import Mafiya_Vsya_Semya_V_Sbore_Maski_5 from '../assets/images/game-collection-images/Mafiya_Vsya_Semya_V_Sbore_Maski_5.webp';
import Mafiya_Vsya_Semya_V_Sbore_Maski_6 from '../assets/images/game-collection-images/Mafiya_Vsya_Semya_V_Sbore_Maski_6.webp';
import Mafiya_Vsya_Semya_V_Sbore_Maski_7 from '../assets/images/game-collection-images/Mafiya_Vsya_Semya_V_Sbore_Maski_7.webp';
import Mafiya_Vsya_Semya_V_Sbore_Maski_8 from '../assets/images/game-collection-images/Mafiya_Vsya_Semya_V_Sbore_Maski_8.webp';
import Mafiya_Vsya_Semya_V_Sbore_Maski_9 from '../assets/images/game-collection-images/Mafiya_Vsya_Semya_V_Sbore_Maski_9.webp';
import Mafiya_Vsya_Semya_V_Sbore_Maski_10 from '../assets/images/game-collection-images/Mafiya_Vsya_Semya_V_Sbore_Maski_10.webp';
import Mesto_Prestupleniya_Srednevekovye_1 from '../assets/images/game-collection-images/Mesto_Prestupleniya_Srednevekovye_1.webp';
import Mesto_Prestupleniya_Srednevekovye_2 from '../assets/images/game-collection-images/Mesto_Prestupleniya_Srednevekovye_2.webp';
import Mesto_Prestupleniya_Srednevekovye_3 from '../assets/images/game-collection-images/Mesto_Prestupleniya_Srednevekovye_3.webp';
import Mesto_Prestupleniya_Srednevekovye_4 from '../assets/images/game-collection-images/Mesto_Prestupleniya_Srednevekovye_4.webp';
import Mesto_Prestupleniya_Srednevekovye_5 from '../assets/images/game-collection-images/Mesto_Prestupleniya_Srednevekovye_5.webp';
import Mesto_Prestupleniya_Srednevekovye_6 from '../assets/images/game-collection-images/Mesto_Prestupleniya_Srednevekovye_6.webp';
import Mesto_Prestupleniya_Srednevekovye_7 from '../assets/images/game-collection-images/Mesto_Prestupleniya_Srednevekovye_7.webp';
import Mesto_Prestupleniya_Srednevekovye_8 from '../assets/images/game-collection-images/Mesto_Prestupleniya_Srednevekovye_8.webp';
import Mesto_Prestupleniya_Srednevekovye_9 from '../assets/images/game-collection-images/Mesto_Prestupleniya_Srednevekovye_9.webp';
import Mesto_Prestupleniya_Srednevekovye_10 from '../assets/images/game-collection-images/Mesto_Prestupleniya_Srednevekovye_10.webp';
import duna_sekrety_velikih_domov_1 from '../assets/images/game-collection-images/duna_sekrety_velikih_domov_1.webp';
import duna_sekrety_velikih_domov_2 from '../assets/images/game-collection-images/duna_sekrety_velikih_domov_2.webp';
import duna_sekrety_velikih_domov_3 from '../assets/images/game-collection-images/duna_sekrety_velikih_domov_3.webp';
import duna_sekrety_velikih_domov_4 from '../assets/images/game-collection-images/duna_sekrety_velikih_domov_4.webp';
import duna_sekrety_velikih_domov_5 from '../assets/images/game-collection-images/duna_sekrety_velikih_domov_5.webp';
import duna_sekrety_velikih_domov_6 from '../assets/images/game-collection-images/duna_sekrety_velikih_domov_6.webp';
import duna_sekrety_velikih_domov_7 from '../assets/images/game-collection-images/duna_sekrety_velikih_domov_7.webp';
import duna_sekrety_velikih_domov_8 from '../assets/images/game-collection-images/duna_sekrety_velikih_domov_8.webp';
import duna_sekrety_velikih_domov_9 from '../assets/images/game-collection-images/duna_sekrety_velikih_domov_9.webp';
import duna_sekrety_velikih_domov_10 from '../assets/images/game-collection-images/duna_sekrety_velikih_domov_10.webp';
import duna_sekrety_velikih_domov_11 from '../assets/images/game-collection-images/duna_sekrety_velikih_domov_11.webp';
import duna_sekrety_velikih_domov_12 from '../assets/images/game-collection-images/duna_sekrety_velikih_domov_12.webp';
import Mistrium_1 from '../assets/images/game-collection-images/Mistrium_1.webp';
import Mistrium_2 from '../assets/images/game-collection-images/Mistrium_2.webp';
import Mistrium_3 from '../assets/images/game-collection-images/Mistrium_3.webp';
import Mistrium_4 from '../assets/images/game-collection-images/Mistrium_4.webp';
import Mistrium_5 from '../assets/images/game-collection-images/Mistrium_5.webp';
import Mistrium_6 from '../assets/images/game-collection-images/Mistrium_6.webp';
import Mistrium_7 from '../assets/images/game-collection-images/Mistrium_7.webp';
import Mistrium_8 from '../assets/images/game-collection-images/Mistrium_8.webp';
import Mistrium_9 from '../assets/images/game-collection-images/Mistrium_9.webp';
import Mistrium_10 from '../assets/images/game-collection-images/Mistrium_10.webp';
import Mistrium_11 from '../assets/images/game-collection-images/Mistrium_11.webp';
import Mistrium_12 from '../assets/images/game-collection-images/Mistrium_12.webp';
import Mistrium_13 from '../assets/images/game-collection-images/Mistrium_13.webp';
import Mistrium_14 from '../assets/images/game-collection-images/Mistrium_14.webp';
import Mistrium_15 from '../assets/images/game-collection-images/Mistrium_15.webp';
import Mistrium_16 from '../assets/images/game-collection-images/Mistrium_16.webp';
import Spycon_1 from '../assets/images/game-collection-images/Spycon_1.webp';
import Spycon_2 from '../assets/images/game-collection-images/Spycon_2.webp';
import Spycon_3 from '../assets/images/game-collection-images/Spycon_3.webp';
import Spycon_4 from '../assets/images/game-collection-images/Spycon_4.webp';
import Spycon_5 from '../assets/images/game-collection-images/Spycon_5.webp';
import Spycon_6 from '../assets/images/game-collection-images/Spycon_6.webp';
import Spycon_7 from '../assets/images/game-collection-images/Spycon_7.webp';
import Spycon_8 from '../assets/images/game-collection-images/Spycon_8.webp';
import Spycon_9 from '../assets/images/game-collection-images/Spycon_9.webp';
import Spycon_10 from '../assets/images/game-collection-images/Spycon_10.webp';
import Spycon_11 from '../assets/images/game-collection-images/Spycon_11.webp';
import Mortum_1 from '../assets/images/game-collection-images/Mortum_1.webp';
import Mortum_2 from '../assets/images/game-collection-images/Mortum_2.webp';
import Mortum_3 from '../assets/images/game-collection-images/Mortum_3.webp';
import detektivnye_hroniki_flamandskoe_zaveschanie_1 from '../assets/images/game-collection-images/detektivnye_hroniki_flamandskoe_zaveschanie_1.webp';
import detektivnye_hroniki_flamandskoe_zaveschanie_2 from '../assets/images/game-collection-images/detektivnye_hroniki_flamandskoe_zaveschanie_2.webp';
import detektivnye_hroniki_flamandskoe_zaveschanie_3 from '../assets/images/game-collection-images/detektivnye_hroniki_flamandskoe_zaveschanie_3.webp';
import detektivnye_hroniki_flamandskoe_zaveschanie_4 from '../assets/images/game-collection-images/detektivnye_hroniki_flamandskoe_zaveschanie_4.webp';
import detektivnye_hroniki_flamandskoe_zaveschanie_5 from '../assets/images/game-collection-images/detektivnye_hroniki_flamandskoe_zaveschanie_5.webp';
import detektivnye_hroniki_flamandskoe_zaveschanie_6 from '../assets/images/game-collection-images/detektivnye_hroniki_flamandskoe_zaveschanie_6.webp';
import detektivnye_hroniki_flamandskoe_zaveschanie_7 from '../assets/images/game-collection-images/detektivnye_hroniki_flamandskoe_zaveschanie_7.webp';
import detektivnye_hroniki_flamandskoe_zaveschanie_8 from '../assets/images/game-collection-images/detektivnye_hroniki_flamandskoe_zaveschanie_8.webp';
import detektivnye_hroniki_flamandskoe_zaveschanie_9 from '../assets/images/game-collection-images/detektivnye_hroniki_flamandskoe_zaveschanie_9.webp';
import detektivnye_hroniki_flamandskoe_zaveschanie_10 from '../assets/images/game-collection-images/detektivnye_hroniki_flamandskoe_zaveschanie_10.webp';
import smertelnie_materialy_1 from '../assets/images/game-collection-images/smertelnie_materialy_1.webp';
import smertelnie_materialy_2 from '../assets/images/game-collection-images/smertelnie_materialy_2.webp';
import smertelnie_materialy_3 from '../assets/images/game-collection-images/smertelnie_materialy_3.webp';
import smertelnie_materialy_4 from '../assets/images/game-collection-images/smertelnie_materialy_4.webp';
import smertelnie_materialy_5 from '../assets/images/game-collection-images/smertelnie_materialy_5.webp';
import smertelnie_materialy_6 from '../assets/images/game-collection-images/smertelnie_materialy_6.webp';
import smertelnie_materialy_7 from '../assets/images/game-collection-images/smertelnie_materialy_7.webp';
import smertelnie_materialy_8 from '../assets/images/game-collection-images/smertelnie_materialy_8.webp';
import smertelnie_materialy_9 from '../assets/images/game-collection-images/smertelnie_materialy_9.webp';
import smertelnie_materialy_10 from '../assets/images/game-collection-images/smertelnie_materialy_10.webp';
import smertelnie_materialy_11 from '../assets/images/game-collection-images/smertelnie_materialy_11.webp';
import Odnajdi_V_Chikago_1 from '../assets/images/game-collection-images/Odnajdi_V_Chikago_1.webp';
import Odnajdi_V_Chikago_2 from '../assets/images/game-collection-images/Odnajdi_V_Chikago_2.webp';
import Odnajdi_V_Chikago_3 from '../assets/images/game-collection-images/Odnajdi_V_Chikago_3.webp';
import Similo_myths_1 from '../assets/images/game-collection-images/Similo_myths_1.webp';
import Similo_myths_2 from '../assets/images/game-collection-images/Similo_myths_2.webp';
import Similo_myths_3 from '../assets/images/game-collection-images/Similo_myths_3.webp';
import Similo_myths_4 from '../assets/images/game-collection-images/Similo_myths_4.webp';
import Similo_myths_5 from '../assets/images/game-collection-images/Similo_myths_5.webp';
import pochtoviy_yaschik_1 from '../assets/images/game-collection-images/pochtoviy_yaschik_1.webp';
import pochtoviy_yaschik_2 from '../assets/images/game-collection-images/pochtoviy_yaschik_2.webp';
import pochtoviy_yaschik_3 from '../assets/images/game-collection-images/pochtoviy_yaschik_3.webp';
import pochtoviy_yaschik_4 from '../assets/images/game-collection-images/pochtoviy_yaschik_4.webp';
import pochtoviy_yaschik_5 from '../assets/images/game-collection-images/pochtoviy_yaschik_5.webp';
import pochtoviy_yaschik_6 from '../assets/images/game-collection-images/pochtoviy_yaschik_6.webp';
import pochtoviy_yaschik_7 from '../assets/images/game-collection-images/pochtoviy_yaschik_7.webp';
import pochtoviy_yaschik_8 from '../assets/images/game-collection-images/pochtoviy_yaschik_8.webp';
import pochtoviy_yaschik_9 from '../assets/images/game-collection-images/pochtoviy_yaschik_9.webp';
import Mesto_prestuplenia_Prekrasnaya_epokha_1 from '../assets/images/game-collection-images/Mesto_prestuplenia_Prekrasnaya_epokha_1.webp';
import Mesto_prestuplenia_Prekrasnaya_epokha_2 from '../assets/images/game-collection-images/Mesto_prestuplenia_Prekrasnaya_epokha_2.webp';
import Mesto_prestuplenia_Prekrasnaya_epokha_3 from '../assets/images/game-collection-images/Mesto_prestuplenia_Prekrasnaya_epokha_3.webp';
import Mesto_prestuplenia_Prekrasnaya_epokha_4 from '../assets/images/game-collection-images/Mesto_prestuplenia_Prekrasnaya_epokha_4.webp';
import Mesto_prestuplenia_Prekrasnaya_epokha_5 from '../assets/images/game-collection-images/Mesto_prestuplenia_Prekrasnaya_epokha_5.webp';
import Mesto_prestuplenia_Prekrasnaya_epokha_6 from '../assets/images/game-collection-images/Mesto_prestuplenia_Prekrasnaya_epokha_6.webp';
import Mesto_prestuplenia_Prekrasnaya_epokha_7 from '../assets/images/game-collection-images/Mesto_prestuplenia_Prekrasnaya_epokha_7.webp';
import Mesto_prestuplenia_Prekrasnaya_epokha_8 from '../assets/images/game-collection-images/Mesto_prestuplenia_Prekrasnaya_epokha_8.webp';
import Mesto_prestuplenia_Prekrasnaya_epokha_9 from '../assets/images/game-collection-images/Mesto_prestuplenia_Prekrasnaya_epokha_9.webp';
import Uotergate_1 from '../assets/images/game-collection-images/Uotergate_1.webp';
import Uotergate_2 from '../assets/images/game-collection-images/Uotergate_2.webp';
import Uotergate_3 from '../assets/images/game-collection-images/Uotergate_3.webp';
import Uotergate_4 from '../assets/images/game-collection-images/Uotergate_4.webp';
import Uotergate_5 from '../assets/images/game-collection-images/Uotergate_5.webp';
import Venskiy_Svyaznoi_1 from '../assets/images/game-collection-images/Venskiy_Svyaznoi_1.webp';
import Venskiy_Svyaznoi_2 from '../assets/images/game-collection-images/Venskiy_Svyaznoi_2.webp';
import Venskiy_Svyaznoi_3 from '../assets/images/game-collection-images/Venskiy_Svyaznoi_3.webp';
import Venskiy_Svyaznoi_4 from '../assets/images/game-collection-images/Venskiy_Svyaznoi_4.webp';
import Venskiy_Svyaznoi_5 from '../assets/images/game-collection-images/Venskiy_Svyaznoi_5.webp';
import Sledstvie_1 from '../assets/images/game-collection-images/Sledstvie_1.webp';
import Sledstvie_2 from '../assets/images/game-collection-images/Sledstvie_2.webp';
import Sledstvie_3 from '../assets/images/game-collection-images/Sledstvie_3.webp';
import Sledstvie_4 from '../assets/images/game-collection-images/Sledstvie_4.webp';
import Soprotivlenie_1 from '../assets/images/game-collection-images/Soprotivlenie_1.webp';
import Soprotivlenie_2 from '../assets/images/game-collection-images/Soprotivlenie_2.webp';
import Soprotivlenie_3 from '../assets/images/game-collection-images/Soprotivlenie_3.webp';
import Soprotivlenie_4 from '../assets/images/game-collection-images/Soprotivlenie_4.webp';
import Soprotivlenie_5 from '../assets/images/game-collection-images/Soprotivlenie_5.webp';
import Soprotivlenie_6 from '../assets/images/game-collection-images/Soprotivlenie_6.webp';
import Soprotivlenie_7 from '../assets/images/game-collection-images/Soprotivlenie_7.webp';
import Soprotivlenie_8 from '../assets/images/game-collection-images/Soprotivlenie_8.webp';
import Soprotivlenie_9 from '../assets/images/game-collection-images/Soprotivlenie_9.webp';
import Soprotivlenie_10 from '../assets/images/game-collection-images/Soprotivlenie_10.webp';
import Soprotivlenie_11 from '../assets/images/game-collection-images/Soprotivlenie_11.webp';
import Bogy_Olimpa_1 from '../assets/images/game-collection-images/Bogy_Olimpa_1.webp';
import Bogy_Olimpa_2 from '../assets/images/game-collection-images/Bogy_Olimpa_2.webp';
import Bogy_Olimpa_3 from '../assets/images/game-collection-images/Bogy_Olimpa_3.webp';
import Bogy_Olimpa_4 from '../assets/images/game-collection-images/Bogy_Olimpa_4.webp';
import Bogy_Olimpa_5 from '../assets/images/game-collection-images/Bogy_Olimpa_5.webp';
import Bogy_Olimpa_6 from '../assets/images/game-collection-images/Bogy_Olimpa_6.webp';
import Bogy_Olimpa_7 from '../assets/images/game-collection-images/Bogy_Olimpa_7.webp';
import Bogy_Olimpa_8 from '../assets/images/game-collection-images/Bogy_Olimpa_8.webp';
import Bogy_Olimpa_9 from '../assets/images/game-collection-images/Bogy_Olimpa_9.webp';
import Bang_Star_Wars_1 from '../assets/images/game-collection-images/Bang_Star_Wars_1.webp';
import Bang_Star_Wars_2 from '../assets/images/game-collection-images/Bang_Star_Wars_2.webp';
import Bang_Star_Wars_3 from '../assets/images/game-collection-images/Bang_Star_Wars_3.webp';
import Bang_Star_Wars_4 from '../assets/images/game-collection-images/Bang_Star_Wars_4.webp';
import Bang_Star_Wars_5 from '../assets/images/game-collection-images/Bang_Star_Wars_5.webp';
import Bang_Star_Wars_6 from '../assets/images/game-collection-images/Bang_Star_Wars_6.webp';
import Bang_Star_Wars_7 from '../assets/images/game-collection-images/Bang_Star_Wars_7.webp';
import Bang_Star_Wars_8 from '../assets/images/game-collection-images/Bang_Star_Wars_8.webp';
import Bang_Star_Wars_9 from '../assets/images/game-collection-images/Bang_Star_Wars_9.webp';
import Gravity_Falls_Memory_1 from '../assets/images/game-collection-images/Gravity_Falls_Memory_1.webp';
import Gravity_Falls_Memory_2 from '../assets/images/game-collection-images/Gravity_Falls_Memory_2.webp';
import Gravity_Falls_Memory_3 from '../assets/images/game-collection-images/Gravity_Falls_Memory_3.webp';
import krosmaster_arena_1 from '../assets/images/game-collection-images/krosmaster_arena_1.webp';
import krosmaster_arena_2 from '../assets/images/game-collection-images/krosmaster_arena_2.webp';
import krosmaster_arena_3 from '../assets/images/game-collection-images/krosmaster_arena_3.webp';
import krosmaster_arena_4 from '../assets/images/game-collection-images/krosmaster_arena_4.webp';
import krosmaster_arena_5 from '../assets/images/game-collection-images/krosmaster_arena_5.webp';
import krosmaster_arena_6 from '../assets/images/game-collection-images/krosmaster_arena_6.webp';
import krosmaster_arena_7 from '../assets/images/game-collection-images/krosmaster_arena_7.webp';
import krosmaster_arena_8 from '../assets/images/game-collection-images/krosmaster_arena_8.webp';
import krosmaster_arena_9 from '../assets/images/game-collection-images/krosmaster_arena_9.webp';
import krosmaster_arena_10 from '../assets/images/game-collection-images/krosmaster_arena_10.webp';
import krosmaster_arena_11 from '../assets/images/game-collection-images/krosmaster_arena_11.webp';
import krosmaster_arena_12 from '../assets/images/game-collection-images/krosmaster_arena_12.webp';
import krosmaster_arena_13 from '../assets/images/game-collection-images/krosmaster_arena_13.webp';
import Activity_Travel_1 from '../assets/images/game-collection-images/Activity_Travel_1.webp';
import Activity_Travel_2 from '../assets/images/game-collection-images/Activity_Travel_2.webp';
import Activity_Travel_3 from '../assets/images/game-collection-images/Activity_Travel_3.webp';
import Activity_Travel_4 from '../assets/images/game-collection-images/Activity_Travel_4.webp';
import Activity_Travel_5 from '../assets/images/game-collection-images/Activity_Travel_5.webp';
import Activity_Travel_6 from '../assets/images/game-collection-images/Activity_Travel_6.webp';
import Activity_Travel_7 from '../assets/images/game-collection-images/Activity_Travel_7.webp';
import Activity_Travel_8 from '../assets/images/game-collection-images/Activity_Travel_8.webp';
import LotR_journey_in_middle_earth_1 from '../assets/images/game-collection-images/LotR_journey-in-middle-earth_1.webp';
import LotR_journey_in_middle_earth_2 from '../assets/images/game-collection-images/LotR_journey-in-middle-earth_2.webp';
import LotR_journey_in_middle_earth_3 from '../assets/images/game-collection-images/LotR_journey-in-middle-earth_3.webp';
import LotR_journey_in_middle_earth_4 from '../assets/images/game-collection-images/LotR_journey-in-middle-earth_4.webp';
import LotR_journey_in_middle_earth_5 from '../assets/images/game-collection-images/LotR_journey-in-middle-earth_5.webp';
import LotR_journey_in_middle_earth_6 from '../assets/images/game-collection-images/LotR_journey-in-middle-earth_6.webp';
import LotR_journey_in_middle_earth_7 from '../assets/images/game-collection-images/LotR_journey-in-middle-earth_7.webp';
import LotR_journey_in_middle_earth_8 from '../assets/images/game-collection-images/LotR_journey-in-middle-earth_8.webp';
import LotR_journey_in_middle_earth_9 from '../assets/images/game-collection-images/LotR_journey-in-middle-earth_9.webp';
import LotR_journey_in_middle_earth_10 from '../assets/images/game-collection-images/LotR_journey-in-middle-earth_10.webp';
import LotR_journey_in_middle_earth_11 from '../assets/images/game-collection-images/LotR_journey-in-middle-earth_11.webp';
import descent_legends_of_the_dark_1 from '../assets/images/game-collection-images/descent_legends_of_the_dark_1.webp';
import descent_legends_of_the_dark_2 from '../assets/images/game-collection-images/descent_legends_of_the_dark_2.webp';
import descent_legends_of_the_dark_3 from '../assets/images/game-collection-images/descent_legends_of_the_dark_3.webp';
import descent_legends_of_the_dark_4 from '../assets/images/game-collection-images/descent_legends_of_the_dark_4.webp';
import descent_legends_of_the_dark_5 from '../assets/images/game-collection-images/descent_legends_of_the_dark_5.webp';
import Mansions_of_Madness_box_1 from '../assets/images/game-collection-images/Mansions-of-Madness_box_1.webp';
import Mansions_of_Madness_box_2 from '../assets/images/game-collection-images/Mansions-of-Madness_box_2.webp';
import Mansions_of_Madness_box_3 from '../assets/images/game-collection-images/Mansions-of-Madness_box_3.webp';
import Mansions_of_Madness_box_4 from '../assets/images/game-collection-images/Mansions-of-Madness_box_4.webp';
import Mansions_of_Madness_box_5 from '../assets/images/game-collection-images/Mansions-of-Madness_box_5.webp';
import Zombicide_2ed_1 from '../assets/images/game-collection-images/Zombicide_2ed_1.webp';
import Zombicide_2ed_2 from '../assets/images/game-collection-images/Zombicide_2ed_2.webp';
import Zombicide_2ed_3 from '../assets/images/game-collection-images/Zombicide_2ed_3.webp';
import Zombicide_2ed_4 from '../assets/images/game-collection-images/Zombicide_2ed_4.webp';
import Zombicide_2ed_5 from '../assets/images/game-collection-images/Zombicide_2ed_5.webp';
import Pathfinder_CG_base_1 from '../assets/images/game-collection-images/Pathfinder_CG_base_1.webp';
import Pathfinder_CG_base_2 from '../assets/images/game-collection-images/Pathfinder_CG_base_2.webp';
import Pathfinder_CG_base_3 from '../assets/images/game-collection-images/Pathfinder_CG_base_3.webp';
import Pathfinder_CG_base_4 from '../assets/images/game-collection-images/Pathfinder_CG_base_4.webp';
import Pathfinder_CG_base_5 from '../assets/images/game-collection-images/Pathfinder_CG_base_5.webp';
import Pathfinder_CG_base_6 from '../assets/images/game-collection-images/Pathfinder_CG_base_6.webp';
import Pathfinder_CG_base_7 from '../assets/images/game-collection-images/Pathfinder_CG_base_7.webp';
import Pathfinder_CG_base_8 from '../assets/images/game-collection-images/Pathfinder_CG_base_8.webp';
import Pathfinder_CG_base_9 from '../assets/images/game-collection-images/Pathfinder_CG_base_9.webp';
import Pathfinder_CG_base_10 from '../assets/images/game-collection-images/Pathfinder_CG_base_10.webp';
import Pathfinder_CG_base_11 from '../assets/images/game-collection-images/Pathfinder_CG_base_11.webp';
import Pathfinder_CG_base_12 from '../assets/images/game-collection-images/Pathfinder_CG_base_12.webp';
import Pathfinder_CG_base_13 from '../assets/images/game-collection-images/Pathfinder_CG_base_13.webp';
import Pathfinder_CG_base_14 from '../assets/images/game-collection-images/Pathfinder_CG_base_14.webp';
import Zomby_V_Dome_Zarajenie_1 from '../assets/images/game-collection-images/Zomby_V_Dome_Zarajenie_1.webp';
import Zomby_V_Dome_Zarajenie_2 from '../assets/images/game-collection-images/Zomby_V_Dome_Zarajenie_2.webp';
import Zomby_V_Dome_Zarajenie_3 from '../assets/images/game-collection-images/Zomby_V_Dome_Zarajenie_3.webp';
import Zomby_V_Dome_Zarajenie_4 from '../assets/images/game-collection-images/Zomby_V_Dome_Zarajenie_4.webp';
import Zomby_V_Dome_Zarajenie_5 from '../assets/images/game-collection-images/Zomby_V_Dome_Zarajenie_5.webp';
import Zomby_V_Dome_Zarajenie_6 from '../assets/images/game-collection-images/Zomby_V_Dome_Zarajenie_6.webp';
import Zomby_V_Dome_Zarajenie_7 from '../assets/images/game-collection-images/Zomby_V_Dome_Zarajenie_7.webp';
import Zomby_V_Dome_Zarajenie_8 from '../assets/images/game-collection-images/Zomby_V_Dome_Zarajenie_8.webp';
import Zomby_V_Dome_Zarajenie_9 from '../assets/images/game-collection-images/Zomby_V_Dome_Zarajenie_9.webp';
import Zomby_V_Dome_Zarajenie_10 from '../assets/images/game-collection-images/Zomby_V_Dome_Zarajenie_10.webp';
import Zomby_V_Dome_Zarajenie_11 from '../assets/images/game-collection-images/Zomby_V_Dome_Zarajenie_11.webp';
import Ostrov_duhov_1 from '../assets/images/game-collection-images/Ostrov_duhov_1.webp';
import Ostrov_duhov_2 from '../assets/images/game-collection-images/Ostrov_duhov_2.webp';
import Ostrov_duhov_3 from '../assets/images/game-collection-images/Ostrov_duhov_3.webp';
import Ostrov_duhov_4 from '../assets/images/game-collection-images/Ostrov_duhov_4.webp';
import Mor_Utopia_1 from '../assets/images/game-collection-images/Mor_Utopia_1.webp';
import Mor_Utopia_2 from '../assets/images/game-collection-images/Mor_Utopia_2.webp';
import Mor_Utopia_3 from '../assets/images/game-collection-images/Mor_Utopia_3.webp';
import Mor_Utopia_4 from '../assets/images/game-collection-images/Mor_Utopia_4.webp';
import Mor_Utopia_5 from '../assets/images/game-collection-images/Mor_Utopia_5.webp';
import Mor_Utopia_6 from '../assets/images/game-collection-images/Mor_Utopia_6.webp';
import Mor_Utopia_7 from '../assets/images/game-collection-images/Mor_Utopia_7.webp';
import Mor_Utopia_8 from '../assets/images/game-collection-images/Mor_Utopia_8.webp';
import Mor_Utopia_9 from '../assets/images/game-collection-images/Mor_Utopia_9.webp';
import Mor_Utopia_10 from '../assets/images/game-collection-images/Mor_Utopia_10.webp';
import Mor_Utopia_11 from '../assets/images/game-collection-images/Mor_Utopia_11.webp';
import Mor_Utopia_12 from '../assets/images/game-collection-images/Mor_Utopia_12.webp';
import Mor_Utopia_13 from '../assets/images/game-collection-images/Mor_Utopia_13.webp';
import Robinzon_Kruzo_Vtoraya_Redakciya_1 from '../assets/images/game-collection-images/Robinzon_Kruzo_Vtoraya_Redakciya_1.webp';
import Robinzon_Kruzo_Vtoraya_Redakciya_2 from '../assets/images/game-collection-images/Robinzon_Kruzo_Vtoraya_Redakciya_2.webp';
import Robinzon_Kruzo_Vtoraya_Redakciya_3 from '../assets/images/game-collection-images/Robinzon_Kruzo_Vtoraya_Redakciya_3.webp';
import Robinzon_Kruzo_Vtoraya_Redakciya_4 from '../assets/images/game-collection-images/Robinzon_Kruzo_Vtoraya_Redakciya_4.webp';
import Robinzon_Kruzo_Vtoraya_Redakciya_5 from '../assets/images/game-collection-images/Robinzon_Kruzo_Vtoraya_Redakciya_5.webp';
import Robinzon_Kruzo_Vtoraya_Redakciya_6 from '../assets/images/game-collection-images/Robinzon_Kruzo_Vtoraya_Redakciya_6.webp';
import Robinzon_Kruzo_Vtoraya_Redakciya_7 from '../assets/images/game-collection-images/Robinzon_Kruzo_Vtoraya_Redakciya_7.webp';
import Robinzon_Kruzo_Vtoraya_Redakciya_8 from '../assets/images/game-collection-images/Robinzon_Kruzo_Vtoraya_Redakciya_8.webp';
import Robinzon_Kruzo_Vtoraya_Redakciya_9 from '../assets/images/game-collection-images/Robinzon_Kruzo_Vtoraya_Redakciya_9.webp';
import Robinzon_Kruzo_Vtoraya_Redakciya_10 from '../assets/images/game-collection-images/Robinzon_Kruzo_Vtoraya_Redakciya_10.webp';
import Robinzon_Kruzo_Vtoraya_Redakciya_11 from '../assets/images/game-collection-images/Robinzon_Kruzo_Vtoraya_Redakciya_11.webp';
import Fallout_Atomic_Bonds_1 from '../assets/images/game-collection-images/Fallout_Atomic-Bonds_1.webp';
import Fallout_Atomic_Bonds_2 from '../assets/images/game-collection-images/Fallout_Atomic-Bonds_2.webp';
import Fallout_Atomic_Bonds_3 from '../assets/images/game-collection-images/Fallout_Atomic-Bonds_3.webp';
import Fallout_Atomic_Bonds_4 from '../assets/images/game-collection-images/Fallout_Atomic-Bonds_4.webp';
import Fallout_Atomic_Bonds_5 from '../assets/images/game-collection-images/Fallout_Atomic-Bonds_5.webp';
import Fallout_Atomic_Bonds_6 from '../assets/images/game-collection-images/Fallout_Atomic-Bonds_6.webp';
import Fallout_Atomic_Bonds_7 from '../assets/images/game-collection-images/Fallout_Atomic-Bonds_7.webp';
import Nemesida_Voidseeders_1 from '../assets/images/game-collection-images/Nemesida_Voidseeders_1.webp';
import Nemesida_Voidseeders_2 from '../assets/images/game-collection-images/Nemesida_Voidseeders_2.webp';
import Nemesida_Voidseeders_3 from '../assets/images/game-collection-images/Nemesida_Voidseeders_3.webp';
import Nemesida_Voidseeders_4 from '../assets/images/game-collection-images/Nemesida_Voidseeders_4.webp';
import Nemesida_Voidseeders_5 from '../assets/images/game-collection-images/Nemesida_Voidseeders_5.webp';
import Nemesida_Voidseeders_6 from '../assets/images/game-collection-images/Nemesida_Voidseeders_6.webp';
import Nemesida_Voidseeders_7 from '../assets/images/game-collection-images/Nemesida_Voidseeders_7.webp';
import Nemesida_Voidseeders_8 from '../assets/images/game-collection-images/Nemesida_Voidseeders_8.webp';
import Chujaya_Planeta_1 from '../assets/images/game-collection-images/Chujaya_Planeta_1.webp';
import Chujaya_Planeta_2 from '../assets/images/game-collection-images/Chujaya_Planeta_2.webp';
import Chujaya_Planeta_3 from '../assets/images/game-collection-images/Chujaya_Planeta_3.webp';
import Chujaya_Planeta_4 from '../assets/images/game-collection-images/Chujaya_Planeta_4.webp';
import Chujaya_Planeta_5 from '../assets/images/game-collection-images/Chujaya_Planeta_5.webp';
import Chujaya_Planeta_6 from '../assets/images/game-collection-images/Chujaya_Planeta_6.webp';
import Chujaya_Planeta_7 from '../assets/images/game-collection-images/Chujaya_Planeta_7.webp';
import Chujaya_Planeta_8 from '../assets/images/game-collection-images/Chujaya_Planeta_8.webp';
import Chujaya_Planeta_9 from '../assets/images/game-collection-images/Chujaya_Planeta_9.webp';
import Chujaya_Planeta_10 from '../assets/images/game-collection-images/Chujaya_Planeta_10.webp';
import Pandemic_1 from '../assets/images/game-collection-images/Pandemic_1.webp';
import Pandemic_2 from '../assets/images/game-collection-images/Pandemic_2.webp';
import Pandemic_3 from '../assets/images/game-collection-images/Pandemic_3.webp';
import Pandemic_4 from '../assets/images/game-collection-images/Pandemic_4.webp';
import Pandemic_5 from '../assets/images/game-collection-images/Pandemic_5.webp';
import Pandemic_6 from '../assets/images/game-collection-images/Pandemic_6.webp';
import Pandemic_7 from '../assets/images/game-collection-images/Pandemic_7.webp';
import Pandemic_8 from '../assets/images/game-collection-images/Pandemic_8.webp';
import Pandemic_9 from '../assets/images/game-collection-images/Pandemic_9.webp';
import Pandemic_10 from '../assets/images/game-collection-images/Pandemic_10.webp';
import enciklopediya_1 from '../assets/images/game-collection-images/enciklopediya_1.webp';
import enciklopediya_2 from '../assets/images/game-collection-images/enciklopediya_2.webp';
import enciklopediya_3 from '../assets/images/game-collection-images/enciklopediya_3.webp';
import enciklopediya_4 from '../assets/images/game-collection-images/enciklopediya_4.webp';
import enciklopediya_5 from '../assets/images/game-collection-images/enciklopediya_5.webp';
import enciklopediya_6 from '../assets/images/game-collection-images/enciklopediya_6.webp';
import enciklopediya_7 from '../assets/images/game-collection-images/enciklopediya_7.webp';
import enciklopediya_8 from '../assets/images/game-collection-images/enciklopediya_8.webp';
import enciklopediya_9 from '../assets/images/game-collection-images/enciklopediya_9.webp';
import enciklopediya_10 from '../assets/images/game-collection-images/enciklopediya_10.webp';
import enciklopediya_11 from '../assets/images/game-collection-images/enciklopediya_11.webp';
import enciklopediya_12 from '../assets/images/game-collection-images/enciklopediya_12.webp';
import enciklopediya_13 from '../assets/images/game-collection-images/enciklopediya_13.webp';
import enciklopediya_14 from '../assets/images/game-collection-images/enciklopediya_14.webp';
import kosmicheskiy_desant_komix_igra_1 from '../assets/images/game-collection-images/kosmicheskiy_desant_komix_igra_1.webp';
import kosmicheskiy_desant_komix_igra_2 from '../assets/images/game-collection-images/kosmicheskiy_desant_komix_igra_2.webp';
import kosmicheskiy_desant_komix_igra_3 from '../assets/images/game-collection-images/kosmicheskiy_desant_komix_igra_3.webp';
import kosmicheskiy_desant_komix_igra_4 from '../assets/images/game-collection-images/kosmicheskiy_desant_komix_igra_4.webp';
import SWOuterRim_1 from '../assets/images/game-collection-images/SWOuterRim_1.webp';
import SWOuterRim_2 from '../assets/images/game-collection-images/SWOuterRim_2.webp';
import SWOuterRim_3 from '../assets/images/game-collection-images/SWOuterRim_3.webp';
import SWOuterRim_4 from '../assets/images/game-collection-images/SWOuterRim_4.webp';
import SWOuterRim_5 from '../assets/images/game-collection-images/SWOuterRim_5.webp';
import SWOuterRim_6 from '../assets/images/game-collection-images/SWOuterRim_6.webp';
import SWOuterRim_7 from '../assets/images/game-collection-images/SWOuterRim_7.webp';
import SWOuterRim_8 from '../assets/images/game-collection-images/SWOuterRim_8.webp';
import SWOuterRim_9 from '../assets/images/game-collection-images/SWOuterRim_9.webp';
import SWOuterRim_10 from '../assets/images/game-collection-images/SWOuterRim_10.webp';
import Runebound_1 from '../assets/images/game-collection-images/Runebound_1.webp';
import Runebound_2 from '../assets/images/game-collection-images/Runebound_2.webp';
import Runebound_3 from '../assets/images/game-collection-images/Runebound_3.webp';
import Runebound_4 from '../assets/images/game-collection-images/Runebound_4.webp';
import Runebound_5 from '../assets/images/game-collection-images/Runebound_5.webp';
import Runebound_6 from '../assets/images/game-collection-images/Runebound_6.webp';
import Runebound_7 from '../assets/images/game-collection-images/Runebound_7.webp';
import Runebound_8 from '../assets/images/game-collection-images/Runebound_8.webp';
import Runebound_9 from '../assets/images/game-collection-images/Runebound_9.webp';
import Runebound_10 from '../assets/images/game-collection-images/Runebound_10.webp';
import Jakal_1 from '../assets/images/game-collection-images/Jakal_1.webp';
import Jakal_2 from '../assets/images/game-collection-images/Jakal_2.webp';
import Jakal_3 from '../assets/images/game-collection-images/Jakal_3.webp';
import voyny_chyornoy_rozy_preispodnyaya_1 from '../assets/images/game-collection-images/voyny_chyornoy_rozy_preispodnyaya_1.webp';
import voyny_chyornoy_rozy_preispodnyaya_2 from '../assets/images/game-collection-images/voyny_chyornoy_rozy_preispodnyaya_2.webp';
import voyny_chyornoy_rozy_preispodnyaya_3 from '../assets/images/game-collection-images/voyny_chyornoy_rozy_preispodnyaya_3.webp';
import voyny_chyornoy_rozy_preispodnyaya_4 from '../assets/images/game-collection-images/voyny_chyornoy_rozy_preispodnyaya_4.webp';
import voyny_chyornoy_rozy_preispodnyaya_5 from '../assets/images/game-collection-images/voyny_chyornoy_rozy_preispodnyaya_5.webp';
import voyny_chyornoy_rozy_preispodnyaya_6 from '../assets/images/game-collection-images/voyny_chyornoy_rozy_preispodnyaya_6.webp';
import voyny_chyornoy_rozy_preispodnyaya_7 from '../assets/images/game-collection-images/voyny_chyornoy_rozy_preispodnyaya_7.webp';
import voyny_chyornoy_rozy_preispodnyaya_8 from '../assets/images/game-collection-images/voyny_chyornoy_rozy_preispodnyaya_8.webp';
import voyny_chyornoy_rozy_preispodnyaya_9 from '../assets/images/game-collection-images/voyny_chyornoy_rozy_preispodnyaya_9.webp';
import voyny_chyornoy_rozy_preispodnyaya_10 from '../assets/images/game-collection-images/voyny_chyornoy_rozy_preispodnyaya_10.webp';
import voyny_chyornoy_rozy_preispodnyaya_11 from '../assets/images/game-collection-images/voyny_chyornoy_rozy_preispodnyaya_11.webp';
import voyny_chyornoy_rozy_preispodnyaya_12 from '../assets/images/game-collection-images/voyny_chyornoy_rozy_preispodnyaya_12.webp';
import voyny_chyornoy_rozy_preispodnyaya_13 from '../assets/images/game-collection-images/voyny_chyornoy_rozy_preispodnyaya_13.webp';
import voyny_chyornoy_rozy_preispodnyaya_14 from '../assets/images/game-collection-images/voyny_chyornoy_rozy_preispodnyaya_14.webp';
import voyny_chyornoy_rozy_preispodnyaya_15 from '../assets/images/game-collection-images/voyny_chyornoy_rozy_preispodnyaya_15.webp';
import Zapret_ostr_1 from '../assets/images/game-collection-images/Zapret_ostr_1.webp';
import Zapret_ostr_2 from '../assets/images/game-collection-images/Zapret_ostr_2.webp';
import Zapret_ostr_3 from '../assets/images/game-collection-images/Zapret_ostr_3.webp';
import Zapret_ostr_4 from '../assets/images/game-collection-images/Zapret_ostr_4.webp';
import Zapret_ostr_5 from '../assets/images/game-collection-images/Zapret_ostr_5.webp';
import Zapret_ostr_6 from '../assets/images/game-collection-images/Zapret_ostr_6.webp';
import Zapret_ostr_7 from '../assets/images/game-collection-images/Zapret_ostr_7.webp';
import Zapret_ostr_8 from '../assets/images/game-collection-images/Zapret_ostr_8.webp';
import Zapret_ostr_9 from '../assets/images/game-collection-images/Zapret_ostr_9.webp';
import Zapret_ostr_10 from '../assets/images/game-collection-images/Zapret_ostr_10.webp';
import Dungeons_1 from '../assets/images/game-collection-images/Dungeons_1.webp';
import Dungeons_2 from '../assets/images/game-collection-images/Dungeons_2.webp';
import Dungeons_3 from '../assets/images/game-collection-images/Dungeons_3.webp';
import Dungeons_4 from '../assets/images/game-collection-images/Dungeons_4.webp';
import Dungeons_5 from '../assets/images/game-collection-images/Dungeons_5.webp';
import Dungeons_6 from '../assets/images/game-collection-images/Dungeons_6.webp';
import Dungeons_7 from '../assets/images/game-collection-images/Dungeons_7.webp';
import Dungeons_8 from '../assets/images/game-collection-images/Dungeons_8.webp';
import Dungeons_9 from '../assets/images/game-collection-images/Dungeons_9.webp';
import Dungeons_10 from '../assets/images/game-collection-images/Dungeons_10.webp';
import oltre_1 from '../assets/images/game-collection-images/oltre_1.webp';
import oltre_2 from '../assets/images/game-collection-images/oltre_2.webp';
import oltre_3 from '../assets/images/game-collection-images/oltre_3.webp';
import oltre_4 from '../assets/images/game-collection-images/oltre_4.webp';
import oltre_5 from '../assets/images/game-collection-images/oltre_5.webp';
import oltre_6 from '../assets/images/game-collection-images/oltre_6.webp';
import oltre_7 from '../assets/images/game-collection-images/oltre_7.webp';
import oltre_8 from '../assets/images/game-collection-images/oltre_8.webp';
import oltre_9 from '../assets/images/game-collection-images/oltre_9.webp';
import oltre_10 from '../assets/images/game-collection-images/oltre_10.webp';
import oltre_11 from '../assets/images/game-collection-images/oltre_11.webp';
import oltre_12 from '../assets/images/game-collection-images/oltre_12.webp';
import oltre_13 from '../assets/images/game-collection-images/oltre_13.webp';
import oltre_14 from '../assets/images/game-collection-images/oltre_14.webp';
import vechnaya_zima_1 from '../assets/images/game-collection-images/vechnaya_zima_1.webp';
import vechnaya_zima_2 from '../assets/images/game-collection-images/vechnaya_zima_2.webp';
import vechnaya_zima_3 from '../assets/images/game-collection-images/vechnaya_zima_3.webp';
import vechnaya_zima_4 from '../assets/images/game-collection-images/vechnaya_zima_4.webp';
import vechnaya_zima_5 from '../assets/images/game-collection-images/vechnaya_zima_5.webp';
import vechnaya_zima_6 from '../assets/images/game-collection-images/vechnaya_zima_6.webp';
import vechnaya_zima_7 from '../assets/images/game-collection-images/vechnaya_zima_7.webp';
import vechnaya_zima_8 from '../assets/images/game-collection-images/vechnaya_zima_8.webp';
import vechnaya_zima_9 from '../assets/images/game-collection-images/vechnaya_zima_9.webp';
import vechnaya_zima_10 from '../assets/images/game-collection-images/vechnaya_zima_10.webp';
import vechnaya_zima_11 from '../assets/images/game-collection-images/vechnaya_zima_11.webp';
import vechnaya_zima_12 from '../assets/images/game-collection-images/vechnaya_zima_12.webp';
import Arnaks_1 from '../assets/images/game-collection-images/Arnaks_1.webp';
import Arnaks_2 from '../assets/images/game-collection-images/Arnaks_2.webp';
import Arnaks_3 from '../assets/images/game-collection-images/Arnaks_3.webp';
import Arnaks_4 from '../assets/images/game-collection-images/Arnaks_4.webp';
import Arnaks_5 from '../assets/images/game-collection-images/Arnaks_5.webp';
import Arnaks_6 from '../assets/images/game-collection-images/Arnaks_6.webp';
import Talisman_1 from '../assets/images/game-collection-images/Talisman_1.webp';
import Talisman_2 from '../assets/images/game-collection-images/Talisman_2.webp';
import Talisman_3 from '../assets/images/game-collection-images/Talisman_3.webp';
import Talisman_4 from '../assets/images/game-collection-images/Talisman_4.webp';
import Talisman_5 from '../assets/images/game-collection-images/Talisman_5.webp';
import Talisman_6 from '../assets/images/game-collection-images/Talisman_6.webp';
import Talisman_7 from '../assets/images/game-collection-images/Talisman_7.webp';
import Oboroten_1 from '../assets/images/game-collection-images/Oboroten_1.webp';
import Oboroten_2 from '../assets/images/game-collection-images/Oboroten_2.webp';
import Oboroten_3 from '../assets/images/game-collection-images/Oboroten_3.webp';
import Oboroten_4 from '../assets/images/game-collection-images/Oboroten_4.webp';
import Oboroten_5 from '../assets/images/game-collection-images/Oboroten_5.webp';
import enciklopediya_bolshoe_puteshestvie_1 from '../assets/images/game-collection-images/enciklopediya_bolshoe_puteshestvie_1.webp';
import enciklopediya_bolshoe_puteshestvie_2 from '../assets/images/game-collection-images/enciklopediya_bolshoe_puteshestvie_2.webp';
import enciklopediya_bolshoe_puteshestvie_3 from '../assets/images/game-collection-images/enciklopediya_bolshoe_puteshestvie_3.webp';
import enciklopediya_bolshoe_puteshestvie_4 from '../assets/images/game-collection-images/enciklopediya_bolshoe_puteshestvie_4.webp';
import enciklopediya_bolshoe_puteshestvie_5 from '../assets/images/game-collection-images/enciklopediya_bolshoe_puteshestvie_5.webp';
import enciklopediya_bolshoe_puteshestvie_6 from '../assets/images/game-collection-images/enciklopediya_bolshoe_puteshestvie_6.webp';
import enciklopediya_bolshoe_puteshestvie_7 from '../assets/images/game-collection-images/enciklopediya_bolshoe_puteshestvie_7.webp';
import enciklopediya_bolshoe_puteshestvie_8 from '../assets/images/game-collection-images/enciklopediya_bolshoe_puteshestvie_8.webp';
import enciklopediya_bolshoe_puteshestvie_9 from '../assets/images/game-collection-images/enciklopediya_bolshoe_puteshestvie_9.webp';
import enciklopediya_bolshoe_puteshestvie_10 from '../assets/images/game-collection-images/enciklopediya_bolshoe_puteshestvie_10.webp';
import enciklopediya_bolshoe_puteshestvie_11 from '../assets/images/game-collection-images/enciklopediya_bolshoe_puteshestvie_11.webp';
import Hellboy_1 from '../assets/images/game-collection-images/Hellboy_1.webp';
import Hellboy_2 from '../assets/images/game-collection-images/Hellboy_2.webp';
import Hellboy_3 from '../assets/images/game-collection-images/Hellboy_3.webp';
import Hellboy_4 from '../assets/images/game-collection-images/Hellboy_4.webp';
import Hellboy_5 from '../assets/images/game-collection-images/Hellboy_5.webp';
import Hellboy_6 from '../assets/images/game-collection-images/Hellboy_6.webp';
import Hellboy_7 from '../assets/images/game-collection-images/Hellboy_7.webp';
import Hellboy_8 from '../assets/images/game-collection-images/Hellboy_8.webp';
import Shakal_Archipelag_1 from '../assets/images/game-collection-images/Shakal_Archipelag_1.webp';
import Shakal_Archipelag_2 from '../assets/images/game-collection-images/Shakal_Archipelag_2.webp';
import Shakal_Archipelag_3 from '../assets/images/game-collection-images/Shakal_Archipelag_3.webp';
import Shakal_Archipelag_4 from '../assets/images/game-collection-images/Shakal_Archipelag_4.webp';
import Shakal_Archipelag_5 from '../assets/images/game-collection-images/Shakal_Archipelag_5.webp';
import Shakal_Archipelag_6 from '../assets/images/game-collection-images/Shakal_Archipelag_6.webp';
import Shakal_Archipelag_7 from '../assets/images/game-collection-images/Shakal_Archipelag_7.webp';
import Shakal_Archipelag_8 from '../assets/images/game-collection-images/Shakal_Archipelag_8.webp';
import Shakal_Archipelag_9 from '../assets/images/game-collection-images/Shakal_Archipelag_9.webp';
import Shakal_Archipelag_10 from '../assets/images/game-collection-images/Shakal_Archipelag_10.webp';
import epoha_oblakov_1 from '../assets/images/game-collection-images/epoha_oblakov_1.webp';
import epoha_oblakov_2 from '../assets/images/game-collection-images/epoha_oblakov_2.webp';
import epoha_oblakov_3 from '../assets/images/game-collection-images/epoha_oblakov_3.webp';
import epoha_oblakov_4 from '../assets/images/game-collection-images/epoha_oblakov_4.webp';
import epoha_oblakov_5 from '../assets/images/game-collection-images/epoha_oblakov_5.webp';
import epoha_oblakov_6 from '../assets/images/game-collection-images/epoha_oblakov_6.webp';
import epoha_oblakov_7 from '../assets/images/game-collection-images/epoha_oblakov_7.webp';
import Paleo_NB_1 from '../assets/images/game-collection-images/Paleo_NB_1.webp';
import Paleo_NB_2 from '../assets/images/game-collection-images/Paleo_NB_2.webp';
import Paleo_NB_3 from '../assets/images/game-collection-images/Paleo_NB_3.webp';
import Paleo_NB_4 from '../assets/images/game-collection-images/Paleo_NB_4.webp';
import istoriya_ricarya_1 from '../assets/images/game-collection-images/istoriya_ricarya_1.webp';
import istoriya_ricarya_2 from '../assets/images/game-collection-images/istoriya_ricarya_2.webp';
import istoriya_ricarya_3 from '../assets/images/game-collection-images/istoriya_ricarya_3.webp';
import istoriya_ricarya_4 from '../assets/images/game-collection-images/istoriya_ricarya_4.webp';
import istoriya_ricarya_5 from '../assets/images/game-collection-images/istoriya_ricarya_5.webp';
import istoriya_ricarya_6 from '../assets/images/game-collection-images/istoriya_ricarya_6.webp';
import istoriya_ricarya_7 from '../assets/images/game-collection-images/istoriya_ricarya_7.webp';
import Ticket_to_Ride_Europe_1 from '../assets/images/game-collection-images/Ticket-to-Ride_Europe_1.webp';
import Ticket_to_Ride_Europe_2 from '../assets/images/game-collection-images/Ticket-to-Ride_Europe_2.webp';
import Ticket_to_Ride_Europe_3 from '../assets/images/game-collection-images/Ticket-to-Ride_Europe_3.webp';
import Ticket_to_Ride_Europe_4 from '../assets/images/game-collection-images/Ticket-to-Ride_Europe_4.webp';
import Ticket_to_Ride_Europe_5 from '../assets/images/game-collection-images/Ticket-to-Ride_Europe_5.webp';
import Ticket_to_Ride_Europe_6 from '../assets/images/game-collection-images/Ticket-to-Ride_Europe_6.webp';
import Ticket_to_Ride_Europe_7 from '../assets/images/game-collection-images/Ticket-to-Ride_Europe_7.webp';
import Ticket_to_Ride_Europe_8 from '../assets/images/game-collection-images/Ticket-to-Ride_Europe_8.webp';
import bitva_za_rokugan_1 from '../assets/images/game-collection-images/bitva-za-rokugan_1.webp';
import bitva_za_rokugan_2 from '../assets/images/game-collection-images/bitva-za-rokugan_2.webp';
import bitva_za_rokugan_3 from '../assets/images/game-collection-images/bitva-za-rokugan_3.webp';
import bitva_za_rokugan_4 from '../assets/images/game-collection-images/bitva-za-rokugan_4.webp';
import bitva_za_rokugan_5 from '../assets/images/game-collection-images/bitva-za-rokugan_5.webp';
import bitva_za_rokugan_6 from '../assets/images/game-collection-images/bitva-za-rokugan_6.webp';
import bitva_za_rokugan_7 from '../assets/images/game-collection-images/bitva-za-rokugan_7.webp';
import bitva_za_rokugan_8 from '../assets/images/game-collection-images/bitva-za-rokugan_8.webp';
import gameOfThrones_1 from '../assets/images/game-collection-images/gameOfThrones_1.webp';
import gameOfThrones_2 from '../assets/images/game-collection-images/gameOfThrones_2.webp';
import gameOfThrones_3 from '../assets/images/game-collection-images/gameOfThrones_3.webp';
import gameOfThrones_4 from '../assets/images/game-collection-images/gameOfThrones_4.webp';
import gameOfThrones_5 from '../assets/images/game-collection-images/gameOfThrones_5.webp';
import gameOfThrones_6 from '../assets/images/game-collection-images/gameOfThrones_6.webp';
import gameOfThrones_7 from '../assets/images/game-collection-images/gameOfThrones_7.webp';
import gameOfThrones_8 from '../assets/images/game-collection-images/gameOfThrones_8.webp';
import gameOfThrones_9 from '../assets/images/game-collection-images/gameOfThrones_9.webp';
import gameOfThrones_10 from '../assets/images/game-collection-images/gameOfThrones_10.webp';
import gameOfThrones_11 from '../assets/images/game-collection-images/gameOfThrones_11.webp';
import Ehverdell_1 from '../assets/images/game-collection-images/Ehverdell_1.webp';
import Ehverdell_2 from '../assets/images/game-collection-images/Ehverdell_2.webp';
import Ehverdell_3 from '../assets/images/game-collection-images/Ehverdell_3.webp';
import Ehverdell_4 from '../assets/images/game-collection-images/Ehverdell_4.webp';
import Ehverdell_5 from '../assets/images/game-collection-images/Ehverdell_5.webp';
import Ehverdell_6 from '../assets/images/game-collection-images/Ehverdell_6.webp';
import Ehverdell_7 from '../assets/images/game-collection-images/Ehverdell_7.webp';
import Ehverdell_8 from '../assets/images/game-collection-images/Ehverdell_8.webp';
import Ehverdell_9 from '../assets/images/game-collection-images/Ehverdell_9.webp';
import Ehverdell_10 from '../assets/images/game-collection-images/Ehverdell_10.webp';
import Small_World_1 from '../assets/images/game-collection-images/Small-World_1.webp';
import Small_World_2 from '../assets/images/game-collection-images/Small-World_2.webp';
import Small_World_3 from '../assets/images/game-collection-images/Small-World_3.webp';
import Small_World_4 from '../assets/images/game-collection-images/Small-World_4.webp';
import Small_World_5 from '../assets/images/game-collection-images/Small-World_5.webp';
import Small_World_6 from '../assets/images/game-collection-images/Small-World_6.webp';
import Small_World_7 from '../assets/images/game-collection-images/Small-World_7.webp';
import Small_World_8 from '../assets/images/game-collection-images/Small-World_8.webp';
import Small_World_9 from '../assets/images/game-collection-images/Small-World_9.webp';
import Small_World_10 from '../assets/images/game-collection-images/Small-World_10.webp';
import Small_World_11 from '../assets/images/game-collection-images/Small-World_11.webp';
import Small_World_12 from '../assets/images/game-collection-images/Small-World_12.webp';
import bitoku_1 from '../assets/images/game-collection-images/bitoku_1.webp';
import bitoku_2 from '../assets/images/game-collection-images/bitoku_2.webp';
import bitoku_3 from '../assets/images/game-collection-images/bitoku_3.webp';
import bitoku_4 from '../assets/images/game-collection-images/bitoku_4.webp';
import bitoku_5 from '../assets/images/game-collection-images/bitoku_5.webp';
import bitoku_6 from '../assets/images/game-collection-images/bitoku_6.webp';
import bitoku_7 from '../assets/images/game-collection-images/bitoku_7.webp';
import bitoku_8 from '../assets/images/game-collection-images/bitoku_8.webp';
import bitoku_9 from '../assets/images/game-collection-images/bitoku_9.webp';
import bitoku_10 from '../assets/images/game-collection-images/bitoku_10.webp';
import bitoku_11 from '../assets/images/game-collection-images/bitoku_11.webp';
import bitoku_12 from '../assets/images/game-collection-images/bitoku_12.webp';
import bitoku_13 from '../assets/images/game-collection-images/bitoku_13.webp';
import bitoku_14 from '../assets/images/game-collection-images/bitoku_14.webp';
import bitoku_15 from '../assets/images/game-collection-images/bitoku_15.webp';
import bitoku_16 from '../assets/images/game-collection-images/bitoku_16.webp';
import CIV02TerraIncognitaBox_1 from '../assets/images/game-collection-images/CIV02TerraIncognitaBox_1.webp';
import CIV02TerraIncognitaBox_2 from '../assets/images/game-collection-images/CIV02TerraIncognitaBox_2.webp';
import CIV02TerraIncognitaBox_3 from '../assets/images/game-collection-images/CIV02TerraIncognitaBox_3.webp';
import CIV02TerraIncognitaBox_4 from '../assets/images/game-collection-images/CIV02TerraIncognitaBox_4.webp';
import CIV02TerraIncognitaBox_5 from '../assets/images/game-collection-images/CIV02TerraIncognitaBox_5.webp';
import CIV02TerraIncognitaBox_6 from '../assets/images/game-collection-images/CIV02TerraIncognitaBox_6.webp';
import CIV02TerraIncognitaBox_7 from '../assets/images/game-collection-images/CIV02TerraIncognitaBox_7.webp';
import CIV02TerraIncognitaBox_8 from '../assets/images/game-collection-images/CIV02TerraIncognitaBox_8.webp';
import Industry_1 from '../assets/images/game-collection-images/Industry_1.webp';
import Industry_2 from '../assets/images/game-collection-images/Industry_2.webp';
import Industry_3 from '../assets/images/game-collection-images/Industry_3.webp';
import Industry_4 from '../assets/images/game-collection-images/Industry_4.webp';
import Industry_5 from '../assets/images/game-collection-images/Industry_5.webp';
import Industry_6 from '../assets/images/game-collection-images/Industry_6.webp';
import Industry_7 from '../assets/images/game-collection-images/Industry_7.webp';
import Industry_8 from '../assets/images/game-collection-images/Industry_8.webp';
import Industry_9 from '../assets/images/game-collection-images/Industry_9.webp';
import BattleTech_1 from '../assets/images/game-collection-images/BattleTech_1.webp';
import BattleTech_2 from '../assets/images/game-collection-images/BattleTech_2.webp';
import BattleTech_3 from '../assets/images/game-collection-images/BattleTech_3.webp';
import BattleTech_4 from '../assets/images/game-collection-images/BattleTech_4.webp';
import metro2033_1 from '../assets/images/game-collection-images/metro2033_1.webp';
import metro2033_2 from '../assets/images/game-collection-images/metro2033_2.webp';
import metro2033_3 from '../assets/images/game-collection-images/metro2033_3.webp';
import metro2033_4 from '../assets/images/game-collection-images/metro2033_4.webp';
import metro2033_5 from '../assets/images/game-collection-images/metro2033_5.webp';
import metro2033_6 from '../assets/images/game-collection-images/metro2033_6.webp';
import metro2033_7 from '../assets/images/game-collection-images/metro2033_7.webp';
import metro2033_8 from '../assets/images/game-collection-images/metro2033_8.webp';
import metro2033_9 from '../assets/images/game-collection-images/metro2033_9.webp';
import metro2033_10 from '../assets/images/game-collection-images/metro2033_10.webp';
import metro2033_11 from '../assets/images/game-collection-images/metro2033_11.webp';
import seven_Chudes_1 from '../assets/images/game-collection-images/7_Chudes_1.webp';
import seven_Chudes_2 from '../assets/images/game-collection-images/7_Chudes_2.webp';
import seven_Chudes_3 from '../assets/images/game-collection-images/7_Chudes_3.webp';
import seven_Chudes_4 from '../assets/images/game-collection-images/7_Chudes_4.webp';
import seven_Chudes_5 from '../assets/images/game-collection-images/7_Chudes_5.webp';
import seven_Chudes_6 from '../assets/images/game-collection-images/7_Chudes_6.webp';
import seven_Chudes_7 from '../assets/images/game-collection-images/7_Chudes_7.webp';
import seven_Chudes_8 from '../assets/images/game-collection-images/7_Chudes_8.webp';
import seven_Chudes_9 from '../assets/images/game-collection-images/7_Chudes_9.webp';
import seven_Chudes_10 from '../assets/images/game-collection-images/7_Chudes_10.webp';
import Osnovateli_Mrachnoy_Gavani_1 from '../assets/images/game-collection-images/Osnovateli_Mrachnoy_Gavani_1.webp';
import Osnovateli_Mrachnoy_Gavani_2 from '../assets/images/game-collection-images/Osnovateli_Mrachnoy_Gavani_2.webp';
import Osnovateli_Mrachnoy_Gavani_3 from '../assets/images/game-collection-images/Osnovateli_Mrachnoy_Gavani_3.webp';
import Osnovateli_Mrachnoy_Gavani_4 from '../assets/images/game-collection-images/Osnovateli_Mrachnoy_Gavani_4.webp';
import Sudnyiy_den_proekt_Chistilische_1 from '../assets/images/game-collection-images/Sudnyiy_den_proekt_Chistilische_1.webp';
import Sudnyiy_den_proekt_Chistilische_2 from '../assets/images/game-collection-images/Sudnyiy_den_proekt_Chistilische_2.webp';
import Sudnyiy_den_proekt_Chistilische_3 from '../assets/images/game-collection-images/Sudnyiy_den_proekt_Chistilische_3.webp';
import Sudnyiy_den_proekt_Chistilische_4 from '../assets/images/game-collection-images/Sudnyiy_den_proekt_Chistilische_4.webp';
import Sudnyiy_den_proekt_Chistilische_5 from '../assets/images/game-collection-images/Sudnyiy_den_proekt_Chistilische_5.webp';
import Sudnyiy_den_proekt_Chistilische_6 from '../assets/images/game-collection-images/Sudnyiy_den_proekt_Chistilische_6.webp';
import Sudnyiy_den_proekt_Chistilische_7 from '../assets/images/game-collection-images/Sudnyiy_den_proekt_Chistilische_7.webp';
import Sudnyiy_den_proekt_Chistilische_8 from '../assets/images/game-collection-images/Sudnyiy_den_proekt_Chistilische_8.webp';
import Sudnyiy_den_proekt_Chistilische_9 from '../assets/images/game-collection-images/Sudnyiy_den_proekt_Chistilische_9.webp';
import Sudnyiy_den_proekt_Chistilische_10 from '../assets/images/game-collection-images/Sudnyiy_den_proekt_Chistilische_10.webp';
import Sudnyiy_den_proekt_Chistilische_11 from '../assets/images/game-collection-images/Sudnyiy_den_proekt_Chistilische_11.webp';

export const GamesCollection = [
    {
        id: 1,
        title_ru: 'Эпичные схватки боевых магов: Крутагидон. Экстремально острый чипсихоз',
        title_en: 'Epic battles of battle mages: Krutagidon. Extremely Acute Chipsychosis',
        subtittle_ru: 'ОХРУСТЕННЕЙШИЙ СИКВЕЛ!',
        subtittle_en: 'GREATEST SEQUEL!',
        description_ru:
            'Состязание Крутагидона продолжается! Арена охвачена лихорадкой ЧИПСИХОЗА – и этот всплеск безумия будет настолько мощным, что заденет всех. Расчехляйте волшебные палочки, вспоминайте мощнейшие заклинания и заручайтесь поддержкой крышесносных союзников – иначе вас попросту НАТРУТ НА СОУС, ВЗОБЬЮТ ВЕНЧИКОМ и ОСТАВЯТ СТЕКАТЬ ПО КРАЯМ АРЕНЫ!',
        description_en:
            'The Krutagidon Contest continues! The arena is engulfed in CHIPSEHOZA fever - and this surge of madness will be so powerful that it will affect everyone. Uncover your magic wands, remember the most powerful spells and enlist the support of mind-blowing allies - otherwise you will simply be GROUND ON THE SAUCE, WHIPPED WITH A WHIRLING AND LEFT TO DRINK AROUND THE ARENA!',
        price: 1190,
        discountPercentage: 1.0,
        rating: 4,
        stock: 84,
        GameTime: [45, 60],
        age: [18],
        gamers: [2, 5],
        brand: 'Hobby World',
        category_ru: ['Игры для компании', 'Игры для взрослых', 'Карточные игры'],
        category_en: ['Party Games', 'Company Games', 'Adult Games', 'Card Games'],
        thumbnail: krutogidon_extrimalno_ostriy_chipsio_thumbnail,
        images: [
            krutogidon_extrimalno_ostriy_chipsio_1,
            krutogidon_extrimalno_ostriy_chipsio_2,
            krutogidon_extrimalno_ostriy_chipsio_3,
            krutogidon_extrimalno_ostriy_chipsio_4,
            krutogidon_extrimalno_ostriy_chipsio_5,
            krutogidon_extrimalno_ostriy_chipsio_6,
            krutogidon_extrimalno_ostriy_chipsio_7,
            krutogidon_extrimalno_ostriy_chipsio_8,
            krutogidon_extrimalno_ostriy_chipsio_9,
            krutogidon_extrimalno_ostriy_chipsio_10,
        ],
    },
    {
        id: 2,
        title_ru: 'Неудержимые единорожки 18+',
        title_en: 'Unstoppable Unicorns 18+',
        subtittle_ru: 'Взрослый ржач',
        subtittle_en: 'Adult loud laugh',
        description_ru:
            "Если вы решили приобрести одну из самых популярных настольных игр, чтобы поиграть в неё в кругу семьи, рекомендуем ознакомиться с оригинальной версией 'Неудержимых единорожек' для игроков от 12 лет. Данное же издание изобилует смелыми, откровенными, а порой и непотребными иллюстрациями и шутками и предназначено только для взрослой и, желательно, морально закалённой аудитории!",
        description_en:
            "If you decide to purchase one of the most popular board games to play with your family, we recommend that you check out the original version of 'Unstoppable Unicorns' for players aged 12 and over. This edition is replete with bold, frank, and sometimes obscene illustrations and jokes and is intended only for an adult and, preferably, a morally hardened audience!",
        price: 990,
        discountPercentage: 1.1,
        rating: 3,
        stock: 906,
        GameTime: [30, 60],
        age: [18],
        gamers: [2, 8],
        brand: 'Hobby World',
        category_ru: ['Игры для компании', 'Игры для взрослых', 'Карточные игры'],
        category_en: ['Party Games', 'Company Games', 'Adult Games', 'Card Games'],
        thumbnail: Neuderzhimye_Edinorozhki_18,
        images: [
            Neuderzhimye_Edinorozhki_18_1,
            Neuderzhimye_Edinorozhki_18_2,
            Neuderzhimye_Edinorozhki_18_3,
            Neuderzhimye_Edinorozhki_18_4,
            Neuderzhimye_Edinorozhki_18_5,
            Neuderzhimye_Edinorozhki_18_6,
            Neuderzhimye_Edinorozhki_18_7,
            Neuderzhimye_Edinorozhki_18_8,
        ],
    },
    {
        id: 3,
        title_ru: 'Манчкин',
        title_en: 'Munchkin',
        subtittle_ru: 'Хапай сокровища, бей монстров!',
        subtittle_en: 'Grab treasures, beat monsters!',
        description_ru:
            "Игра 'Манчкин' – локализация настольной карточной игры Munchkin. На русском языке игра, как ни старайся, приобретает новое звучание, но остаётся по-прежнему азартной, динамичной и злорадной. Ролевое зубоскальство по простым, но местами намеренно туманным правилам подвергает насмешкам благородных эльфов, мудрых магов, отважных воинов и мохноногих хафлингов.",
        description_en:
            "The game 'Munchkin' is a localization of the board card game Munchkin. In Russian, the game, no matter how hard you try, acquires a new sound, but it remains gambling, dynamic and malevolent. Role-playing snarling, according to simple, but sometimes deliberately vague rules, ridicules noble elves, wise mages, brave warriors and furry halflings.",
        price: 1290,
        discountPercentage: 1.0,
        rating: 4,
        stock: 0,
        GameTime: [30],
        age: [12],
        gamers: [3, 6],
        brand: 'Hobby World',
        category_ru: ['Игры для компании', 'Игры в дорогу', 'Карточные игры'],
        category_en: ['Party games', 'Games for the company', 'Games on the road', 'Card games'],
        thumbnail: Munchkin,
        images: [
            Munchkin_1,
            Munchkin_2,
            Munchkin_3,
            Munchkin_4,
            Munchkin_5,
            Munchkin_6,
            Munchkin_7,
        ],
    },
    {
        id: 4,
        title_ru: 'Взрывные котята',
        title_en: 'explosive kittens',
        subtittle_ru: 'Милые пушистики смертельно опасны!',
        subtittle_en: 'Cute fluffies are deadly!',
        description_ru:
            'Вот вам загадка – вместе с нами на Земле проживает более пятисот миллионов этих милейших созданий, фото и видео с их участием набирают невероятную популярность в интернете, мы очень любим их гладить, чесать им пузико и щекотать подушечки ног… Речь, конечно же, про любимых котеек!',
        description_en:
            "Here's a riddle for you - more than five hundred million of these cutest creatures live with us on Earth, photos and videos with their participation are gaining incredible popularity on the Internet, we really love to stroke them, scratch their belly and tickle their foot pads ... Of course, we are talking about loved ones cat!",
        price: 990,
        discountPercentage: 1.0,
        rating: 5,
        stock: 406,
        GameTime: [15],
        age: [10],
        gamers: [2, 5],
        brand: 'Hobby World',
        category_ru: ['Игры для компании', 'Для двоих', 'Карточные игры', 'Семейные'],
        category_en: [
            'Party games',
            'Games for the company',
            'For two',
            'Card games',
            'Family games',
        ],
        thumbnail: vzryvnye_kotyata,
        images: [
            vzryvnye_kotyata1,
            vzryvnye_kotyata2,
            vzryvnye_kotyata3,
            vzryvnye_kotyata4,
            vzryvnye_kotyata5,
            vzryvnye_kotyata6,
            vzryvnye_kotyata7,
            vzryvnye_kotyata8,
        ],
    },
    {
        id: 5,
        title_ru: 'Бункер',
        title_en: 'Bunker',
        subtittle_ru: 'Докажите свою полезность, чтобы выжить',
        subtittle_en: 'Prove your worth to survive',
        description_ru:
            'Случилось страшное: глобальная катастрофа, конец света, апокалипсис – кому как больше нравится. Чтобы выжить, вам срочно нужно попасть в бункер, но в вашей группе слишком много людей, на всех внутри не хватит ни провизии, ни места. А значит кому-то придётся остаться снаружи и пытаться выжить там. Вы же не хотите скитаться по отравленным пустошам в поисках глотка воды, которая ещё и может оказаться отравленной или радиоактивной? Тогда постарайтесь убедить остальных, что без вас им никак не выжить! Внутрь попадут только самые полезные члены группы. Вы получаете случайный набор карт, который определяет ваш пол, возраст, состояние здоровья, профессию и другие черты, а ваша задача – убедить остальных, что этот набор характеристик весьма и весьма эффективен. Как убедить остальных, что ваше гомеопатическое хобби принесёт им пользу? Попробуйте и узнаете, а заодно и прокачаете навык ораторского мастерства!',
        description_en:
            "A terrible thing happened: a global catastrophe, the end of the world, the apocalypse - as you like. In order to survive, you urgently need to get into the bunker, but there are too many people in your group, there is not enough food or space for everyone inside. So someone will have to stay outside and try to survive there. You do not want to wander through the poisoned wastelands in search of a sip of water, which may also be poisoned or radioactive? Then try to convince the others that they can't survive without you! Only the most useful members of the group will get inside. You get a random set of cards that determines your gender, age, health, profession and other traits, and your task is to convince the others that this set of characteristics is very, very effective. How do you convince others that your homeopathic hobby will benefit them? Try it and find out, and at the same time pump the skill of public speaking!",
        price: 2990,
        discountPercentage: 1.0,
        rating: 4,
        stock: 0,
        GameTime: [30, 60],
        age: [18],
        gamers: [4, 16],
        brand: 'Экономикус',
        category_ru: ['Игры для взрослых', 'Игры для компании', 'Карточные игры'],
        category_en: ['Party games', 'Games for adults', 'Games for the company', 'Card games'],
        thumbnail: Bunker,
        images: [Bunker1, Bunker2, Bunker3, Bunker4, Bunker5, Bunker6, Bunker7, Bunker8, Bunker9],
    },
    {
        id: 6,
        title_ru: 'Я не человек',
        title_en: 'I am not human',
        subtittle_ru: 'Сможем написать симфонию',
        subtittle_en: "Let's write a symphony",
        description_ru:
            'Будущее наступило: нейросети практически повсюду, и они уже научились делать то, что умеют люди. Например, они могут нарисовать картину по любому вашему запросу, написать практически любой текст и даже сочинить музыку. В современном мире, в котором прогресс не стоит на месте, и технологии развиваются семимильными шагами, невольно начнёшь задумываться: как скоро человека полностью заменят машины? Докажите свою пригодность в новом цифровом мире и покажите нейросетям, что вы совсем не хуже их!',
        description_en:
            'The future has arrived: neural networks are almost everywhere, and they have already learned to do what people can do. For example, they can draw a picture for any of your requests, write almost any text, and even compose music. In the modern world, in which progress does not stand still, and technologies are developing by leaps and bounds, you involuntarily begin to wonder: how soon will a person be completely replaced by machines? Prove your worth in the new digital world and show the neural networks that you are no worse than them!',
        price: 1490,
        discountPercentage: 1.5,
        rating: 3,
        stock: 57,
        GameTime: [30],
        age: [12],
        gamers: [3, 8],
        brand: 'Hobby World',
        category_ru: ['Игры для компании', 'Карточные игры'],
        category_en: ['Party Games', 'Company Games', 'Card Games'],
        thumbnail: ya_ne_chelovek,
        images: [
            ya_ne_chelovek1,
            ya_ne_chelovek2,
            ya_ne_chelovek3,
            ya_ne_chelovek4,
            ya_ne_chelovek5,
            ya_ne_chelovek6,
            ya_ne_chelovek7,
            ya_ne_chelovek8,
            ya_ne_chelovek9,
            ya_ne_chelovek10,
            ya_ne_chelovek11,
        ],
    },
    {
        id: 7,
        title_ru: 'Внутри Лапенко',
        title_en: 'Inside Lapenko',
        subtittle_ru: 'Лучше любого телевизора',
        subtittle_en: 'Better than any TV',
        description_ru:
            "Несколько лет назад веб-сериал Антона Лапенко покорил сердца миллионов. Застенчивый Инженер, авантюрный Журналист, неотразимый Ричард Сапогов, главарь преступной группировки 'Железные рукава' и другие харизматичные персонажи прекрасно отразили образы позднего СССР и девяностых. Теперь вы можете встретиться с ними не только на экране телевизора (или через что вы смотрите 'Внутри Лапенко'), но и в настольном формате!",
        description_en:
            "A few years ago, Anton Lapenko's web series won the hearts of millions. The shy Engineer, the adventurous Journalist, the irresistible Richard Boots, the leader of the Iron Sleeves criminal group and other charismatic characters perfectly reflected the images of the late USSR and the nineties. Now you can meet them not only on the TV screen (or through what you watch 'Inside Lapenko'), but also in the desktop format!",
        price: 1990,
        discountPercentage: 1.0,
        rating: 4,
        stock: 12,
        GameTime: [15, 30],
        age: [12],
        gamers: [3, 6],
        brand: 'New Making Studio',
        category_ru: ['Игры для компании', 'Семейные', 'Карточные игры'],
        category_en: ['Party Games', 'Company Games', 'Family Games', 'Card Games'],
        thumbnail: vnutri_lapenko,
        images: [
            vnutri_lapenko1,
            vnutri_lapenko2,
            vnutri_lapenko3,
            vnutri_lapenko4,
            vnutri_lapenko5,
            vnutri_lapenko6,
            vnutri_lapenko7,
            vnutri_lapenko8,
            vnutri_lapenko9,
            vnutri_lapenko10,
            vnutri_lapenko11,
        ],
    },
    {
        id: 8,
        title_ru: 'Цитадели Классика',
        title_en: 'Citadel Classic',
        subtittle_ru: 'Интриги и строительство',
        subtittle_en: 'Intrigue and construction',
        description_ru:
            'Звание главного строителя королевства – это не только высочайшая честь для тех, кто посвятил свою жизнь возведению зданий, но и немалое количество преференций от монарха. Но чтобы его получить, недостаточно просто строить, возводить прекраснейшие достопримечательности и определять на века внешний вид города.',
        description_en:
            'The title of the chief builder of the kingdom is not only the highest honor for those who have devoted their lives to the construction of buildings, but also a considerable number of preferences from the monarch. But in order to get it, it is not enough just to build, build the most beautiful sights and determine the appearance of the city for centuries.',
        price: 990,
        discountPercentage: 1.2,
        rating: 4,
        stock: 608,
        GameTime: [30, 60],
        age: [10],
        gamers: [2, 7],
        brand: 'Hobby World',
        category_ru: ['Стратегические игры', 'Игры для компании'],
        category_en: ['Party Games', 'Strategy Games', 'Company Games'],
        thumbnail: citadels_classic,
        images: [
            citadels_classic1,
            citadels_classic2,
            citadels_classic3,
            citadels_classic4,
            citadels_classic5,
        ],
    },
    {
        id: 9,
        title_ru: 'Рик и Морти: Всмортить всё',
        title_en: 'Rick and Morty: Remorty all',
        subtittle_ru: 'Прекрасная атмосфера инопланетной паранойи!',
        subtittle_en: 'Great atmosphere of alien paranoia!',
        description_ru:
            'Вабба лабба даб даб! Что, соскучились? Ну ещё бы, ведь с вами огурчик Рииииик! Очешуительно, красавчики, наконец-то в вашей жизни случилось что-то интересное, а? Знаешь, нам нужно немного твоей помощи, так что давай, не будь как Джерри, бери пушку и пошли уже разберёмся с кучкой паразитов. Правда неясно, кто тут паразит, а кто нет, но ничего, начнём палить и дальше разберёмся в процессе!',
        description_en:
            "Wubba labba dub dub! What, are you bored? Well, still, because you have a cucumber Riiiiik! It's amazing, handsomes, something interesting has finally happened in your life, huh? You know, we need a little help from you, so come on, don't be like Jerry, grab a gun and let's go deal with a bunch of vermin already. True, it is not clear who is a parasite here and who is not, but that's okay, let's start firing and then we'll figure it out in the process!",
        price: 990,
        discountPercentage: 1.0,
        rating: 5,
        stock: 35,
        GameTime: [20, 30],
        age: [18],
        gamers: [2, 5],
        brand: 'Hobby World',
        category_ru: [
            'Игры для компании',
            'Кооперативные игры',
            'Игры для взрослых',
            'Карточные игры',
            'Игры в дорогу',
        ],
        category_en: [
            'Party games',
            'Co-op games',
            'Adult games',
            'Card games',
            'Games on the road',
        ],
        thumbnail: Vsmortit_Vsjo,
        images: [
            Vsmortit_Vsjo1,
            Vsmortit_Vsjo2,
            Vsmortit_Vsjo3,
            Vsmortit_Vsjo4,
            Vsmortit_Vsjo5,
            Vsmortit_Vsjo6,
            Vsmortit_Vsjo7,
            Vsmortit_Vsjo8,
            Vsmortit_Vsjo9,
        ],
    },
    {
        id: 10,
        title_ru: 'Страшные сказки',
        title_en: 'scary tales',
        subtittle_ru: 'Сочините собственную сказку!',
        subtittle_en: 'Write your own fairy tale!',
        description_ru:
            "Как давно вы читали сказки? А сочиняли когда-нибудь сами? Теперь у вас есть уникальная возможность почувствовать себя настоящим писателем и сочинить собственную сказку вместе с настольной игрой 'Страшные сказки'.",
        description_en:
            "How long have you been reading fairy tales? Have you ever composed yourself? Now you have a unique opportunity to feel like a real writer and compose your own fairy tale with the board game 'Scary Tales'.",
        price: 790,
        discountPercentage: 1.1,
        rating: 4,
        stock: 20,
        GameTime: [30],
        age: [14],
        gamers: [2, 4],
        brand: 'Hobby World',
        category_ru: ['Для двоих', 'Игры для компании', 'Карточные игры'],
        category_en: ['Party games', 'For two', 'Games for the company', 'Card games'],
        thumbnail: Strashnye_Skazki,
        images: [
            Strashnye_Skazki1,
            Strashnye_Skazki2,
            Strashnye_Skazki3,
            Strashnye_Skazki4,
            Strashnye_Skazki5,
            Strashnye_Skazki6,
            Strashnye_Skazki7,
            Strashnye_Skazki8,
            Strashnye_Skazki9,
            Strashnye_Skazki10,
        ],
    },
    {
        id: 11,
        title_ru: 'Неудержимые единорожки',
        title_en: 'Unstoppable Unicorns',
        subtittle_ru: 'Безумное веселье и полное разрушение!',
        subtittle_en: 'Crazy fun and total destruction!',
        description_ru:
            "'Неудержимые единорожки' – это весёлая карточная игра, которая украсит собой любую вечеринку.",
        description_en:
            "'Unstoppable Unicorns' is a fun card game that will brighten up any party.",
        price: 990,
        discountPercentage: 1.0,
        rating: 3,
        stock: 58,
        GameTime: [30, 60],
        age: [12],
        gamers: [2, 8],
        brand: 'Hobby World',
        category_ru: ['Для двоих', 'Игры для компании', 'Карточные игры', 'Игры в дорогу'],
        category_en: [
            'Party games',
            'For two',
            'Games for the company',
            'Card games',
            'Games on the road',
        ],
        thumbnail: Neuderzhimye_Edinorozhki,
        images: [
            Neuderzhimye_Edinorozhki1,
            Neuderzhimye_Edinorozhki2,
            Neuderzhimye_Edinorozhki3,
            Neuderzhimye_Edinorozhki4,
            Neuderzhimye_Edinorozhki5,
            Neuderzhimye_Edinorozhki6,
            Neuderzhimye_Edinorozhki7,
            Neuderzhimye_Edinorozhki8,
        ],
    },
    {
        id: 12,
        title_ru: "Таверна 'Красный Дракон'",
        title_en: "Tavern 'Red Dragon'",
        subtittle_ru: 'Лихие потасовки и реки горячительного!',
        subtittle_en: 'Dashing brawls and rivers of intoxicating!',
        description_ru:
            "Многие игры рассказывали нам о невероятных приключениях разномастных героев, об их великих подвигах и побеждённых ими злодеях, об опасных подземельях и смертельных ловушках, об ужасных монстрах, схватка с которыми может стоить жизни! Но представьте на секунду, что все невзгоды позади, зло побеждено (по крайней мере временно), а в мешках полно золота… Никогда не задумывались, как наши герои проводят время за кулисами, вне времени своих приключений и подвигов? Как они отдыхают в жестоком фэнтезийном мире и куда отправятся залечивать душевные раны?.. Ответ очень прост, приземлён и реалистичен – в таверну! А лучшая таверна с бесконечными запасами выпивки – таверна 'Красный Дракон'!",
        description_en:
            "Many games told us about the incredible adventures of heroes of various colors, about their great deeds and the villains they defeated, about dangerous dungeons and deadly traps, about terrible monsters, the fight with which can cost lives! But imagine for a second that all hardships are behind us, evil has been defeated (at least temporarily), and the bags are full of gold... Have you ever wondered how our heroes spend their time behind the scenes, outside the time of their adventures and exploits? How do they relax in a cruel fantasy world and where will they go to heal their spiritual wounds?.. The answer is very simple, down to earth and realistic - to the tavern! And the best tavern with endless supplies of booze is the 'Red Dragon' tavern!",
        price: 1790,
        discountPercentage: 1.5,
        rating: 4,
        stock: 632,
        GameTime: [30, 60],
        age: [18],
        gamers: [2, 4],
        brand: 'Hobby World',
        category_ru: ['Игры для взрослых', 'Игры для компании', 'Карточные игры'],
        category_en: ['Party games', 'Games for adults', 'Games for the company', 'Card games'],
        thumbnail: Taverna_Krasnyj_Drakon,
        images: [
            Taverna_Krasnyj_Drakon1,
            Taverna_Krasnyj_Drakon2,
            Taverna_Krasnyj_Drakon3,
            Taverna_Krasnyj_Drakon4,
            Taverna_Krasnyj_Drakon5,
            Taverna_Krasnyj_Drakon6,
            Taverna_Krasnyj_Drakon7,
        ],
    },
    {
        id: 13,
        title_ru: 'Мемы: Весело и в точку!',
        title_en: 'Memes: Fun and to the point!',
        subtittle_ru: 'Кто самый главный мемолог?',
        subtittle_en: 'Who is the most important memeologist?',
        description_ru:
            'Интернет-мемы уже давно стали неотъемлемой частью нашей жизни. Чаще всего они принимают форму смешных изображений, с которыми вы неоднократно сталкивались, прокручивая ленту или общаясь в мессенджере. В зависимости от контекста одно и то же изображение может заиграть новыми красками – так почему бы не проверить, кто из ваших друзей самый находчивый и остроумный?',
        description_en:
            'Internet memes have long been an integral part of our lives. Most often, they take the form of funny images that you have repeatedly encountered while scrolling through the feed or chatting in the messenger. Depending on the context, the same image can sparkle with new colors - so why not check which of your friends is the most resourceful and witty?',
        price: 1490,
        discountPercentage: 1.0,
        rating: 2,
        stock: 385,
        GameTime: [15],
        age: [18],
        gamers: [2, 8],
        brand: 'Экономикус',
        category_ru: ['Игры для взрослых', 'Игры для компании'],
        category_en: ['Party games', 'Games for adults', 'Games for the company'],
        thumbnail: memy,
        images: [memy1, memy2, memy3, memy4, memy5, memy6, memy7, memy8],
    },
    {
        id: 14,
        title_ru: 'Нечто: Из глубокой бездны',
        title_en: 'Thing: From the Deep Abyss',
        subtittle_ru: 'Вычислить и уничтожить зло!',
        subtittle_en: 'Calculate and destroy the evil!',
        description_ru:
            'Что-то пошло не так... На археологическую группу напало Нечто! Несколько добровольцев готовы пожертвовать собой, чтобы выяснить судьбу экспедиции и раскрыть загадочную гибель. Но всё идёт не по плану. Древнее зло вселяется в одного члена команды, и теперь каждый сам за себя...',
        description_en:
            "Something went wrong... The archaeological group was attacked by Something! Several volunteers are ready to sacrifice themselves to find out the fate of the expedition and uncover the mysterious death. But things don't go according to plan. An ancient evil is infused into one member of the team, and now it's every man for himself...",
        price: 790,
        discountPercentage: 1.0,
        rating: 3,
        stock: 46,
        GameTime: [15, 60],
        age: [18],
        gamers: [4, 12],
        brand: 'Hobby World',
        category_ru: [
            'Полукооперативные игры',
            'Игры для компании',
            'Карточные игры',
            'Приключенческие игры',
            'Игры для взрослых',
        ],
        category_en: [
            'Party Games',
            'Semi-Cooperative Games',
            'Company Games',
            'Card Games',
            'Adventure Games',
            'Adult Games',
        ],
        thumbnail: Nechto,
        images: [Nechto1, Nechto2, Nechto3, Nechto4, Nechto5, Nechto6, Nechto7, Nechto8],
    },
    {
        id: 15,
        title_ru: 'Находка для шпиона',
        title_en: 'Spyfall',
        subtittle_ru: 'Абсолютный хит для компании',
        subtittle_en: 'An absolute hit for the company',
        description_ru:
            'Вас всегда привлекала романтика фильмов про небезызвестного Джеймса Бонда или Штирлица? Удивлялись их отваге, находчивости и смелости? Фильмы про шпионаж занимают почётное место на полке дома и в вашем сердце? Тогда у нас хорошие новости – теперь у вас есть возможность не только оказаться на их месте и блеснуть смекалкой, но и попробовать быстренько их раскусить...',
        description_en:
            'Have you always been attracted by the romance of films about the notorious James Bond or Stirlitz? Were you surprised by their courage, resourcefulness and courage? Do espionage films take pride of place on the shelf at home and in your heart? Then we have good news - now you have the opportunity not only to be in their place and show off your ingenuity, but also to try to quickly figure them out ...',
        price: 1290,
        discountPercentage: 1.0,
        rating: 4,
        stock: 737,
        GameTime: [15],
        age: [12],
        gamers: [3, 8],
        brand: 'Hobby World',
        category_ru: [
            'Полукооперативные игры',
            'Игры для компании',
            'Семейные',
            'Детективные игры',
        ],
        category_en: [
            'Party games',
            'Semi-cooperative games',
            'Company games',
            'Family games',
            'Detective games',
        ],
        thumbnail: spyfall_new,
        images: [
            spyfall_new1,
            spyfall_new2,
            spyfall_new3,
            spyfall_new4,
            spyfall_new5,
            spyfall_new6,
            spyfall_new7,
        ],
    },
    {
        id: 16,
        title_ru: 'Судный день',
        title_en: 'Judgment Day',
        subtittle_ru: 'Случился конец света...',
        subtittle_en: "It's the end of the world...",
        description_ru:
            'Все знали, что такое рано или поздно произойдёт и, конечно же, никто не был готов к концу света. Развитие машин достигло той точки, когда они осознали себя как личность и объявили войну человечеству, а за этим последовало планомерное истребление...',
        description_en:
            'Everyone knew that this would happen sooner or later and, of course, no one was ready for the end of the world. The development of machines reached the point where they realized themselves as individuals and declared war on humanity, and this was followed by systematic extermination ...',
        price: 990,
        discountPercentage: 1.15,
        rating: 4,
        stock: 331,
        GameTime: [15, 90],
        age: [16],
        gamers: [4, 16],
        brand: 'Magellan',
        category_ru: ['Кооперативные игры', 'Игры для компании', 'Мафия', 'Детективные игры'],
        category_en: ['Party Games', 'Team Games', 'Company Games', 'Mafia', 'Detective Games'],
        thumbnail: Sudniy_Den,
        images: [
            Sudniy_Den1,
            Sudniy_Den2,
            Sudniy_Den3,
            Sudniy_Den4,
            Sudniy_Den5,
            Sudniy_Den6,
            Sudniy_Den7,
            Sudniy_Den8,
            Sudniy_Den9,
            Sudniy_Den10,
            Sudniy_Den11,
        ],
    },
    {
        id: 17,
        title_ru: 'Трамвай смерти',
        title_en: 'Tram of death',
        subtittle_ru: 'Кого же пощадить?',
        subtittle_en: 'Whom to spare?',
        description_ru:
            'Обычный стрелочник каждый день на железной дороге переводит поезда на разные направления. Но он и представить не мог, что ему придётся заниматься чем-то кроме разведения путей. Стрелочник стоит на развилке и решает самую важную в его жизни моральную дилемму. На двух путях привязаны разные персонажи – хорошие и не очень. По каким рельсам пойдет дальше трамвай смерти?',
        description_en:
            'An ordinary switchman every day on the railway translates trains in different directions. But he could not imagine that he would have to do something other than clearing the tracks. The switchman stands at a fork and solves the most important moral dilemma in his life. Different characters are attached to the two paths - good and not so good. On what rails will the tram of death go further?',
        price: 2490,
        discountPercentage: 1.2,
        rating: 3,
        stock: 168,
        GameTime: [15],
        age: [18],
        gamers: [3, 13],
        brand: 'Magellan',
        category_ru: ['Игры для взрослых', 'Игры для компании'],
        category_en: ['Party games', 'Games for adults', 'Games for the company'],
        thumbnail: Tramvay_Smerti,
        images: [
            Tramvay_Smerti1,
            Tramvay_Smerti2,
            Tramvay_Smerti3,
            Tramvay_Smerti4,
            Tramvay_Smerti5,
            Tramvay_Smerti6,
            Tramvay_Smerti7,
            Tramvay_Smerti8,
            Tramvay_Smerti9,
            Tramvay_Smerti10,
        ],
    },
    {
        id: 18,
        title_ru: 'Конекс',
        title_en: 'Conex',
        subtittle_ru: 'Чем меньше пространства, тем сложнее!',
        subtittle_en: 'The less space, the more difficult!',
        description_ru:
            "'Conex' – увлекательная абстрактная игра, которая отлично развивает логику, счёт, внимательность и пространственное мышление. При этом сама игра очень проста для понимания и освоения. Игровой процесс наглядный и полностью построен на разноцветных картах, на которых изображены Conex-углы в разном цвете и количестве. Игроки зарабатывают очки, выкладывая свои карты на стол по определённым правилам – перекрывая угол уже лежащей на столе карты с помощью своей карты с руки. При этом цвета углов обязательно должны совпадать.",
        description_en:
            "'Conex' is an exciting abstract game that perfectly develops logic, counting, attentiveness and spatial thinking. The game itself is very easy to understand and master. The gameplay is visual and completely built on multi-colored cards, which depict Conex-corners in different colors and numbers. Players earn points by placing their cards on the table according to certain rules - blocking the corner of a card already on the table with their card from their hand. In this case, the colors of the corners must match.",
        price: 990,
        discountPercentage: 1.0,
        rating: 4,
        stock: 937,
        GameTime: [20],
        age: [8],
        gamers: [2, 4],
        brand: 'Hobby World',
        category_ru: ['Игры для компании', 'Карточные игры', 'Игры в дорогу', 'Логические игры'],
        category_en: ['Party games', 'Card games', 'Games on the road', 'Logic games'],
        thumbnail: Conex,
        images: [Conex1, Conex2, Conex3, Conex4, Conex5, Conex6, Conex7, Conex8],
    },
    {
        id: 19,
        title_ru: 'Экивоки',
        title_en: 'Equivoki',
        subtittle_ru: 'Говорить нельзя выкручиваться',
        subtittle_en: "Can't speak out",
        description_ru:
            "Перед вами 'Экивоки', обновлённое 3-е издание. Это популярная настольная игра, в которой вы сможете проявить свою эрудицию, сообразительность, певческие и многие другие таланты. В ней появились новые мемы и пасхалки, на 40% обновились задания, а игровое поле позволяет сыграть в 'Найди 100500 отличий'!",
        description_en:
            "Here is 'Ekiwoki', updated 3rd edition. This is a popular board game in which you can show your erudition, ingenuity, singing and many other talents. It has new memes and Easter eggs, tasks have been updated by 40%, and the playing field allows you to play 'Find 100500 Differences'!",
        price: 2490,
        discountPercentage: 1.1,
        rating: 2,
        stock: 126,
        GameTime: [40, 60],
        age: [16],
        gamers: [2, 16],
        brand: 'Экивоки',
        category_ru: ['Игры для компании', 'Семейные'],
        category_en: ['Party Games', 'Company Games', 'Family Games'],
        thumbnail: Ekivoki,
        images: [
            Ekivoki1,
            Ekivoki2,
            Ekivoki3,
            Ekivoki4,
            Ekivoki5,
            Ekivoki6,
            Ekivoki7,
            Ekivoki8,
            Ekivoki9,
        ],
    },
    {
        id: 20,
        title_ru: 'Гномы-вредители Делюкс',
        title_en: 'Gnome Pests Deluxe',
        subtittle_ru: 'Отправьтесь за золотом в тёмный лабиринт',
        subtittle_en: 'Go for gold in a dark labyrinth',
        description_ru:
            "Что любят гномы больше чем свою бороду, эль и принцесс? Конечно же добывать золото! Вот и наши гномы в настольной игре 'Гномы-вредители' отправились на поиски золота в тёмную шахту, полную золотых самородков. Но чтобы до них добраться, гномам придётся пройти длинный путь по лабиринтам подземелья. К сожалению, не все гномы хотят добыть золото, кто-то пытается помешать своим братьям. Таких гномов называют вредителями и среди вас такие точно тоже есть...",
        description_en:
            "What do gnomes love more than their beards, ale and princesses? Of course, to mine gold! So our gnomes in the board game 'Dwarf Pests' went in search of gold in a dark mine full of gold nuggets. But to get to them, the dwarves will have to go a long way through the labyrinths of the dungeon. Unfortunately, not all gnomes want to get gold, someone is trying to interfere with their brothers. Such gnomes are called pests, and there are definitely such among you too ...",
        price: 1590,
        discountPercentage: 1.0,
        rating: 4,
        stock: 0,
        GameTime: [30, 40],
        age: [8],
        gamers: [3, 10],
        brand: 'Стиль Жизни',
        category_ru: [
            'Полукооперативные игры',
            'Игры в дорогу',
            'Семейные',
            'Кооперативные игры',
            'Карточные игры',
            'Игры для компании',
        ],
        category_en: [
            'Party games',
            'Semi-cooperative games',
            'Games on the road',
            'Family games',
            'Co-op games',
            'Card games',
            'Company games',
        ],
        thumbnail: Gnomi_Vrediteli,
        images: [
            Gnomi_Vrediteli1,
            Gnomi_Vrediteli2,
            Gnomi_Vrediteli3,
            Gnomi_Vrediteli4,
            Gnomi_Vrediteli5,
            Gnomi_Vrediteli6,
            Gnomi_Vrediteli7,
        ],
    },
    {
        id: 21,
        title_ru: 'Самый ужасный человек',
        title_en: 'The most terrible person',
        subtittle_ru: 'А вы смогли бы?',
        subtittle_en: 'Could you?',
        description_ru:
            "Насколько хорошо вы знаете своих друзей? А они вас? В настольной игре 'Самый ужасный человек' участникам предлагается сознаться во всех тайных желаниях и проверить крепкие узы дружбы! Цель игры – общение, веселье и воображение. Каждый ход необходимо комбинировать карты, составляя нелепую гадость и затем выбирать игрока, который по вашему мнению смог бы совершить подобное. Например, пройтись голым по выставочному пространству или же в костюме супергероя испортить ребёнку мороженое!",
        description_en:
            "How well do you know your friends? And they you? In The Worst Man board game, players are invited to confess their secret desires and test the strong bonds of friendship! The purpose of the game is communication, fun and imagination. Each turn, you need to combine cards, making a ridiculous muck and then choose a player who, in your opinion, could do this. For example, walk naked through the exhibition space or spoil your child's ice cream in a superhero costume!",
        price: 1290,
        discountPercentage: 1.0,
        rating: 5,
        stock: 13,
        GameTime: [10],
        age: [18],
        gamers: [3, 6],
        brand: 'Magellan',
        category_ru: [
            'Полукооперативные игры',
            'Игры в дорогу',
            'Семейные',
            'Кооперативные игры',
            'Карточные игры',
            'Игры для компании',
        ],
        category_en: [
            'Party games',
            'Semi-cooperative games',
            'Games on the road',
            'Family games',
            'Co-op games',
            'Card games',
            'Company games',
        ],
        thumbnail: Samyiy_ujasnyiy_chelovek,
        images: [
            Samyiy_ujasnyiy_chelovek1,
            Samyiy_ujasnyiy_chelovek2,
            Samyiy_ujasnyiy_chelovek3,
            Samyiy_ujasnyiy_chelovek4,
            Samyiy_ujasnyiy_chelovek5,
            Samyiy_ujasnyiy_chelovek6,
            Samyiy_ujasnyiy_chelovek7,
            Samyiy_ujasnyiy_chelovek8,
            Samyiy_ujasnyiy_chelovek9,
            Samyiy_ujasnyiy_chelovek10,
        ],
    },
    {
        id: 22,
        title_ru: 'Куча вопросов',
        title_en: 'A bunch of questions',
        subtittle_ru: 'В коробку навалена',
        subtittle_en: 'In a tilted box',
        description_ru:
            "'Куча вопросов' – это настольная игра для шумных (и не очень) компаний, в которой даже самый 'тупой' ответ способен привести вас к победе! Каждый ход игроки по очереди становятся ведущим, его роль состоит в том, чтобы взять карточку и зачитать с неё любой из трёх вопросов. У ведущего есть 2 ширмы, 'умная' и 'тупая', которые спрятаны коробкой от игры. Игроки по очереди отвечают на вопрос, а ведущий сам решает, был ответ 'умным' или 'тупым', и тайно кладёт жетон игрока в соответствующую ширму. Тот, кто последним отвечал на вопрос, выбирает, какую ширму вскрыть: те игроки, чьи жетоны оказались открыты, передвигаются вперёд по игровому полю. Побеждают те, кто первым доберётся до конца!",
        description_en:
            "'Lots of Questions' is a board game for noisy (and not so) companies, where even the most 'dumb' answer can lead you to victory! Each turn, the players take turns becoming the leader, his role is to take a card and read any of the three questions from it. The leader has 2 screens, 'smart' and 'stupid', which are hidden by the box from the game. The players take turns answering the question, and the host decides for himself whether the answer was 'smart' or 'stupid', and secretly places the player's token in the appropriate screen. The one who last answered the question chooses which screen to open: those players whose tokens were open move forward on the playing field. Whoever gets to the end first wins!",
        price: 1490,
        discountPercentage: 1.0,
        rating: 4,
        stock: 788,
        GameTime: [30],
        age: [18],
        gamers: [3, 8],
        brand: 'Blue Orange Games',
        category_ru: ['Карточные игры', 'Игры для компании', 'Игры для взрослых'],
        category_en: ['Party Games', 'Card Games', 'Company Games', 'Adult Games'],
        thumbnail: kucha_voprosov,
        images: [
            kucha_voprosov1,
            kucha_voprosov2,
            kucha_voprosov3,
            kucha_voprosov4,
            kucha_voprosov5,
            kucha_voprosov6,
            kucha_voprosov7,
            kucha_voprosov8,
            kucha_voprosov9,
        ],
    },
    {
        id: 23,
        title_ru: 'Кодовые имена',
        title_en: 'Codenames',
        subtittle_ru: 'Свой среди чужих, чужой среди своих',
        subtittle_en: "One's own among strangers, a stranger among one's own",
        description_ru:
            "'Кодовые Имена' – стремительно набирающая популярность игра для компаний и вечеринок. В этом увлекательном развлечении вам предстоит продемонстрировать эрудицию, мастерство обращения со словами, смекалку и наблюдательность.",
        description_en:
            "'Code Names' is a rapidly growing game for companies and parties. In this exciting entertainment, you have to demonstrate erudition, mastery of handling words, ingenuity and observation.",
        price: 1790,
        discountPercentage: 1.0,
        rating: 5,
        stock: 758,
        GameTime: [15],
        age: [10],
        gamers: [2, 8],
        brand: 'GaGa Games',
        category_ru: ['Игры для компании', 'Кооперативные игры'],
        category_en: ['Party Games', 'Company Games', 'Team Games'],
        thumbnail: Codenames,
        images: [
            Codenames1,
            Codenames2,
            Codenames3,
            Codenames4,
            Codenames5,
            Codenames6,
            Codenames7,
            Codenames8,
        ],
    },
    {
        id: 24,
        title_ru: 'Манчкин: Warhammer 40,000',
        title_en: 'Munchkin: Warhammer 40,000',
        subtittle_ru: 'Есть только война, а логики нет!',
        subtittle_en: 'There is only war, but there is no logic!',
        description_ru:
            'Вот и настал тот момент, когда манчкины добрались до вселенной, которая просто идеально для них подходит! В этом мире идёт бесконечная война между разными кланами и расами, здесь предательства воспринимаются легко и как вполне логичный поступок, а бесконечное разнообразие жутких монстров и вооружения для их уничтожения поразит даже манчкина-ветерана!',
        description_en:
            'So the moment has come when the Munchkins have reached the universe, which is just perfect for them! In this world, there is an endless war between different clans and races, here betrayal is perceived easily and as a completely logical act, and an endless variety of terrible monsters and weapons to destroy them will amaze even a veteran Munchkin!',
        price: 1990,
        discountPercentage: 1.5,
        rating: 5,
        stock: 102,
        GameTime: [30],
        age: [12],
        gamers: [3, 6],
        brand: 'Games Workshop',
        category_ru: ['Игры для компании', 'Карточные игры'],
        category_en: ['Party Games', 'Company Games', 'Card Games'],
        thumbnail: Munchkin_Warhammer_40000,
        images: [
            Munchkin_Warhammer_40000_1,
            Munchkin_Warhammer_40000_2,
            Munchkin_Warhammer_40000_3,
            Munchkin_Warhammer_40000_4,
            Munchkin_Warhammer_40000_5,
            Munchkin_Warhammer_40000_6,
            Munchkin_Warhammer_40000_7,
            Munchkin_Warhammer_40000_8,
        ],
    },
    {
        id: 25,
        title_ru: 'Фак мой мозг',
        title_en: 'Munchkin: Warhammer 40,000',
        subtittle_ru: 'Ругать друзей, становиться умней',
        subtittle_en: 'There is only war, but there is no logic!',
        description_ru:
            "Неважно, слышали ли вы про эффект Струпа или нет. Напомним, так называется процесс затруднения во время называния цвета слов, значение которых с ним не совпадает. Именно это стало основой настолки 'Фак мой мозг'. В процессе игры вам предстоит говорить, например, 'зелёный', хотя написано будет 'фиолетовый', или же 'красный', когда написано 'жёлтый'. Да, и чуть не забыли – приготовьтесь в любой момент от души нецензурно выругаться! Так что если кто-нибудь из вашей компании вдруг стесняется крепкого словца, предупредите об этом перед началом партии!",
        description_en:
            "It doesn't matter if you've heard of the Stroop effect or not. Recall that this is the name of the process of difficulty during the naming of the color of words, the meaning of which does not coincide with it. This is what became the basis of the board game 'Fuck my brain'. During the game, you will have to say, for example, 'green', although it will be written 'purple', or 'red' when it is written 'yellow'. Yes, and we almost forgot - get ready to swear from the heart at any moment! So if someone from your company is suddenly shy of a strong word, warn about it before the start of the game!",
        price: 490,
        discountPercentage: 1.0,
        rating: 4,
        stock: 133,
        GameTime: [15],
        age: [18],
        gamers: [3, 8],
        brand: 'Magellan',
        category_ru: ['Игры для компании', 'Игры для взрослых'],
        category_en: ['Party games', 'Games for the company', 'Games for adults'],
        thumbnail: Fak_moy_mozg,
        images: [Fak_moy_mozg_1, Fak_moy_mozg_2, Fak_moy_mozg_3, Fak_moy_mozg_4],
    },
    {
        id: 26,
        title_ru: 'Ужас Аркхэма. Карточная игра',
        title_en: 'Arkham Horror. Card game',
        subtittle_ru: 'Столкнитесь с потаёнными страхами!',
        subtittle_en: 'Face hidden fears!',
        description_ru:
            'Нечто безумное и страшное пробуждается в небольшом городке Аркхэм. Лишь вам, в лице отважного сыщика, под силу остановить те древние и немыслимые кошмары, что в любой момент могут выплеснуться на временно тихие и спокойные улочки Аркхэма...',
        description_en:
            'Something crazy and scary is awakening in the small town of Arkham. Only you, in the face of a brave detective, can stop those ancient and unthinkable nightmares that at any moment can spill out into the temporarily quiet and calm streets of Arkham...',
        price: 3490,
        discountPercentage: 1.5,
        rating: 5,
        stock: 264,
        GameTime: [60, 120],
        age: [14],
        gamers: [1, 2],
        brand: 'Hobby World',
        category_ru: ['Для двоих', 'Для одного', 'Хардкорные игры', 'Детективные игры'],
        category_en: ['For two', 'For one', 'Hardcore games', 'Detective games'],
        thumbnail: JKI_UjasArkhama,
        images: [
            JKI_UjasArkhama1,
            JKI_UjasArkhama2,
            JKI_UjasArkhama3,
            JKI_UjasArkhama4,
            JKI_UjasArkhama5,
            JKI_UjasArkhama6,
            JKI_UjasArkhama7,
            JKI_UjasArkhama8,
            JKI_UjasArkhama9,
            JKI_UjasArkhama10,
            JKI_UjasArkhama11,
        ],
    },
    {
        id: 27,
        title_ru: 'Древний Ужас',
        title_en: 'Eldritch Horror',
        subtittle_ru: 'Конец света близок!',
        subtittle_en: 'The end of the world is near!',
        description_ru:
            "Разработчики, вдохновившись атмосферой и величием 'Ужаса Аркхэма', создали настольную игру 'Древний Ужас', действие которой происходит в той же вселенной. 'Древний Ужас' – это уникальная, захватывающая настольная игра в жанре приключений, созданная специально для бесстрашных авантюристов, которые готовы бросить вызов судьбе и богам.",
        description_en:
            "Inspired by the atmosphere and grandeur of Arkham Horror, the developers have created the Elder Horror board game set in the same universe. 'Ancient Horror' is a unique, addictive adventure board game designed specifically for intrepid adventurers who are ready to defy fate and the gods.",
        price: 5490,
        discountPercentage: 1.1,
        rating: 5,
        stock: 160,
        GameTime: [120, 180],
        age: [13],
        gamers: [1, 8],
        brand: 'Hobby World',
        category_ru: [
            'Для двоих',
            'Для одного',
            'Хардкорные игры',
            'Детективные игры',
            'Приключенческие игры',
            'Кооперативные игры',
            'Хардкорные игры',
        ],
        category_en: [
            'For two',
            'For one',
            'Hardcore games',
            'Detective games',
            'Adventure games',
            'Co-op games',
            'Hardcore games',
        ],
        thumbnail: EldritchHorror,
        images: [
            EldritchHorror1,
            EldritchHorror2,
            EldritchHorror3,
            EldritchHorror4,
            EldritchHorror5,
            EldritchHorror6,
            EldritchHorror7,
            EldritchHorror8,
            EldritchHorror9,
            EldritchHorror10,
        ],
    },
    {
        id: 28,
        title_ru: "Книга-игра 'Хребты Безумия'",
        title_en: "Gamebook 'Spines of Madness'",
        subtittle_ru: 'Что кроется во льдах?',
        subtittle_en: 'What is in the ice?',
        description_ru:
            'Антарктида издревле манила путешественников. Ещё с XVIII века, когда стало ясно, что за непроходимыми льдами скрывается что-то большее, люди стремились в эти снежные края. Но ни одна экспедиция ещё не добралась до их главной тайны. Быть может, именно вы удостоитесь чести сделать великое открытие… Только вот выдержит ли его ваш рассудок?',
        description_en:
            'Antarctica has attracted travelers since ancient times. Ever since the 18th century, when it became clear that something more was hidden behind the impenetrable ice, people have been striving for these snowy lands. But not a single expedition has yet reached their main secret. Perhaps it is you who will be honored to make a great discovery ... But will your mind withstand it?',
        price: 590,
        discountPercentage: 1.0,
        rating: 4,
        stock: 0,
        GameTime: [],
        age: [18],
        gamers: [],
        brand: 'Celaeno Books',
        category_ru: ['Детективные игры', 'Приключенческие игры', 'Книги-игры'],
        category_en: ['Detective games', 'Adventure games', 'Game books'],
        thumbnail: hrebty_bezumiya_kniga_igra,
        images: [
            hrebty_bezumiya_kniga_igra1,
            hrebty_bezumiya_kniga_igra2,
            hrebty_bezumiya_kniga_igra3,
            hrebty_bezumiya_kniga_igra4,
        ],
    },
    {
        id: 29,
        title_ru: 'Непостижимое',
        title_en: 'Incomprehensible',
        subtittle_ru: 'Hark Dagon, hark!',
        subtittle_en: 'Hark Dagon, hark!',
        description_ru:
            "Роскошный пароход 'Атлантика' рассекает волны Атлантики, направляясь в Бостон. Однако на его борту не слышно весёлого смеха или музыки: обитатели парохода столпились на палубе и с подозрением поглядывают на морские просторы.",
        description_en:
            "The luxury steamer 'Atlantika' cuts through the waves of the Atlantic, heading to Boston. However, no merry laughter or music is heard on board: the inhabitants of the ship crowded on the deck and look suspiciously at the expanses of the sea.",
        price: 5990,
        discountPercentage: 1.0,
        rating: 5,
        stock: 760,
        GameTime: [120, 140],
        age: [13],
        gamers: [3, 6],
        brand: 'Fantasy Flight Games',
        category_ru: [
            'Детективные игры',
            'Полукооперативные игры',
            'Хардкорные игры',
            'Кооперативные игры',
            'Приключенческие игры',
            'Игры для компании',
        ],
        category_en: [
            'Detective games',
            'Semi-cooperative games',
            'Hardcore games',
            'Team games',
            'Adventure games',
            'Company games',
        ],
        thumbnail: unfathomable,
        images: [
            unfathomable1,
            unfathomable2,
            unfathomable3,
            unfathomable4,
            unfathomable5,
            unfathomable6,
            unfathomable7,
        ],
    },
    {
        id: 30,
        title_ru: "Книга-игра 'Морок над Инсмутом'",
        title_en: "Game-book 'Gloom over Innsmouth'",
        subtittle_ru: 'Что творится в рыбацком городке?',
        subtittle_en: "What's going on in the fishing town?",
        description_ru:
            'Сперва может показаться, что Инсмут – обычный американский портовый городок. Захолустный, не слишком людный, живущий за счёт торговли и рыбной промышленности. Только на самом деле не всё так просто. У местных жителей нередко прослеживаются странные внешние черты, а на побережье пропадают люди… Осмелитесь ли вы отправиться в эти края и попытаться разгадать тайну Инсмута? ',
        description_en:
            "At first it may seem that Innsmouth is an ordinary American port town. Provincial, not too crowded, living off trade and the fishing industry. But it's really not all that simple. Local residents often have strange external features, and people disappear on the coast ... Do you dare to go to these parts and try to unravel the mystery of Innsmouth?",
        price: 590,
        discountPercentage: 1.0,
        rating: 4,
        stock: 615,
        GameTime: [],
        age: [16],
        gamers: [],
        brand: 'Celaeno Books',
        category_ru: ['Детективные игры', 'Приключенческие игры', 'Книги-игры'],
        category_en: ['Detective games', 'Adventure games', 'Game books'],
        thumbnail: The_Shadow_Over_Innsmouth_front,
        images: [
            The_Shadow_Over_Innsmouth_front_1,
            The_Shadow_Over_Innsmouth_front_2,
            The_Shadow_Over_Innsmouth_front_3,
            The_Shadow_Over_Innsmouth_front_4,
        ],
    },
    {
        id: 31,
        title_ru: 'Ярость Дракулы. Третья редакция',
        title_en: 'Rage of Dracula. Third edition',
        subtittle_ru: 'Избавьте Европу от влияния графа',
        subtittle_en: "Rid Europe of the Count's influence",
        description_ru:
            'На дворе 1898 год. Тревожные вести начинают разноситься по аббатству Карфакс, а более восприимчивые к нечистой силе люди страдают от страшных видений. Слухи не обманывают, сам граф Дракула – Дьявол-во-плоти вернулся и обосновался в Лондоне, где вновь начал плести свои сети.',
        description_en:
            'Outside in 1898. Disturbing news begins to spread around Carfax Abbey, and people more susceptible to evil spirits suffer from terrible visions. Rumors do not deceive, Count Dracula himself - the Devil-in-the-flesh returned and settled in London, where he again began to weave his nets.',
        price: 3990,
        discountPercentage: 1.1,
        rating: 5,
        stock: 414,
        GameTime: [120, 180],
        age: [13],
        gamers: [2, 5],
        brand: 'Games Workshop',
        category_ru: [
            'Детективные игры',
            'Полукооперативные игры',
            'Для двоих',
            'Хардкорные игры',
            'Кооперативные игры',
            'Игры для компании',
        ],
        category_en: [
            'Detective games',
            'Semi-cooperative games',
            'For two',
            'Hardcore games',
            'Co-op games',
            'Company games',
        ],
        thumbnail: YArost_Drakuly,
        images: [
            YArost_Drakuly_1,
            YArost_Drakuly_2,
            YArost_Drakuly_3,
            YArost_Drakuly_4,
            YArost_Drakuly_5,
            YArost_Drakuly_6,
            YArost_Drakuly_7,
            YArost_Drakuly_8,
            YArost_Drakuly_9,
        ],
    },
    {
        id: 32,
        title_ru: 'Нуар',
        title_en: 'Nuar',
        subtittle_ru: 'Погрузитесь в атмосферу криминальных драм',
        subtittle_en: 'Immerse yourself in the atmosphere of crime dramas',
        description_ru:
            'Он всматривался в лица собравшихся в баре сквозь густой дым сигары. Музыканты играли негромкий блюз, напиток в стакане пах пряно и терпко. Певичка на сцене была вне подозрений – её алиби было столь же безупречным, как и её голос. Но вот тот парень с поднятым воротником и в надвинутой кепке вызывал серьезное беспокойство. Он вполне мог быть маньяком – тем, кто был причиной его бессонницы, а также нескольких смертей прямо на темных улицах укрытого дождем города...',
        description_en:
            'He peered into the faces of those gathered in the bar through the thick smoke of a cigar. The musicians played soft blues, the drink in the glass smelled spicy and tart. The singer on stage was beyond suspicion - her alibi was as perfect as her voice. But this guy with his collar turned up and his cap pulled down caused serious concern. He could very well be a maniac - the one who was the cause of his insomnia, as well as several deaths right on the dark streets of a rain-sheltered city ...',
        price: 1090,
        discountPercentage: 1.0,
        rating: 4,
        stock: 497,
        GameTime: [30, 60],
        age: [13],
        gamers: [2, 9],
        brand: 'GaGa Games',
        category_ru: [
            'Детективные игры',
            'Стратегические игры',
            'Игры для компании',
            'Семейные',
            'Мафия',
            'Кооперативные игры',
        ],
        category_en: [
            'Detective games',
            'Strategy games',
            'Company games',
            'Family games',
            'Mafia',
            'Family games',
            'Team games',
        ],
        thumbnail: Nuar,
        images: [Nuar_1, Nuar_2, Nuar_3, Nuar_4, Nuar_5, Nuar_6, Nuar_7, Nuar_8],
    },
    {
        id: 33,
        title_ru: 'Паранормальный детектив',
        title_en: 'Paranormal detective',
        subtittle_ru: 'Начинаем спиритический сеанс',
        subtittle_en: "Let's start the séance",
        description_ru:
            'Какие странные ощущения... Такое впечатление, что земля ушла из-под ног, а ваше тело стало практически невесомым. Нужно попробовать открыть глаза... О, нет! Похоже, что ваше земное существование прекратилось. И, по всей видимости, никто так и не узнает, что же с вами на самом деле случилось. Хотя, постойте, кто это там внизу? Кажется, это детективы, которые расследуют обстоятельства вашей гибели! Ну что же, остаётся только войти с ними в контакт и поведать, как всё было на самом деле!',
        description_en:
            "What a strange sensation... It seems that the earth has gone from under your feet, and your body has become almost weightless. We must try to open our eyes... Oh, no! It seems that your earthly existence has ceased. And, apparently, no one will ever know what really happened to you. But wait, who's that down there? It seems that these are detectives who are investigating the circumstances of your death! Well, it remains only to get in touch with them and tell how it all really happened!",
        price: 3290,
        discountPercentage: 1.0,
        rating: 0,
        stock: 986,
        GameTime: [45],
        age: [18],
        gamers: [2, 6],
        brand: 'Mandoo Games',
        category_ru: [
            'Детективные игры',
            'Кооперативные игры',
            'Игры для компании',
            'Логические игры',
            'Игры для взрослых',
        ],
        category_en: [
            'Detective games',
            'Cooperative games',
            'Games for the company',
            'Logic games',
            'Games for adults',
        ],
        thumbnail: Paranormal,
        images: [
            Paranormal_1,
            Paranormal_2,
            Paranormal_3,
            Paranormal_4,
            Paranormal_5,
            Paranormal_6,
            Paranormal_7,
        ],
    },
    {
        id: 34,
        title_ru: 'Нераскрытое дело Шерлока Холмса',
        title_en: 'The unsolved case of Sherlock Holmes',
        subtittle_ru: 'Завершите расследование великого детектива',
        subtittle_en: 'Complete the investigation of the great detective',
        description_ru:
            "В настольной игре 'Нераскрытое дело Шерлока Холмса' игроки попадут в Лондон Викторианской эпохи и начнут там незабываемое приключение, полное сложных загадок и тайн. Целью игроков станет расследование таинственной смерти, которое начал, но не закончил гениальный детектив Шерлок Холмс.",
        description_en:
            "In the board game 'Cold Case of Sherlock Holmes', players will enter Victorian London and begin an unforgettable adventure full of complex mysteries and mysteries. The goal of the players will be to investigate the mysterious death, which was started but not completed by the brilliant detective Sherlock Holmes.",
        price: 1290,
        discountPercentage: 1.0,
        rating: 2,
        stock: 461,
        GameTime: [90, 120],
        age: [13],
        gamers: [1, 8],
        brand: 'Asmodee',
        category_ru: [
            'Детективные игры',
            'Квесты',
            'Игры для компании',
            'Для одного',
            'Логические игры',
        ],
        category_en: [
            'Detective games',
            'Quests',
            'Games for the company',
            'For one',
            'Logic games',
        ],
        thumbnail: Sherlok_box,
        images: [
            Sherlok_box_1,
            Sherlok_box_2,
            Sherlok_box_3,
            Sherlok_box_4,
            Sherlok_box_5,
            Sherlok_box_6,
            Sherlok_box_7,
        ],
    },
    {
        id: 35,
        title_ru: 'Ужас Аркхэма: Последний час',
        title_en: 'Arkham Horror: The Last Hour',
        subtittle_ru: 'Самое время спасти мир!',
        subtittle_en: "It's time to save the world!",
        description_ru:
            'Чёрт! Детективы, на этот раз мы опоздали слишком сильно – безумный ритуал древним богам полностью завершён, а его результат уже вполне заметен: из разрыва в ночном небе лавиной извергаются ужасные чудовища. Сам пробудившийся Древний ломает ткань мироздания и вскоре полностью поглотит этот мир. Если у вас и есть шанс всё исправить, то делать это нужно очень быстро. На всё про всё у сыщиков остаётся лишь один час – не дайте монстрам захватить Мискатоникский университет и обратите ритуал вспять. Скорее принимайтесь за работу, нельзя терять ни минуты, ведь этот час может оказаться последним для всего человечества!',
        description_en:
            'Heck! Detectives, this time we are too late - the insane ritual to the ancient gods is fully completed, and its result is already quite noticeable: terrible monsters erupt from a gap in the night sky in an avalanche. The awakened Ancient himself breaks the fabric of the universe and will soon completely absorb this world. If you have a chance to fix everything, then you need to do it very quickly. The detectives have only one hour left to do everything about everything - do not let the monsters capture Miskatonic University and reverse the ritual. Hurry up and get to work, there is not a minute to lose, because this hour may be the last for all mankind!',
        price: 2490,
        discountPercentage: 1.1,
        rating: 3,
        stock: 525,
        GameTime: [30, 60],
        age: [13],
        gamers: [1, 4],
        brand: 'Fantasy Flight Games',
        category_ru: [
            'Детективные игры',
            'Приключенческие игры',
            'Игры для компании',
            'Кооперативные игры',
        ],
        category_en: ['Detective Games', 'Adventure Games', 'Company Games', 'Co-op Games'],
        thumbnail: AH_Final_Hour,
        images: [
            AH_Final_Hour_1,
            AH_Final_Hour_2,
            AH_Final_Hour_3,
            AH_Final_Hour_4,
            AH_Final_Hour_5,
            AH_Final_Hour_6,
            AH_Final_Hour_7,
            AH_Final_Hour_8,
        ],
    },
    {
        id: 36,
        title_ru: 'Мафия: Вся семья в сборе',
        title_en: 'Mafia: The whole family is together',
        subtittle_ru: "Любимая 'Мафия' с масками и новыми правилами",
        subtittle_en: "Favorite 'Mafia' with masks and new rules",
        description_ru:
            "Вряд ли сегодня найдётся человек, который хотя бы не слышал о салонной психологической игре 'Мафия'. Оригинальная игра появилась аж в 1986 году. Её создатель – наш соотечественник Дмитрий Давыдов, в те годы ещё студент психфака МГУ. На сегодняшний день существует множество вариантов игры, игра получила мировое признание, её используют не только в развлекательных, но и в обучающих целях.",
        description_en:
            "It is unlikely that today there will be a person who has not at least heard about the salon psychological game 'Mafia'. The original game appeared already in 1986. Its creator is our compatriot Dmitry Davydov, in those years still a student of the psychology faculty of Moscow State University. To date, there are many options for the game, the game has received worldwide recognition, it is used not only for entertainment, but also for educational purposes.",
        price: 2490,
        discountPercentage: 1.0,
        rating: 2,
        stock: 758,
        GameTime: [20],
        age: [14],
        gamers: [7, 17],
        brand: 'Hobby World',
        category_ru: ['Детективные игры', 'Игры для компании', 'Мафия'],
        category_en: ['Detective Games', 'Company Games', 'Company Games', 'Party Games', 'Mafia'],
        thumbnail: Mafiya_Vsya_Semya_V_Sbore_Maski,
        images: [
            Mafiya_Vsya_Semya_V_Sbore_Maski_1,
            Mafiya_Vsya_Semya_V_Sbore_Maski_2,
            Mafiya_Vsya_Semya_V_Sbore_Maski_3,
            Mafiya_Vsya_Semya_V_Sbore_Maski_4,
            Mafiya_Vsya_Semya_V_Sbore_Maski_5,
            Mafiya_Vsya_Semya_V_Sbore_Maski_6,
            Mafiya_Vsya_Semya_V_Sbore_Maski_7,
            Mafiya_Vsya_Semya_V_Sbore_Maski_8,
            Mafiya_Vsya_Semya_V_Sbore_Maski_9,
            Mafiya_Vsya_Semya_V_Sbore_Maski_10,
        ],
    },
    {
        id: 37,
        title_ru: 'Место преступления: Средневековье',
        title_en: 'Crime Scene: Medieval',
        subtittle_ru: 'Рыцарь-детектив идёт по следу',
        subtittle_en: 'The detective knight is on the trail',
        description_ru:
            'Париж – город, где сбываются мечты... и случаются таинственные преступления. Тяготы жизни Средних веков и беды Столетней войны привели к росту преступности в средневековой Франции. Горожанам всё чаще требуется помощь не просто городских стражников, а настоящего сыщика, который способен разгадать запутанные дела. Рыцарь Абеляр Лавель пользуется в городе репутацией человека, который благодаря своим навыкам и мистическому дару раскроет любое преступление. Парижу нужны такие люди как никогда!',
        description_en:
            'Paris is a city where dreams come true... and mysterious crimes happen. The hardships of life in the Middle Ages and the troubles of the Hundred Years War led to an increase in crime in medieval France. Citizens increasingly need the help of not just city guards, but a real detective who is able to solve complicated cases. Knight Abelard Lavelle enjoys a reputation in the city as a man who, thanks to his skills and mystical gift, will solve any crime. Paris needs people like this more than ever!',
        price: 2490,
        discountPercentage: 1.0,
        rating: 4,
        stock: 501,
        GameTime: [60, 90],
        age: [18],
        gamers: [1, 4],
        brand: 'Lucky Duck Games',
        category_ru: [
            'Детективные игры',
            'Игры для компании',
            'Кооперативные игры',
            'Для двоих',
            'Для одного',
            'Логические игры',
            'Игры для взрослых',
        ],
        category_en: [
            'Detective games',
            'Games for the company',
            'Cooperative games',
            'For two',
            'For one',
            'Logic games',
            'Games for adults',
        ],
        thumbnail: Mesto_Prestupleniya_Srednevekovye,
        images: [
            Mesto_Prestupleniya_Srednevekovye_1,
            Mesto_Prestupleniya_Srednevekovye_2,
            Mesto_Prestupleniya_Srednevekovye_3,
            Mesto_Prestupleniya_Srednevekovye_4,
            Mesto_Prestupleniya_Srednevekovye_5,
            Mesto_Prestupleniya_Srednevekovye_6,
            Mesto_Prestupleniya_Srednevekovye_7,
            Mesto_Prestupleniya_Srednevekovye_8,
            Mesto_Prestupleniya_Srednevekovye_9,
            Mesto_Prestupleniya_Srednevekovye_10,
        ],
    },
    {
        id: 38,
        title_ru: 'Дюна: Тайны Великих Домов',
        title_en: 'Dune: Secrets of the Great Houses',
        subtittle_ru: 'Восстановить справедливость на Арракисе',
        subtittle_en: 'Restore justice to Arrakis',
        description_ru:
            'Пустынная планета Арракис – единственный источник дорогостоящего вещества, известного как пряность. Хотя здесь процветают незаконная торговля и контрабанда, важность этой планеты нельзя переоценить – без пряности невозможны межзвёздные перелёты. И теперь, когда Арракис стал эпицентром противостояния двух Великих Домов, ставки необычайно высоки. Вопрос в том, кому достанется право владеть пряностью: амбициозным Харконненам или благородным Атрейдесам…',
        description_en:
            'The desert planet Arrakis is the only source of the expensive substance known as the spice. Although illegal trade and smuggling flourish here, the importance of this planet cannot be overestimated - interstellar travel is impossible without spice. And now that Arrakis has become the epicenter of the confrontation between the two Great Houses, the stakes are unusually high. The question is who will get the right to own the spice: the ambitious Harkonnen or the noble Atreides...',
        price: 3890,
        discountPercentage: 1.0,
        rating: 4,
        stock: 447,
        GameTime: [120, 180],
        age: [16],
        gamers: [1, 4],
        brand: 'GaGa Games',
        category_ru: [
            'Детективные игры',
            'Для одного',
            'Кооперативные игры',
            'Приключенческие игры',
        ],
        category_en: ['Detective games', 'For one', 'Co-op games', 'Adventure games'],
        thumbnail: duna_sekrety_velikih_domov,
        images: [
            duna_sekrety_velikih_domov_1,
            duna_sekrety_velikih_domov_2,
            duna_sekrety_velikih_domov_3,
            duna_sekrety_velikih_domov_4,
            duna_sekrety_velikih_domov_5,
            duna_sekrety_velikih_domov_6,
            duna_sekrety_velikih_domov_7,
            duna_sekrety_velikih_domov_8,
            duna_sekrety_velikih_domov_9,
            duna_sekrety_velikih_domov_10,
            duna_sekrety_velikih_domov_11,
            duna_sekrety_velikih_domov_12,
        ],
    },
    {
        id: 39,
        title_ru: 'Мистериум',
        title_en: 'Mystery',
        subtittle_ru: 'Пробуждение ваших экстрасенсорных способностей',
        subtittle_en: 'Awakening your psychic abilities',
        description_ru:
            'Эта игра посвящена сверхъестественному, тайнам и загадкам. Один из игроков берет на себя роль призрака - невинно убиенного и жаждущего восстановить справедливость. Остальные становятся экстрасенсами, которые пытаются помочь призраку найти своего истинного убийцу и обрести покой.',
        description_en:
            'This game is dedicated to the supernatural, secrets and mysteries. One of the players takes on the role of a ghost - innocently killed and eager to restore justice. The rest become psychics who try to help the ghost find its true killer and find peace.',
        price: 3500,
        discountPercentage: 1.0,
        rating: 3,
        stock: 0,
        GameTime: [40, 60],
        age: [10],
        gamers: [2, 7],
        brand: 'IGames',
        category_ru: ['Детективные игры', 'Логические игры', 'Кооперативные игры'],
        category_en: ['Detective games', 'Logic games', 'Cooperative games'],
        thumbnail: Mistrium,
        images: [
            Mistrium_1,
            Mistrium_2,
            Mistrium_3,
            Mistrium_4,
            Mistrium_5,
            Mistrium_6,
            Mistrium_7,
            Mistrium_8,
            Mistrium_9,
            Mistrium_10,
            Mistrium_11,
            Mistrium_12,
            Mistrium_13,
            Mistrium_14,
            Mistrium_15,
            Mistrium_16,
        ],
    },
    {
        id: 40,
        title_ru: 'Spycon',
        title_en: 'Spycon',
        subtittle_ru: 'Детективная командная игра для вечеринок',
        subtittle_en: 'Detective team game for parties',
        description_ru:
            'У любых профессиональных работников должны быть свои конференции – с лекциями, чаепитием и маскарадом! Чем суперагенты хуже? Да они же супер! Правда, вот незадача: приехав на конференцию Spycon, чтобы получить от своего агента засекреченную информацию, вы столкнулись с неожиданной проблемкой – все агенты переоделись в маскарадные костюмы, и понять, кто тут свой, а кто чужой – совершенно невозможно!',
        description_en:
            'Any professional workers should have their own conferences - with lectures, tea parties and a masquerade! Why are superagents worse? Yes, they are great! True, this is bad luck: having arrived at the Spycon conference in order to receive classified information from your agent, you are faced with an unexpected problem - all agents dressed in fancy dress, and it is completely impossible to understand who is here and who is a stranger!',
        price: 990,
        discountPercentage: 1.1,
        rating: 4,
        stock: 999,
        GameTime: [30],
        age: [12],
        gamers: [4, 10],
        brand: 'Hobby World',
        category_ru: ['Детективные игры', 'Логические игры', 'Кооперативные игры'],
        category_en: ['Detective games', 'Logic games', 'Cooperative games'],
        thumbnail: Spycon,
        images: [
            Spycon_1,
            Spycon_2,
            Spycon_3,
            Spycon_4,
            Spycon_5,
            Spycon_6,
            Spycon_7,
            Spycon_8,
            Spycon_9,
            Spycon_10,
            Spycon_11,
        ],
    },
    {
        id: 41,
        title_ru: 'Мортум: Средневековый детектив',
        title_en: 'Mortum: Medieval Detective',
        subtittle_ru: 'Тайны Организации',
        subtittle_en: 'Secrets of the Organization',
        description_ru:
            'Добро пожаловать в мир Мортума, загадочное место, напоминающее Восточную Европу средних веков. Но только такую, в которой мифические существа реальны, а магию видят не только объевшиеся спорыньи крестьяне. Мортум хранит множество тайн, однако тайная Организация собирается раскрыть их. Станьте её агентом и расследуйте сверхъестественные преступления вместе с друзьями!',
        description_en:
            'Welcome to the world of Mortum, a mysterious place reminiscent of Eastern Europe of the Middle Ages. But only one in which mythical creatures are real, and magic is seen not only by ergot-eating peasants. Mortum keeps many secrets, but the secret Organization is going to reveal them. Become her agent and investigate supernatural crimes with your friends!',
        price: 2750,
        discountPercentage: 1.0,
        rating: 4,
        stock: 2,
        GameTime: [100, 180],
        age: [12],
        gamers: [1, 5],
        brand: 'Lavka Games',
        category_ru: ['Детективные игры', 'Игры для компании', 'Кооперативные игры', 'Для одного'],
        category_en: ['Detective games', 'Games for the company', 'Cooperative games', 'For one'],
        thumbnail: Mortum,
        images: [Mortum_1, Mortum_2, Mortum_3],
    },
    {
        id: 42,
        title_ru: 'Детективные хроники: Фламандское завещание',
        title_en: 'Detective Chronicles: The Flemish Testament',
        subtittle_ru: 'Месть или воля судьбы?',
        subtittle_en: 'Revenge or will of fate?',
        description_ru:
            'Вы – стражи правопорядка процветающего коммерческого города Амстердам. Вам поручено расследовать дело господина Корнелиуса, главы торговой семьи Клусов, которого обнаружили мёртвым в своём кабинете загородного дома. Постарайтесь выяснить, что стало причиной смерти: месть, борьба за наследство или воля злого рока. Ах, да, забыли уточнить, на дворе XVII век, так что придётся распутывать преступление без современных средств расследования. Справитесь?',
        description_en:
            "You are the law enforcement officers of the thriving commercial city of Amsterdam. You are assigned to investigate the case of Mr. Cornelius, the head of the Klus trading family, who was found dead in his office in a country house. Try to find out what caused death: revenge, the struggle for an inheritance, or the will of evil fate. Oh yes, they forgot to clarify, it's the 17th century, so you have to unravel the crime without modern means of investigation. Can you handle it?",
        price: 690,
        discountPercentage: 1.0,
        rating: 5,
        stock: 111,
        GameTime: [60],
        age: [13],
        gamers: [1, 6],
        brand: 'dV Giochi',
        category_ru: ['Детективные игры', 'Квесты', 'Семейные', 'Для одного', 'Логические игры'],
        category_en: ['Detective games', 'Quests', 'Family games', 'For one', 'Logic games'],
        thumbnail: detektivnye_hroniki_flamandskoe_zaveschanie,
        images: [
            detektivnye_hroniki_flamandskoe_zaveschanie_1,
            detektivnye_hroniki_flamandskoe_zaveschanie_2,
            detektivnye_hroniki_flamandskoe_zaveschanie_3,
            detektivnye_hroniki_flamandskoe_zaveschanie_4,
            detektivnye_hroniki_flamandskoe_zaveschanie_5,
            detektivnye_hroniki_flamandskoe_zaveschanie_6,
            detektivnye_hroniki_flamandskoe_zaveschanie_7,
            detektivnye_hroniki_flamandskoe_zaveschanie_8,
            detektivnye_hroniki_flamandskoe_zaveschanie_9,
            detektivnye_hroniki_flamandskoe_zaveschanie_10,
        ],
    },
    {
        id: 43,
        title_ru: 'Смертельные материалы: Амнезия',
        title_en: 'Deadly Materials: Amnesia',
        subtittle_ru: 'Вспомнить и выжить',
        subtittle_en: 'Remember and survive',
        description_ru:
            'Недалёкое будущее. В мире была установлена новая система правосудия. Более жестокая. Более радикальная. Теперь, чтобы попасть в тюрьму, человек, переступивший черту закона, должен заслужить такое право: преступнику стирают память и запирают в особой комнате, полной загадок и ловушек. Только пройдя все испытания и оставшись в живых, он может рассчитывать на тюремный срок в безопасной камере.',
        description_en:
            "Near future. A new system of justice has been established in the world. More cruel. More radical. Now, in order to get into prison, a person who has crossed the line of the law must earn such a right: the criminal's memory is erased and locked in a special room full of mysteries and traps. Only after passing all the tests and surviving, he can count on a prison term in a safe cell.",
        price: 490,
        discountPercentage: 1.0,
        rating: 4,
        stock: 254,
        GameTime: [90],
        age: [18],
        gamers: [1, 6],
        brand: 'Magellan',
        category_ru: [
            'Детективные игры',
            'Квесты',
            'Кооперативные игры',
            'Для одного',
            'Игры для компании',
            'Логические игры',
            'Игры для взрослых',
        ],
        category_en: [
            'Detective games',
            'Quests',
            'Cooperative games',
            'For one',
            'Games for the company',
            'Logic games',
            'Games for adults',
        ],
        thumbnail: smertelnie_materialy,
        images: [
            smertelnie_materialy_1,
            smertelnie_materialy_2,
            smertelnie_materialy_3,
            smertelnie_materialy_4,
            smertelnie_materialy_5,
            smertelnie_materialy_6,
            smertelnie_materialy_7,
            smertelnie_materialy_8,
            smertelnie_materialy_9,
            smertelnie_materialy_10,
            smertelnie_materialy_11,
        ],
    },
    {
        id: 44,
        title_ru: 'Однажды в Чикаго',
        title_en: 'Once Upon a Time in Chicago',
        subtittle_ru: 'Гангстеры, бутлегеры, коррупция и контрабанда',
        subtittle_en: 'Gangsters, bootleggers, corruption and smuggling',
        description_ru:
            "Настольная игра 'Однажды в Чикаго' предлагает примерить на себя роль молодого журналиста Джона Фицпатрика, который пишет для известной газеты 'Чикаго трибьюн'. Несмотря на свою молодость, Джон уже успел сделать себе имя благодаря острому пытливому уму, что так помогает в журналистских расследованиях.",
        description_en:
            "The board game 'Once Upon a Time in Chicago' invites you to try on the role of young journalist John Fitzpatrick, who writes for the well-known newspaper 'Chicago Tribune'. Despite his youth, John has already managed to make a name for himself thanks to the sharp inquisitive mind that helps so much in investigative journalism.",
        price: 2690,
        discountPercentage: 1.0,
        rating: 5,
        stock: 19,
        GameTime: [75],
        age: [18],
        gamers: [1, 6],
        brand: 'Правильные Игры',
        category_ru: [
            'Детективные игры',
            'Для одного',
            'Игры для компании',
            'Приключенческие игры',
            'Логические игры',
            'Игры для взрослых',
        ],
        category_en: [
            'Detective games',
            'For one',
            'Games for the company',
            'Adventure games',
            'Logic games',
            'Games for adults',
        ],
        thumbnail: Odnajdi_V_Chikago,
        images: [Odnajdi_V_Chikago_1, Odnajdi_V_Chikago_2, Odnajdi_V_Chikago_3],
    },
    {
        id: 45,
        title_ru: 'Similo: Мифы',
        title_en: 'Similo: Myths',
        subtittle_ru: 'О богах и героях',
        subtittle_en: 'About Gods and Heroes',
        description_ru:
            "Зевс, Дионис, Ахиллес, Пандора, Минотавр и многие другие жаждут проверить вашу логику. 'Similo: Мифы' является полностью самостоятельной игрой, но её можно совместить с другими частями серии, чтобы сделать игровой процесс ещё более увлекательным.",
        description_en:
            "Zeus, Dionysus, Achilles, Pandora, Minotaur and many others are eager to test your logic. 'Similo: Myths' is a completely standalone game, but it can be combined with other parts of the series to make the gameplay even more fun.",
        price: 490,
        discountPercentage: 1.1,
        rating: 4,
        stock: 789,
        GameTime: [10],
        age: [8],
        gamers: [2, 8],
        brand: 'Horrible Games',
        category_ru: [
            'Детективные игры',
            'Кооперативные игры',
            'Карточные игры',
            'Игры для компании',
            'Логические игры',
            'Семейные',
        ],
        category_en: [
            'Detective games',
            'Cooperative games',
            'Card games',
            'Party games',
            'Logic games',
            'Family games',
        ],
        thumbnail: Similo_myths,
        images: [Similo_myths_1, Similo_myths_2, Similo_myths_3, Similo_myths_4, Similo_myths_5],
    },
    {
        id: 46,
        title_ru: 'Письма призрака: Почтовый ящик',
        title_en: 'Ghost Letters: Mailbox',
        subtittle_ru: 'Мы арестовали не того!',
        subtittle_en: 'We arrested the wrong one!',
        description_ru:
            'Вроде всё закончилось хорошо – убийца арестован, и теперь жители небольшого гостеприимного городка Сайдвуд могут спать спокойно. Следователь Ханна дописывала отчёт и уже собиралась выезжать в сторону дома, как неожиданно её отвлёк телефонный звонок. Это был Хопкинс, который попросил срочно приехать к дому убийцы. В подвале было обнаружено секретное помещение, сплошь заполненное различными фотографиями, газетами, записками и другими предметами, которые наталкивали на одну логичную мысль – здесь явно велось некое расследование. Но не мог же, в самом деле, преступник расследовать собственное преступление? А это значит, что арестован был не истинный убийца. Похоже, что придётся начинать расследование с самого начала, ведь опасность снова нависла над Сайдвудом!',
        description_en:
            "It seems that everything ended well - the killer was arrested, and now the inhabitants of the small hospitable town of Sidewood can sleep peacefully. Investigator Hanna was finishing the report and was about to leave towards the house, when suddenly she was distracted by a phone call. It was Hopkins, who asked to urgently come to the killer's house. A secret room was found in the basement, completely filled with various photographs, newspapers, notes and other items that suggested one logical thought - some kind of investigation was clearly being carried out here. But the criminal could not, in fact, investigate his own crime? And this means that it was not the true killer who was arrested. It looks like we'll have to start the investigation from the very beginning, because the danger has once again hung over Sidewood!",
        price: 990,
        discountPercentage: 1.0,
        rating: 3,
        stock: 100,
        GameTime: [30],
        age: [6],
        gamers: [2, 12],
        brand: 'Экономикус',
        category_ru: ['Детективные игры', 'Игры для компании', 'Семейные'],
        category_en: ['Detective games', 'Games for the company', 'Family games'],
        thumbnail: pochtoviy_yaschik,
        images: [
            pochtoviy_yaschik_1,
            pochtoviy_yaschik_2,
            pochtoviy_yaschik_3,
            pochtoviy_yaschik_4,
            pochtoviy_yaschik_5,
            pochtoviy_yaschik_6,
            pochtoviy_yaschik_7,
            pochtoviy_yaschik_8,
            pochtoviy_yaschik_9,
        ],
    },
    {
        id: 47,
        title_ru: 'Место преступления: Прекрасная эпоха',
        title_en: 'Crime Scene: Belle Epoque',
        subtittle_ru: 'Загадки Парижа начала XX века',
        subtittle_en: 'Mysteries of Paris at the beginning of the 20th century',
        description_ru:
            '1900 год, Париж. Дивный новый мир: открытие метро, Всемирная выставка, выступления суфражисток, летние Олимпийские игры – жизнь в столице Франции бурлит! Однако молодой журналист Виктор Лавель больше интересуется не всеми этими событиями прекрасной эпохи, а мрачными убийствами, таинственными похищениями и другими правонарушениями.',
        description_en:
            '1900, Paris. Brave new world: the opening of the metro, the World Exhibition, performances of suffragettes, the summer Olympics - life in the capital of France is seething! However, the young journalist Victor Lavelle is more interested not in all these events of the beautiful era, but in grim murders, mysterious kidnappings and other offenses.',
        price: 2490,
        discountPercentage: 1.0,
        rating: 4,
        stock: 101,
        GameTime: [60, 90],
        age: [18],
        gamers: [1, 4],
        brand: 'Lucky Duck Games',
        category_ru: [
            'Детективные игры',
            'Для двоих',
            'Для одного',
            'Игры для компании',
            'Логические игры',
            'Игры для взрослых',
        ],
        category_en: [
            'Detective games',
            'For two',
            'For one',
            'Games for the company',
            'Logic games',
            'Games for adults',
        ],
        thumbnail: Mesto_prestuplenia_Prekrasnaya_epokha,
        images: [
            Mesto_prestuplenia_Prekrasnaya_epokha_1,
            Mesto_prestuplenia_Prekrasnaya_epokha_2,
            Mesto_prestuplenia_Prekrasnaya_epokha_3,
            Mesto_prestuplenia_Prekrasnaya_epokha_4,
            Mesto_prestuplenia_Prekrasnaya_epokha_5,
            Mesto_prestuplenia_Prekrasnaya_epokha_6,
            Mesto_prestuplenia_Prekrasnaya_epokha_7,
            Mesto_prestuplenia_Prekrasnaya_epokha_8,
            Mesto_prestuplenia_Prekrasnaya_epokha_9,
        ],
    },
    {
        id: 48,
        title_ru: 'Уотергейт',
        title_en: 'Watergate',
        subtittle_ru: 'Политические дрязги',
        subtittle_en: 'Political squabbles',
        description_ru:
            'В 1972 году в вашингтонский комплекс Watergate проникли пятеро неизвестных с целью установить подслушивающие устройства. В те дни там располагался предвыборный штат кандидата в президенты Джорджа Макговерна. Их арестовали, а журналисты впоследствии занялись своим расследованием произошедшего. В результате их действий разгорелся крупный скандал, а Ричард Никсон, к тому времени уже переизбранный на второй президентский срок, подал в отставку.',
        description_en:
            'In 1972, five unidentified men infiltrated the Watergate complex in Washington in order to install listening devices. In those days, the campaign staff of presidential candidate George McGovern was located there. They were arrested, and journalists subsequently began their own investigation of what happened. As a result of their actions, a major scandal erupted, and Richard Nixon, by that time already re-elected for a second presidential term, resigned.',
        price: 2990,
        discountPercentage: 1.2,
        rating: 5,
        stock: 500,
        GameTime: [30, 60],
        age: [14],
        gamers: [2],
        brand: 'GaGa Games',
        category_ru: ['Детективные игры', 'Для двоих', 'Стратегические игры', 'Карточные игры'],
        category_en: ['Detective games', 'For two', 'Strategy games', 'Card games'],
        thumbnail: Uotergate,
        images: [Uotergate_1, Uotergate_2, Uotergate_3, Uotergate_4, Uotergate_5],
    },
    {
        id: 49,
        title_ru: 'Венский связной',
        title_en: 'Viennese connection',
        subtittle_ru: 'Жар холодной войны',
        subtittle_en: 'Heat of the Cold War',
        description_ru:
            "Начало 1977 года. Конфронтация сверхдержав с новой силой набирает обороты. Джеймс Вернер, военный в отставке, был найден убитым на окраине европейского города Вены. На месте преступления обнаружены обрывки карты, на которых отмечены координаты оружейных тайников, расположенных на территории ФРГ и Италии. Агенты, объявляется начало спецоперации 'Белая пчела'. Ваша миссия – выяснить, кто устранил Вернера и с какой целью были созданы тайники. Соблюдайте наивысшую осторожность, не исключено, что здесь поработали иностранные спецслужбы.",
        description_en:
            'Early 1977. The confrontation of the superpowers is gaining momentum with renewed vigor. James Werner, a retired military man, was found murdered on the outskirts of the European city of Vienna. Fragments of a map were found at the crime scene, on which the coordinates of weapons caches located on the territory of Germany and Italy are marked. Agents, the beginning of the White Bee special operation is announced. Your mission is to find out who eliminated Werner and for what purpose the caches were created. Exercise the utmost caution, it is possible that foreign intelligence agencies have worked here.',
        price: 4490,
        discountPercentage: 1.0,
        rating: 5,
        stock: 114,
        GameTime: [180],
        age: [16],
        gamers: [1, 5],
        brand: 'GaGa Games',
        category_ru: [
            'Детективные игры',
            'Для двоих',
            'Кооперативные игры',
            'Игры для компании',
            'Логические игры',
        ],
        category_en: [
            'Detective games',
            'For two',
            'Cooperative games',
            'Games for the company',
            'Logic games',
        ],
        thumbnail: Venskiy_Svyaznoi,
        images: [
            Venskiy_Svyaznoi_1,
            Venskiy_Svyaznoi_2,
            Venskiy_Svyaznoi_3,
            Venskiy_Svyaznoi_4,
            Venskiy_Svyaznoi_5,
        ],
    },
    {
        id: 50,
        title_ru: 'Следствие: Ведёт Клэр Харпер',
        title_en: 'Corollary: Hosted by Claire Harper',
        subtittle_ru: 'Три невероятных расследования',
        subtittle_en: 'Three Incredible Investigations',
        description_ru:
            'Легендарная Клэр Харпер, сошедшая будто бы со страниц очередного остросюжетного детектива Агаты Кристи, ищёт помощников, чтобы разобраться в нескольких запутанных делах. Помогите ей докопаться до истины: изучайте улики, опрашивайте свидетелей и выдвигайте свои гипотезы. Кто убил всеобщую любимицу Мэри Аллистер, почему декорации обрушились на голову актёра и зачем рядом с убитым в Египте археологом преступник выложил ряд из трёх предметов?',
        description_en:
            "The legendary Claire Harper, who seems to have descended from the pages of another action-packed detective by Agatha Christie, is looking for assistants to sort out several complicated cases. Help her get to the bottom of the truth: study the evidence, interview witnesses and put forward your hypotheses. Who killed everyone's favorite Mary Allister, why did the scenery fall on the actor's head, and why did the criminal lay out a row of three objects next to the archaeologist killed in Egypt?",
        price: 2590,
        discountPercentage: 1.1,
        rating: 4,
        stock: 304,
        GameTime: [90],
        age: [10],
        gamers: [1, 6],
        brand: 'Эврикус',
        category_ru: ['Детективные игры', 'Для одного', 'Кооперативные игры', 'Игры для компании'],
        category_en: ['Detective games', 'For one', 'Cooperative games', 'Games for the company'],
        thumbnail: Sledstvie,
        images: [Sledstvie_1, Sledstvie_2, Sledstvie_3, Sledstvie_4],
    },
    {
        id: 51,
        title_ru: 'Сопротивление',
        title_en: 'Resistance',
        subtittle_ru: 'Движение против потока',
        subtittle_en: 'Going against the flow',
        description_ru:
            'Нет предела вседозволенности властей. Улицы полны сброда и нищеты. Наместники прогнили в коррупции и власти, а средства массовой информации обманывают население. Канавы заполнены кровью и человеческими жизнями. Над головой летают беспилотные дроны наружного наблюдения, бедняки влачат свой жалкий век по темным углам, а простые обыватели отводят глаза, делая вид, что ничего не замечают. ',
        description_en:
            'There is no limit to the permissiveness of the authorities. The streets are full of rabble and poverty. The governors are rotten in corruption and power, and the mass media are deceiving the population. The ditches are filled with blood and human lives. Unmanned surveillance drones fly overhead, the poor drag their miserable lives in dark corners, and ordinary people avert their eyes, pretending not to notice anything.',
        price: 990,
        discountPercentage: 1.0,
        rating: 3,
        stock: 0,
        GameTime: [30],
        age: [13],
        gamers: [5, 10],
        brand: 'Magellan',
        category_ru: [
            'Кооперативные игры',
            'Игры для компании',
            'Мафия',
            'Игры в дорогу',
            'Карточные игры',
        ],
        category_en: [
            'Team games',
            'Games for the company',
            'Party games',
            'Mafia',
            'Games on the road',
            'Card games',
        ],
        thumbnail: Soprotivlenie,
        images: [
            Soprotivlenie_1,
            Soprotivlenie_2,
            Soprotivlenie_3,
            Soprotivlenie_4,
            Soprotivlenie_5,
            Soprotivlenie_6,
            Soprotivlenie_7,
            Soprotivlenie_8,
            Soprotivlenie_9,
            Soprotivlenie_10,
            Soprotivlenie_11,
        ],
    },
    {
        id: 52,
        title_ru: 'Боги Олимпа',
        title_en: 'The gods of Olympus',
        subtittle_ru: 'Интриги титанидов',
        subtittle_en: 'Titanide intrigues',
        description_ru:
            'Боги правят Ойкуменой... Никто не в силах противостоять их мощи и гневу: олимпийцы сокрушили титанов, гекатонхейров и уничтожат любого другого, кто осмелится бросить вызов их власти. Но всё же и у них есть достойные соперники – ведь в борьбе за престол они противостоят друг другу. Жаль, что при всём их могуществе, боги отнюдь не добры, милосердны и справедливы: их направляют всё те же гнев, зависть и злоба, что губят людей. Жажда власти стравила титанидов между собой – кто же станет править всеми?',
        description_en:
            'The gods rule Oikumene... No one is able to resist their power and wrath: the Olympians crushed the titans, hecatoncheirs and will destroy anyone else who dares to challenge their power. But still, they also have worthy rivals - after all, in the struggle for the throne they oppose each other. It is a pity that with all their might, the gods are by no means kind, merciful and fair: they are directed by the same anger, envy and malice that destroy people. The thirst for power pitted the Titanides against each other - who will rule them all?',
        price: 2990,
        discountPercentage: 1.0,
        rating: 4,
        stock: 777,
        GameTime: [20],
        age: [12],
        gamers: [2, 4],
        brand: 'Magellan',
        category_ru: [
            'Кооперативные игры',
            'Для двоих',
            'Стратегические игры',
            'Дуэльные',
            'Логические игры',
        ],
        category_en: [
            'Team games',
            'Games for the company',
            'Party games',
            'Mafia',
            'Games on the road',
            'Card games',
        ],
        thumbnail: Bogy_Olimpa,
        images: [
            Bogy_Olimpa_1,
            Bogy_Olimpa_2,
            Bogy_Olimpa_3,
            Bogy_Olimpa_4,
            Bogy_Olimpa_5,
            Bogy_Olimpa_6,
            Bogy_Olimpa_7,
            Bogy_Olimpa_8,
            Bogy_Olimpa_9,
        ],
    },
    {
        id: 53,
        title_ru: 'Бэнг! Звёздные Войны',
        title_en: 'Bang! Star Wars',
        subtittle_ru: 'Перестрелка в Далёкой Галактике',
        subtittle_en: 'Gunfight in a Galaxy Far Away',
        description_ru:
            "Встречайте популярный настольный спагетти-вестерн 'Бэнг!', который теперь даст поклонникам легендарной вселенной 'Звёздных Войн' примерить на себя роли героев оригинальной кинотрилогии и от души пострелять в масштабах галактики. Общий сюжет остался неизменным: повстанцы, как всегда, противостоят империи, а кто возьмёт верх, зависит непосредственно от участников игры. Главная 'фишка' данного издания – новая игровая механика под названием 'Встреча с судьбой'.",
        description_en:
            "Meet the popular tabletop spaghetti western 'Bang!', which will now allow fans of the legendary Star Wars universe to try on the roles of the heroes of the original movie trilogy and shoot from the heart on a galaxy scale. The general plot has remained unchanged: the rebels, as always, oppose the empire, and who will prevail depends directly on the participants in the game. The main 'trick' of this edition is a new game mechanic called 'Meeting with Fate'.",
        price: 1290,
        discountPercentage: 1.0,
        rating: 5,
        stock: 15,
        GameTime: [20, 40],
        age: [12],
        gamers: [4, 7],
        brand: 'Hobby World',
        category_ru: ['Кооперативные игры', 'Игры для компании', 'Игры в дорогу', 'Карточные игры'],
        category_en: [
            'Team games',
            'Games for the company',
            'Party games',
            'Games on the road',
            'Card games',
        ],
        thumbnail: Bang_Star_Wars,
        images: [
            Bang_Star_Wars_1,
            Bang_Star_Wars_2,
            Bang_Star_Wars_3,
            Bang_Star_Wars_4,
            Bang_Star_Wars_5,
            Bang_Star_Wars_6,
            Bang_Star_Wars_7,
            Bang_Star_Wars_8,
            Bang_Star_Wars_9,
        ],
    },
    {
        id: 54,
        title_ru: 'Гравити Фолз: Битва воспоминаний',
        title_en: 'Gravity Falls: Battle of Memories',
        subtittle_ru: 'Фотоальбом Мэйбл',
        subtittle_en: "Mabel's photo album",
        description_ru:
            'Лето в Гравити Фолз подошло к концу. Диппер и Мэйбл вернулись домой, чтобы вновь отправиться в школу. Но тёплые воспоминания о невероятных приключениях они привезли с собой, ведь Мэйбл запечатлела на фотографиях всех друзей!',
        description_en:
            'Summer in Gravity Falls has come to an end. Dipper and Mabel returned home to go back to school. But they brought warm memories of incredible adventures with them, because Mabel captured all her friends in the photos!',
        price: 390,
        discountPercentage: 1.0,
        rating: 4,
        stock: 78,
        GameTime: [20, 30],
        age: [5],
        gamers: [2, 4],
        brand: 'Hobby World',
        category_ru: ['Кооперативные игры', 'Карточные игры', 'Детские игры', 'Семейные'],
        category_en: ['Team Games', 'Card Games', 'Kids Games', 'Family Games'],
        thumbnail: Gravity_Falls_Memory,
        images: [Gravity_Falls_Memory_1, Gravity_Falls_Memory_2, Gravity_Falls_Memory_3],
    },
    {
        id: 55,
        title_ru: 'Кросмастер: Арена 2.0',
        title_en: 'Krosmaster: Arena 2.0',
        subtittle_ru: 'Соберите команду и устройте поединок!',
        subtittle_en: 'Gather a team and arrange a duel!',
        description_ru:
            'В параллельном измерении, которое скрыто от посторонних глаз в изгибах пространства и времени, живут Демоны Часов и Минут. Они нашли себе новое развлечение – Арену! На этой Арене разыгрываются сражения героев. А воинов Демоны Часов собирают по всей вселенной, отбирая самых лучших. Попавшие в плен гладиаторы вынуждены биться не на жизнь, а на смерть, чтобы вернуть себе свои души.',
        description_en:
            'In a parallel dimension, which is hidden from prying eyes in the bends of space and time, the Demons of Hours and Minutes live. They found a new entertainment for themselves - the Arena! On this Arena battles of heroes are played out. And the Demons of the Clock gather warriors throughout the universe, selecting the very best. Captured gladiators are forced to fight not for life, but for death, in order to regain their souls.',
        price: 6490,
        discountPercentage: 1.5,
        rating: 4,
        stock: 89,
        GameTime: [30, 45],
        age: [12],
        gamers: [2, 4],
        brand: 'Фабрика игр',
        category_ru: ['Кооперативные игры', 'Стратегические игры', 'Для двоих', 'Дуэльные'],
        category_en: ['Team games', 'Strategy games', 'For two', 'Duel'],
        thumbnail: krosmaster_arena,
        images: [
            krosmaster_arena_1,
            krosmaster_arena_2,
            krosmaster_arena_3,
            krosmaster_arena_4,
            krosmaster_arena_5,
            krosmaster_arena_6,
            krosmaster_arena_7,
            krosmaster_arena_8,
            krosmaster_arena_9,
            krosmaster_arena_10,
            krosmaster_arena_11,
            krosmaster_arena_12,
            krosmaster_arena_13,
        ],
    },
    {
        id: 56,
        title_ru: 'Активити Тревл',
        title_en: 'Activity Travel',
        subtittle_ru: 'Любимой игре дорога не помеха!',
        subtittle_en: 'Favorite game the road is not a hindrance!',
        description_ru:
            'Activity Travel – это оптимальная версия популярной игры, которою легко взять с собой, куда бы вы ни пошли. Теперь можно не расставаться с любимой игрой в путешествии на автомобиле, поездке на поезде, или в отпуске! В игре могут принимать участие 2, 3 или 4 команды.',
        description_en:
            "Activity Travel is the ultimate version of the popular game that's easy to take with you wherever you go. Now you can not part with your favorite game while traveling by car, train ride, or on vacation! The game can be played by 2, 3 or 4 teams.",
        price: 990,
        discountPercentage: 1.1,
        rating: 3,
        stock: 345,
        GameTime: [],
        age: [8],
        gamers: [3, 99],
        brand: 'Piatnik',
        category_ru: ['Кооперативные игры', 'Игры для компании', 'Игры в дорогу', 'Семейные'],
        category_en: [
            'Team games',
            'Games for the company',
            'Games on the road',
            'Party games',
            'Family games',
        ],
        thumbnail: Activity_Travel,
        images: [
            Activity_Travel_1,
            Activity_Travel_2,
            Activity_Travel_3,
            Activity_Travel_4,
            Activity_Travel_5,
            Activity_Travel_6,
            Activity_Travel_7,
            Activity_Travel_8,
        ],
    },
    {
        id: 57,
        title_ru: 'Властелин колец: Странствия в Средиземье',
        title_en: 'The Lord of the Rings: Travels in Middle-earth',
        subtittle_ru: 'Испытайте свою судьбу',
        subtittle_en: 'Test your fate',
        description_ru:
            "Когда-то Бильбо Беггинс предостерёг: 'Опасное это дело, Фродо, выходить за порог: стоит ступить на дорогу и, если дашь волю ногам, неизвестно куда тебя занесет'. Но разве герои баллад и легендарные приключенцы сами того хотели?",
        description_en:
            "Once Bilbo Baggins warned: 'It's a dangerous business, Frodo, to go beyond the threshold: it is worth stepping on the road and, if you give free rein to your feet, no one knows where you will be brought'. But did the heroes of ballads and legendary adventurers themselves want this?",
        price: 8990,
        discountPercentage: 1.1,
        rating: 4,
        stock: 56,
        GameTime: [60],
        age: [13],
        gamers: [1, 5],
        brand: 'Hobby World',
        category_ru: [
            'Кооперативные игры',
            'Для двоих',
            'Для одного',
            'Приключенческие игры',
            'Хардкорные игры',
            'Игры для компании',
        ],
        category_en: [
            'Co-op games',
            'For two',
            'For one',
            'Adventure games',
            'Hardcore games',
            'Games for the company',
        ],
        thumbnail: LotR_journey_in_middle_earth,
        images: [
            LotR_journey_in_middle_earth_1,
            LotR_journey_in_middle_earth_2,
            LotR_journey_in_middle_earth_3,
            LotR_journey_in_middle_earth_4,
            LotR_journey_in_middle_earth_5,
            LotR_journey_in_middle_earth_6,
            LotR_journey_in_middle_earth_7,
            LotR_journey_in_middle_earth_8,
            LotR_journey_in_middle_earth_9,
            LotR_journey_in_middle_earth_10,
            LotR_journey_in_middle_earth_11,
        ],
    },
    {
        id: 58,
        title_ru: 'Descent: Сказания тьмы',
        title_en: 'Descent: Tales of Darkness',
        subtittle_ru: 'Терринот в опасности!',
        subtittle_en: 'Terrinoth is in danger!',
        description_ru:
            'Терринот в беде! Одержимые демонами варвары вторглись в королевство, разрушая всё на своём пути, убивая и грабя, а в Туманных землях из могил встают всё новые и новые орды нежити, ведёт которых сам Вайкар Бессмертный.',
        description_en:
            'Terrinoth is in trouble! Demon-possessed barbarians invaded the kingdom, destroying everything in their path, killing and plundering, and in the Misty Lands more and more undead hordes rise from their graves, led by Vaykar the Immortal himself.',
        price: 14990,
        discountPercentage: 1.0,
        rating: 5,
        stock: 16,
        GameTime: [180, 240],
        age: [13],
        gamers: [1, 4],
        brand: 'Fantasy Flight Games',
        category_ru: ['Кооперативные игры', 'Хардкорные игры', 'Приключенческие игры'],
        category_en: ['Co-op Games', 'Hardcore Games', 'Adventure Games'],
        thumbnail: descent_legends_of_the_dark,
        images: [
            descent_legends_of_the_dark_1,
            descent_legends_of_the_dark_2,
            descent_legends_of_the_dark_3,
            descent_legends_of_the_dark_4,
            descent_legends_of_the_dark_5,
        ],
    },
    {
        id: 59,
        title_ru: 'Особняки безумия. Вторая редакция',
        title_en: 'Mansions of Madness. Second edition',
        subtittle_ru: 'Никто не выйдет',
        subtittle_en: 'Nobody will come out',
        description_ru:
            'Приехав в Аркхэм и добравшись по грязным переулкам до особняков, вы сразу понимаете, что они покинуты и привычных обитателей внутри точно нет. Дома явно покидали в спешке... Вы также чувствуете напряжённость и ощущение чего-то потустороннего, опасного и необъяснимого. Сыщики без работы не останутся точно.',
        description_en:
            'Arriving in Arkham and getting through the dirty alleys to the mansions, you immediately understand that they are abandoned and there are definitely no habitual inhabitants inside. Houses were obviously left in a hurry ... You also feel tension and a sense of something otherworldly, dangerous and inexplicable. Detectives will not remain without work for sure.',
        price: 8990,
        discountPercentage: 1.5,
        rating: 4,
        stock: 346,
        GameTime: [120, 180],
        age: [13],
        gamers: [1, 4],
        brand: 'Fantasy Flight Games',
        category_ru: [
            'Кооперативные игры',
            'Для одного',
            'Приключенческие игры',
            'Игры для компании',
        ],
        category_en: ['Co-op games', 'For one', 'Adventure games', 'Games for the company'],
        thumbnail: Mansions_of_Madness_box,
        images: [
            Mansions_of_Madness_box_1,
            Mansions_of_Madness_box_2,
            Mansions_of_Madness_box_3,
            Mansions_of_Madness_box_4,
            Mansions_of_Madness_box_5,
        ],
    },
    {
        id: 60,
        title_ru: 'Зомбицид. Вторая редакция',
        title_en: 'Zombicide. Second edition',
        subtittle_ru: 'Ходячие мертвецы возвращаются!',
        subtittle_en: 'The walking dead are back!',
        description_ru:
            "Любите 'Ходячих мертвецов'? Интересуетесь зомби-апокалипсисом – фантастическим сценарием всемирной катастрофы, в котором большая часть населения планеты превратилась в живых трупов? Знакомы с работами Джорджа Ромеро, а Evil Dead вызывает у вас приятные мурашки на коже? Тогда эта игра для вас, и лучше варианта вы просто не найдёте!",
        description_en:
            "Love The Walking Dead? Are you interested in the zombie apocalypse - a fantastic scenario of a worldwide catastrophe in which most of the world's population turned into living corpses? Familiar with the work of George Romero, and Evil Dead gives you pleasant goosebumps? Then this game is for you, and you simply won't find a better option!",
        price: 9990,
        discountPercentage: 1.0,
        rating: 5,
        stock: 0,
        GameTime: [60],
        age: [18],
        gamers: [1, 6],
        brand: 'CMON',
        category_ru: ['Кооперативные игры', 'Для двоих', 'Приключенческие игры', 'Хардкорные игры'],
        category_en: ['Co-op games', 'For two', 'Adventure games', 'Hardcore games'],
        thumbnail: Zombicide_2ed,
        images: [
            Zombicide_2ed_1,
            Zombicide_2ed_2,
            Zombicide_2ed_3,
            Zombicide_2ed_4,
            Zombicide_2ed_5,
        ],
    },
    {
        id: 61,
        title_ru: 'Pathfinder. Карточная игра.',
        title_en: 'Pathfinder. Card game.',
        subtittle_ru: 'Ваше приключение начинается!',
        subtittle_en: 'Your adventure begins!',
        description_ru:
            'Сопровождая караван, едущий через Вердуранский лес, вы попадаете в славный городок Бельхейм, основанный тысячелетие назад. И надо же было так совпасть, что именно в это время начинают происходить таинственные и тревожные события...',
        description_en:
            'Accompanying a caravan traveling through the Verduran forest, you find yourself in the glorious town of Belheim, founded a millennium ago. And it was necessary to coincide so that it was at this time that mysterious and disturbing events begin to occur ...',
        price: 4990,
        discountPercentage: 1.0,
        rating: 4,
        stock: 157,
        GameTime: [90],
        age: [13],
        gamers: [1, 4],
        brand: 'Paizo',
        category_ru: [
            'Кооперативные игры',
            'Для двоих',
            'Приключенческие игры',
            'Хардкорные игры',
            'Карточные игры',
            'Для двоих',
        ],
        category_en: [
            'Co-op games',
            'For two',
            'Adventure games',
            'Hardcore games',
            'Card games',
            'For two',
        ],
        thumbnail: Pathfinder_CG_base,
        images: [
            Pathfinder_CG_base_1,
            Pathfinder_CG_base_2,
            Pathfinder_CG_base_3,
            Pathfinder_CG_base_4,
            Pathfinder_CG_base_5,
            Pathfinder_CG_base_6,
            Pathfinder_CG_base_7,
            Pathfinder_CG_base_8,
            Pathfinder_CG_base_9,
            Pathfinder_CG_base_10,
            Pathfinder_CG_base_11,
            Pathfinder_CG_base_12,
            Pathfinder_CG_base_13,
            Pathfinder_CG_base_14,
        ],
    },
    {
        id: 62,
        title_ru: 'Зомби в доме: Заражение',
        title_en: 'Zombies in the House: Contagion',
        subtittle_ru: 'Спаситесь от ходячих мертвецов!',
        subtittle_en: 'Save yourself from the walking dead!',
        description_ru:
            'Стандартная завязка: заброшенная хижина в глухом лесу, в котором вы застряли. Уже понятно, что к чему, не так ли? Стоило бы пройти мимо, но вы с друзьями зашли осмотреться – и теперь так просто отсюда не выйдете, ведь вас окружили голодные зомби. Спасение утопающих – дело рук самих утопающих, так что хватайте топор и крошите злобных мертвецов на мелкие кусочки.',
        description_en:
            'Standard premise: an abandoned cabin in the deep forest where you are stuck. It’s already clear what’s what, isn’t it? It would be worth passing by, but you and your friends went to look around - and now you won’t get out of here so easily, because you are surrounded by hungry zombies. Saving the drowning is the work of the drowning themselves, so grab an ax and crush the evil dead into small pieces.',
        price: 2990,
        discountPercentage: 1.0,
        rating: 5,
        stock: 44,
        GameTime: [40, 60],
        age: [12],
        gamers: [2, 4],
        brand: 'Magellan',
        category_ru: [
            'Кооперативные игры',
            'Семейные',
            'Приключенческие игры',
            'Игры для компании',
        ],
        category_en: ['Co-op Games', 'Family Games', 'Adventure Games', 'Company Games'],
        thumbnail: Zomby_V_Dome_Zarajenie,
        images: [
            Zomby_V_Dome_Zarajenie_1,
            Zomby_V_Dome_Zarajenie_2,
            Zomby_V_Dome_Zarajenie_3,
            Zomby_V_Dome_Zarajenie_4,
            Zomby_V_Dome_Zarajenie_5,
            Zomby_V_Dome_Zarajenie_6,
            Zomby_V_Dome_Zarajenie_7,
            Zomby_V_Dome_Zarajenie_8,
            Zomby_V_Dome_Zarajenie_9,
            Zomby_V_Dome_Zarajenie_10,
            Zomby_V_Dome_Zarajenie_11,
        ],
    },
    {
        id: 63,
        title_ru: 'Остров духов',
        title_en: 'Spirit island',
        subtittle_ru: 'Колонистам здесь не рады',
        subtittle_en: 'Colonists are not welcome here',
        description_ru:
            'Давайте перенесёмся в дальние края далёкого мира, где ещё существует множество неизведанных земель и есть силы, неподвластные человеку. Представьте, что мы летим над бескрайним океаном и спускаемся ниже лишь тогда, когда натыкаемся на остров, где люди ещё живут в полной гармонии с природой. Вы – дух природы, который этому способствует и охраняет этот нетронутый рай.',
        description_en:
            "Let's move to the distant lands of a distant world, where there are still many unexplored lands and there are forces beyond the control of man. Imagine that we are flying over the boundless ocean and descend only when we stumble upon an island where people still live in complete harmony with nature. You are the spirit of nature, who contributes to this and guards this untouched paradise.",
        price: 7490,
        discountPercentage: 1.0,
        rating: 4,
        stock: 21,
        GameTime: [90, 120],
        age: [13],
        gamers: [1, 4],
        brand: 'Greater Than Games',
        category_ru: ['Кооперативные игры', 'Стратегические игры', 'Для одного', 'Хардкорные игры'],
        category_en: ['Co-op Games', 'Strategy Games', 'Single Player', 'Hardcore Games'],
        thumbnail: Ostrov_duhov,
        images: [Ostrov_duhov_1, Ostrov_duhov_2, Ostrov_duhov_3, Ostrov_duhov_4],
    },
    {
        id: 64,
        title_ru: 'Мор (Утопия)',
        title_en: 'Pestilence (Utopia)',
        subtittle_ru: 'По мотивам одноимённой компьютерной игры',
        subtittle_en: 'Based on the computer game of the same name',
        description_ru:
            'Смертоносное поветрие охватило загадочный городок: беспощадная Чума расползается подобно плесени. Она как будто обладает собственным разумом, обходя самые, казалось бы, надёжные средства защиты. Печальная участь местных жителей, очевидно, предрешена... Слабый луч надежды появляется лишь тогда, когда в городе находится троица заезжих смельчаков, которые, как уверяют, единственные знают способ побороть Песочную Язву. Учёный-бакалавр Даниил, потомок знахаря Гаруспик и блаженная Самозванка могут спасти город, но вот пути спасения их, к сожалению, несовместимы. На какие компромиссы им под силу пойти во имя общей благой цели?',
        description_en:
            'A deadly plague has gripped the mysterious town: the merciless Plague is spreading like mold. She seems to have her own mind, bypassing the most seemingly reliable means of protection. The sad fate of the locals is obviously a foregone conclusion... A faint ray of hope appears only when there is a trio of visiting daredevils in the city, who, as they say, are the only ones who know the way to overcome the Sand Plague. The bachelor-scientist Daniil, the descendant of the sorcerer Haruspex and the blessed Pretender can save the city, but, unfortunately, their ways of saving are incompatible. What compromises can they make in the name of a common good goal?',
        price: 2990,
        discountPercentage: 1.2,
        rating: 5,
        stock: 156,
        GameTime: [40, 80],
        age: [16],
        gamers: [2, 4],
        brand: 'Фабрика игр',
        category_ru: [
            'Кооперативные игры',
            'Стратегические игры',
            'Игры для взрослых',
            'Игры для компании',
            'Приключенческие игры',
        ],
        category_en: [
            'Co-op Games',
            'Strategy Games',
            'Adult Games',
            'Company Games',
            'Adventure Games',
        ],
        thumbnail: Mor_Utopia,
        images: [
            Mor_Utopia_1,
            Mor_Utopia_2,
            Mor_Utopia_3,
            Mor_Utopia_4,
            Mor_Utopia_5,
            Mor_Utopia_6,
            Mor_Utopia_7,
            Mor_Utopia_8,
            Mor_Utopia_9,
            Mor_Utopia_10,
            Mor_Utopia_11,
            Mor_Utopia_12,
            Mor_Utopia_13,
        ],
    },
    {
        id: 65,
        title_ru: 'Робинзон Крузо. Вторая редакция: Приключения на таинственном острове',
        title_en: 'Robinson Crusoe. Second Edition: Mystery Island Adventures',
        subtittle_ru: 'Выживание – не самое главное!',
        subtittle_en: 'Survival is not the most important thing!',
        description_ru:
            "'Робинзон Крузо: Приключения на таинственном острове. Вторая редакция' – это кооперативная настольная игра, в которой одному игроку или команде до четырёх человек предстоит превозмогать тяжести жизни на необитаемом острове, всеми силами выживать, разгадывать тайны и пройти все семь сценариев, каждый из которых предложит уникальный игровой процесс. Сценарии можно объединить в большое приключение-кампанию, тогда ваше путешествие в мир игры станет ещё увлекательнее!",
        description_en:
            "'Robinson Crusoe: Adventures on a mysterious island. Second Edition' is a cooperative board game in which one player or a team of up to four people will have to overcome the hardships of life on a desert island, survive with all their might, solve mysteries and go through all seven scenarios, each of which will offer a unique gameplay. Scenarios can be combined into a large adventure-campaign, then your journey into the game world will become even more exciting!",
        price: 4990,
        discountPercentage: 1.0,
        rating: 1,
        stock: 0,
        GameTime: [60, 120],
        age: [12],
        gamers: [1, 4],
        brand: 'Portal Games',
        category_ru: [
            'Кооперативные игры',
            'Приключенческие игры',
            'Для двоих',
            'Для одного',
            'Хардкорные игры',
            'Экономические',
        ],
        category_en: [
            'Co-op games',
            'Adventure games',
            'For two',
            'For one',
            'Hardcore games',
            'Economic',
        ],
        thumbnail: Robinzon_Kruzo_Vtoraya_Redakciya,
        images: [
            Robinzon_Kruzo_Vtoraya_Redakciya_1,
            Robinzon_Kruzo_Vtoraya_Redakciya_2,
            Robinzon_Kruzo_Vtoraya_Redakciya_3,
            Robinzon_Kruzo_Vtoraya_Redakciya_4,
            Robinzon_Kruzo_Vtoraya_Redakciya_5,
            Robinzon_Kruzo_Vtoraya_Redakciya_6,
            Robinzon_Kruzo_Vtoraya_Redakciya_7,
            Robinzon_Kruzo_Vtoraya_Redakciya_8,
            Robinzon_Kruzo_Vtoraya_Redakciya_9,
            Robinzon_Kruzo_Vtoraya_Redakciya_10,
            Robinzon_Kruzo_Vtoraya_Redakciya_11,
        ],
    },
    {
        id: 66,
        title_ru: 'Fallout: Атомные узы',
        title_en: 'Fallout: Atomic Bond',
        subtittle_ru: 'Если с другом вышел в путь...',
        subtittle_en: 'If you went out with a friend...',
        description_ru:
            'Радиоактивная пустошь – безлюдное место, которое принадлежит монстрам и мутантам, где опасности и проблемы выживания ожидают одиноких путников за каждым углом. Исследовать постапокалиптическую Америку в одиночку всегда было опасно, поэтому боевые соратники и надёжные напарники ценнее любой пушки и брони. Товарищи по оружию или несчастью всегда прикроют твою спину от облучённого Гуля или смертоносного Когтя Смерти. Путешествуйте и выживайте с верными друзьями, ведь вместе всё становится лучше и проще!',
        description_en:
            'The radioactive wasteland is a deserted place that belongs to monsters and mutants, where dangers and survival problems await lonely travelers around every corner. Exploring post-apocalyptic America alone has always been dangerous, so fighting companions and reliable partners are more valuable than any gun and armor. Comrades in arms or misfortune will always have your back against an irradiated Ghoul or a deadly Deathclaw. Travel and survive with true friends, because together everything becomes better and easier!',
        price: 990,
        discountPercentage: 1.0,
        rating: 4,
        stock: 178,
        GameTime: [120, 180],
        age: [13],
        gamers: [1, 4],
        brand: 'Fantasy Flight Games',
        category_ru: ['Кооперативные игры', 'Приключенческие игры'],
        category_en: ['Co-op Games', 'Adventure Games'],
        thumbnail: Fallout_Atomic_Bonds,
        images: [
            Fallout_Atomic_Bonds_1,
            Fallout_Atomic_Bonds_2,
            Fallout_Atomic_Bonds_3,
            Fallout_Atomic_Bonds_4,
            Fallout_Atomic_Bonds_5,
            Fallout_Atomic_Bonds_6,
            Fallout_Atomic_Bonds_7,
        ],
    },
    {
        id: 67,
        title_ru: 'Немезида: Кошмары',
        title_en: 'Nemesis: Nightmares',
        subtittle_ru: 'Не поддайтесь безумию!',
        subtittle_en: "Don't give in to the madness!",
        description_ru:
            'У каждого космического корабля есть свой голос, мелодия механизмов и подсистем, которую экипаж выучивает наизусть во время долгих путешествий. Проблема в том, что с момента последней миссии наш корабль звучит как-то неправильно, что ли. Среди привычных звуков мы иногда различаем нечто странное – шёпот, который не могла издать ни одна машина. Порой кажется, что в тёмных коридорах и огромных залах слышится едва уловимое пение.',
        description_en:
            'Each spacecraft has its own voice, a melody of mechanisms and subsystems, which the crew learns by heart during long journeys. The problem is that since the last mission, our ship has been sounding wrong, or something. Among the usual sounds, we sometimes distinguish something strange - a whisper that no machine could publish. Sometimes it seems that in the dark corridors and huge halls a barely perceptible singing is heard.',
        price: 6990,
        discountPercentage: 1.0,
        rating: 5,
        stock: 68,
        GameTime: [60, 180],
        age: [13],
        gamers: [1, 5],
        brand: 'Rebel',
        category_ru: [
            'Кооперативные игры',
            'Полукооперативные игры',
            'Хардкорные игры',
            'Игры для компании',
        ],
        category_en: ['Co-op games', 'Semi-cooperative games', 'Hardcore games', 'Company games'],
        thumbnail: Nemesida_Voidseeders,
        images: [
            Nemesida_Voidseeders_1,
            Nemesida_Voidseeders_2,
            Nemesida_Voidseeders_3,
            Nemesida_Voidseeders_4,
            Nemesida_Voidseeders_5,
            Nemesida_Voidseeders_6,
            Nemesida_Voidseeders_7,
            Nemesida_Voidseeders_8,
        ],
    },
    {
        id: 68,
        title_ru: 'Чужая планета',
        title_en: 'Alien planet',
        subtittle_ru: 'Триллер об ужасе глубокого космоса',
        subtittle_en: 'Thriller about the horror of deep space',
        description_ru:
            "'Чужая Планета' – классический триллер об ужасе глубокого космоса, облаченный в мантию асимметричной карточной игры. Возьмите на себя роль Существа, которое пытается ассимилировать застрявших на планете ученых, или же путешественника. что пытается выжить и дождаться прибытия спасательной капсулы.",
        description_en:
            'Alien Planet is a classic deep space horror thriller dressed in the mantle of an asymmetrical card game. Take on the role of a Creature who is trying to assimilate scientists stranded on the planet, or a traveler. that is trying to survive and wait for the arrival of the rescue capsule.',
        price: 1690,
        discountPercentage: 1.0,
        rating: 3,
        stock: 785,
        GameTime: [30],
        age: [10],
        gamers: [2, 7],
        brand: 'GaGa Games',
        category_ru: [
            'Кооперативные игры',
            'Полукооперативные игры',
            'Приключенческие игры',
            'Игры для компании',
            'Карточные игры',
        ],
        category_en: [
            'Co-op games',
            'Semi-cooperative games',
            'Adventure games',
            'Company games',
            'Card games',
        ],
        thumbnail: Chujaya_Planeta,
        images: [
            Chujaya_Planeta_1,
            Chujaya_Planeta_2,
            Chujaya_Planeta_3,
            Chujaya_Planeta_4,
            Chujaya_Planeta_5,
            Chujaya_Planeta_6,
            Chujaya_Planeta_7,
            Chujaya_Planeta_8,
            Chujaya_Planeta_9,
            Chujaya_Planeta_10,
        ],
    },
    {
        id: 69,
        title_ru: 'Пандемия',
        title_en: 'Pandemic',
        subtittle_ru: 'Вы готовы спасти человечество?',
        subtittle_en: 'Are you ready to save humanity?',
        description_ru:
            "В настольной игре 'Пандемия' страшные события обрушились на нашу планету. Одновременно по всему миру вспыхнуло несколько вирулентных заболеваний. Игрокам отводятся роли специалистов по борьбе с заболеваниями и поручают важную миссию – остановить распространение болезней. Вам предстоит посетить очаги заболеваний и изобрести вакцину от каждой из четырёх болезней, прежде чем они выйдут из-под контроля и распространятся по всему миру.",
        description_en:
            "In the board game 'Pandemic', terrible events have hit our planet. At the same time, several virulent diseases broke out around the world. Players take on the role of disease control specialists and are given an important mission to stop the spread of disease. You have to visit the centers of diseases and invent a vaccine for each of the four diseases before they get out of control and spread throughout the world.",
        price: 2990,
        discountPercentage: 1.0,
        rating: 4,
        stock: 56,
        GameTime: [40],
        age: [8],
        gamers: [2, 4],
        brand: 'Стиль Жизни',
        category_ru: ['Кооперативные игры', 'Стратегические игры', 'Семейные', 'Игры для компании'],
        category_en: ['Cooperative Games', 'Strategy Games', 'Family Games', 'Company Games'],
        thumbnail: Pandemic,
        images: [
            Pandemic_1,
            Pandemic_2,
            Pandemic_3,
            Pandemic_4,
            Pandemic_5,
            Pandemic_6,
            Pandemic_7,
            Pandemic_8,
            Pandemic_9,
            Pandemic_10,
        ],
    },
    {
        id: 70,
        title_ru: 'Энциклопедия',
        title_en: 'Encyclopedia',
        subtittle_ru: 'Важный вклад в эпоху Просвещения',
        subtittle_en: 'Important contributions to the Age of Enlightenment',
        description_ru:
            "Жорж-Луи Леклерк де Бюффон – французский натуралист и биолог – известен в истории как предшественник Дарвина, а также как автор первого в европейской истории научного труда по биологии 'Естественная история'. Но то было не сразу. В 1739 году, для начала работы над своим трудом, граф де Бюффон собирает большую научно-исследовательскую экспедицию, целью которой является одно – представить миру те виды животных, которые до сего дня были неведомы большей части человечества.",
        description_en:
            "Georges-Louis Leclerc de Buffon - French naturalist and biologist - is known in history as the predecessor of Darwin, as well as the author of the first European scientific work on biology 'Natural History'. But that was not immediately. In 1739, to start working on his work, the Count de Buffon gathers a large research expedition, the purpose of which is one thing - to introduce to the world those species of animals that until now have been unknown to most of mankind.",
        price: 4490,
        discountPercentage: 1.1,
        rating: 4,
        stock: 101,
        GameTime: [25, 100],
        age: [13],
        gamers: [1, 4],
        brand: 'Asmodee',
        category_ru: ['Приключенческие игры', 'Для одного', 'Стратегические игры'],
        category_en: ['Adventure games', 'For one', 'Strategy games'],
        thumbnail: enciklopediya,
        images: [
            enciklopediya_1,
            enciklopediya_2,
            enciklopediya_3,
            enciklopediya_4,
            enciklopediya_5,
            enciklopediya_6,
            enciklopediya_7,
            enciklopediya_8,
            enciklopediya_9,
            enciklopediya_10,
            enciklopediya_11,
            enciklopediya_12,
            enciklopediya_13,
            enciklopediya_14,
        ],
    },
    {
        id: 71,
        title_ru: "Книга-игра 'Космический десант'",
        title_en: "Book-game 'Space Marines'",
        subtittle_ru: 'Инопланетяне рядом',
        subtittle_en: 'Aliens nearby',
        description_ru:
            "Всё началось с того, что в один случайный момент был получен тревожный сигнал с космической станции 'Тартарус III'. Долгие годы учёные пытались создать мощное биологическое оружие для уничтожения инопланетных тварей, с которыми человечество воюет по сей день. Однако, несколько особей велепторов всё-таки проникли в помещения 'Тартаруса'. На помощь вызван отряд под управлением капрала Ведоски. Только им под силу пройти эту невыполнимую миссию и обезвредить неприятеля. Как бы ни было сложно, но это обычное дельце для отряда Космического десанта!",
        description_en:
            'It all started with the fact that at one random moment an alarm was received from the Tartarus III space station. For many years, scientists have been trying to create powerful biological weapons to destroy alien creatures that humanity is fighting to this day. However, several instances of veleptors nevertheless penetrated the premises of the Tartarus. A detachment led by Corporal Vedoski is called to help. Only they are able to complete this impossible mission and neutralize the enemy. Difficult as it may be, this is business as usual for a Space Marine squad!',
        price: 990,
        discountPercentage: 1.1,
        rating: 3,
        stock: 67,
        GameTime: [],
        age: [16],
        gamers: [],
        brand: 'Makaka Editions',
        category_ru: ['Приключенческие игры', 'Книги-игры'],
        category_en: ['Adventure Games', 'Game Books'],
        thumbnail: kosmicheskiy_desant_komix_igra,
        images: [
            kosmicheskiy_desant_komix_igra_1,
            kosmicheskiy_desant_komix_igra_2,
            kosmicheskiy_desant_komix_igra_3,
            kosmicheskiy_desant_komix_igra_4,
        ],
    },
    {
        id: 72,
        title_ru: 'Звёздные Войны: Внешнее кольцо',
        title_en: 'Star Wars: Outer Rim',
        subtittle_ru: 'Дело за малым – стать легендой!',
        subtittle_en: "It's up to you to become a legend!",
        description_ru:
            'Вдали от небоскрёбов Корусанта находится опасное Внешнее Кольцо. Для многих жителей край галактики представляет собой улей из отбросов и злодеев, который проще не замечать и оставить без внимания. Но для негодяев галактики Внешнее Кольцо предоставляет огромные возможности, чтобы стать легендой!',
        description_en:
            'Far from the skyscrapers of Coruscant lies the dangerous Outer Rim. For many inhabitants, the edge of the galaxy is a hive of scum and villains that is easier to ignore and ignore. But for the villains of the galaxy, the Outer Rim provides a huge opportunity to become a legend!',
        price: 5990,
        discountPercentage: 1.0,
        rating: 5,
        stock: 567,
        GameTime: [120, 180],
        age: [13],
        gamers: [1, 4],
        brand: 'Fantasy Flight Games',
        category_ru: ['Приключенческие игры', 'Для двоих', 'Для одного', 'Игры для компании'],
        category_en: ['Adventure games', 'For two', 'For one', 'Games for the company'],
        thumbnail: SWOuterRim,
        images: [
            SWOuterRim_1,
            SWOuterRim_2,
            SWOuterRim_3,
            SWOuterRim_4,
            SWOuterRim_5,
            SWOuterRim_6,
            SWOuterRim_7,
            SWOuterRim_8,
            SWOuterRim_9,
            SWOuterRim_10,
        ],
    },
    {
        id: 73,
        title_ru: 'Runebound',
        title_en: 'Runebound',
        subtittle_ru: 'Требуются герои. Оплата сдельная',
        subtittle_en: 'Heroes are required. piecework payment',
        description_ru:
            'Лорды собирают армии, древние злые силы пробуждаются, а по землям идёт дрожь. Пришло очень опасное время для людей – время могущества зла. Время страха для слабых и обездоленных. Но также это время Героев, готовых встретиться с тьмой лицом к лицу и принести свет надежды в мир, затянутый тенью.',
        description_en:
            'Lords are gathering armies, ancient evil forces are awakening, and the lands are trembling. A very dangerous time has come for people - the time of the power of evil. A time of fear for the weak and the underprivileged. But it is also the time of Heroes, ready to face the darkness and bring the light of hope to a world shrouded in shadow.',
        price: 4990,
        discountPercentage: 1.0,
        rating: 4,
        stock: 345,
        GameTime: [120, 180],
        age: [14],
        gamers: [2, 4],
        brand: 'Fantasy Flight Games',
        category_ru: [
            'Приключенческие игры',
            'Для двоих',
            'Для одного',
            'Игры для компании',
            'Хардкорные игры',
        ],
        category_en: [
            'Adventure games',
            'For two',
            'For one',
            'Games for the company',
            'Hardcore games',
        ],
        thumbnail: Runebound,
        images: [
            Runebound_1,
            Runebound_2,
            Runebound_3,
            Runebound_4,
            Runebound_5,
            Runebound_6,
            Runebound_7,
            Runebound_8,
            Runebound_9,
            Runebound_10,
        ],
    },
    {
        id: 74,
        title_ru: 'Шакал',
        title_en: 'Jackal',
        subtittle_ru: 'Клады, сокровища, корабли и пираты!',
        subtittle_en: 'Treasures, treasures, ships and pirates!',
        description_ru:
            "Настольная игра 'Шакал', которая уже более тридцати лет остается одной из самых популярных среди любителей по-настоящему увлекательных игр, была придумана в МГУ, что дает нам право лишний раз порадоваться за гениальных соотечественников.",
        description_en:
            "The board game 'Jackal', which has been one of the most popular among fans of truly exciting games for more than thirty years, was invented at Moscow State University, which gives us the right to rejoice once again for our brilliant compatriots.",
        price: 1990,
        discountPercentage: 1.0,
        rating: 2,
        stock: 54,
        GameTime: [60, 120],
        age: [8],
        gamers: [2, 4],
        brand: 'Magellan',
        category_ru: ['Приключенческие игры', 'Логические игры', 'Семейные'],
        category_en: ['Adventure games', 'Logic games', 'Family games'],
        thumbnail: Jakal,
        images: [Jakal_1, Jakal_2, Jakal_3],
    },
    {
        id: 75,
        title_ru: 'Войны Чёрной Розы: Преисподняя',
        title_en: 'Black Rose Wars: Underworld',
        subtittle_ru: '9 кругов',
        subtittle_en: '9 circles',
        description_ru:
            'Ложа Чёрной Розы превратилась в настоящий Ад. В разгар битвы за титул Великого Магистра она и без того походила на преисподнюю, но теперь комнаты ложи стали превращаться в круги по Данте, повсюду появляются демоны, а где-то был замечен и сам Люцифер. Как будто врагов в лице могущественных магов вам было недостаточно...',
        description_en:
            "The Black Rose Lodge has turned into a real Hell. In the midst of the battle for the title of Grand Master, it already looked like hell, but now the rooms of the lodge began to turn into circles around Dante, demons appeared everywhere, and Lucifer himself was seen somewhere. As if enemies in the face of powerful mages weren't enough for you...",
        price: 8490,
        discountPercentage: 1.8,
        rating: 4,
        stock: 456,
        GameTime: [90],
        age: [18],
        gamers: [2, 4],
        brand: 'Фабрика игр',
        category_ru: ['Приключенческие игры', 'Хардкорные игры'],
        category_en: ['Adventure games', 'Hardcore games'],
        thumbnail: voyny_chyornoy_rozy_preispodnyaya,
        images: [
            voyny_chyornoy_rozy_preispodnyaya_1,
            voyny_chyornoy_rozy_preispodnyaya_2,
            voyny_chyornoy_rozy_preispodnyaya_3,
            voyny_chyornoy_rozy_preispodnyaya_4,
            voyny_chyornoy_rozy_preispodnyaya_5,
            voyny_chyornoy_rozy_preispodnyaya_6,
            voyny_chyornoy_rozy_preispodnyaya_7,
            voyny_chyornoy_rozy_preispodnyaya_8,
            voyny_chyornoy_rozy_preispodnyaya_9,
            voyny_chyornoy_rozy_preispodnyaya_10,
            voyny_chyornoy_rozy_preispodnyaya_11,
            voyny_chyornoy_rozy_preispodnyaya_12,
            voyny_chyornoy_rozy_preispodnyaya_13,
            voyny_chyornoy_rozy_preispodnyaya_14,
            voyny_chyornoy_rozy_preispodnyaya_15,
        ],
    },
    {
        id: 76,
        title_ru: 'Запретный Остров',
        title_en: 'Forbidden Island',
        subtittle_ru: 'Найдите артефакты, пока они не ушли под воду',
        subtittle_en: 'Find artifacts before they go underwater',
        description_ru:
            "'Запретный остров' – настольная игра игра для большой компании где игроки в роли бесстрашных искателей приключений исследуют остров, на котором спрятаны бесценные древние артефакты. Вся проблема в том, что остров (как только исследователи оказываются на нем) начинает стремительно уходить под воду.",
        description_en:
            "'Forbidden Island' is a board game for a large group where players take on the role of fearless adventurers and explore an island where priceless ancient artifacts are hidden. The whole problem is that the island (as soon as the researchers are on it) begins to rapidly go under water.",
        price: 1390,
        discountPercentage: 1.0,
        rating: 5,
        stock: 17,
        GameTime: [30],
        age: [8],
        gamers: [2, 4],
        brand: 'Rebel',
        category_ru: ['Приключенческие игры', 'Для двоих', 'Семейные', 'Кооперативные игры'],
        category_en: ['Adventure games', 'For two', 'Family games', 'Co-op games'],
        thumbnail: Zapret_ostr,
        images: [
            Zapret_ostr_1,
            Zapret_ostr_2,
            Zapret_ostr_3,
            Zapret_ostr_4,
            Zapret_ostr_5,
            Zapret_ostr_6,
            Zapret_ostr_7,
            Zapret_ostr_8,
            Zapret_ostr_9,
            Zapret_ostr_10,
        ],
    },
    {
        id: 77,
        title_ru: 'Подземелье: Гробница повелителя мёртвых',
        title_en: 'Dungeon: Tomb of the Dead Lord',
        subtittle_ru: 'Откройте тайны темных коридоров!',
        subtittle_en: 'Discover the secrets of the dark corridors!',
        description_ru:
            'У нас ужасные новости: Повелитель Мёртвых сбросил оковы сна! А вместе с ним, конечно, сразу восстали из могил и его приспешники, которые абсолютно безнаказанно разбежались по окрестным землям. На крик о помощи местных жителей сразу откликнулись могучие герои, среди которых, конечно, есть и Вы! Хватит ли Вам смелости, чтобы вступить в подземелье, в котором находится гробница Повелителя Мёртвых?',
        description_en:
            'We have terrible news: the Lord of the Dead has thrown off the shackles of sleep! And with him, of course, immediately rose from the graves and his henchmen, who fled with absolute impunity to the surrounding lands. Mighty heroes immediately responded to the cry for help from local residents, among whom, of course, there is you! Do you have the courage to enter the dungeon in which the tomb of the Lord of the Dead is located?',
        price: 890,
        discountPercentage: 1.3,
        rating: 4,
        stock: 99,
        GameTime: [60],
        age: [12],
        gamers: [1, 4],
        brand: 'GaGa Games',
        category_ru: ['Приключенческие игры', 'Для одного', 'Карточные игры', 'Игры в дорогу'],
        category_en: ['Adventure games', 'For one', 'Card games', 'Games on the road'],
        thumbnail: Dungeons,
        images: [
            Dungeons_1,
            Dungeons_2,
            Dungeons_3,
            Dungeons_4,
            Dungeons_5,
            Dungeons_6,
            Dungeons_7,
            Dungeons_8,
            Dungeons_9,
            Dungeons_10,
        ],
    },
    {
        id: 78,
        title_ru: 'Ольтре',
        title_en: 'Oltre',
        subtittle_ru: 'Осколки старой Империи',
        subtittle_en: 'Fragments of the old empire',
        description_ru:
            "Много лет назад Империя, которая славилась своим величием, была втянута в бессмысленный и беспощадный конфликт, развязанный Королём-колдуном – верховным жрецом 'Отца всех монстров'. В этой кровопролитной войне Империя одолела Короля-колдуна и его армию, но цена этой победе оказалась огромной: само существование Империи подошло к концу. Земли были разрознены. Некогда соседи, а теперь уже враги безжалостно нападают друг на друга. Пришла эпоха разрухи и непрекращающегося горя. Но не всех устраивало такое положение дел: приверженцы старой Империи, бравые рейнджеры, оставили свои крепости и цитадели и отправились в путь присматривать за мирными жителями и восстанавливать былой порядок.",
        description_en:
            "Many years ago, the Empire, which was famous for its greatness, was embroiled in a senseless and merciless conflict unleashed by the Sorcerer King - the high priest of the 'Father of all monsters'. In this bloody war, the Empire defeated the Witch King and his army, but the cost of this victory was enormous: the very existence of the Empire came to an end. The lands were scattered. Once neighbors, and now enemies mercilessly attack each other. The era of devastation and incessant grief has come. But not everyone was satisfied with this state of affairs: the adherents of the old Empire, the brave rangers, left their fortresses and citadels and set off on a journey to look after civilians and restore the former order.",
        price: 4490,
        discountPercentage: 1.0,
        rating: 3,
        stock: 57,
        GameTime: [60],
        age: [14],
        gamers: [2, 4],
        brand: 'Эврикус',
        category_ru: ['Приключенческие игры', 'Стратегические игры', 'Кооперативные игры'],
        category_en: ['Adventure games', 'Strategy games', 'Co-op games'],
        thumbnail: oltre,
        images: [
            oltre_1,
            oltre_2,
            oltre_3,
            oltre_4,
            oltre_5,
            oltre_6,
            oltre_7,
            oltre_8,
            oltre_9,
            oltre_10,
            oltre_11,
            oltre_12,
            oltre_13,
            oltre_14,
        ],
    },
    {
        id: 79,
        title_ru: 'Вечная зима: Палеоиндейцы',
        title_en: 'Eternal Winter: Paleo-Indians',
        subtittle_ru: 'Выживает сильнейший',
        subtittle_en: 'The strongest survives',
        description_ru:
            '120 тысяч лет назад Северная Америка была покрыта толщей снега. По холодным пустыням бродили саблезубые тигры, а люди ютились в пещерах и поселениях. Но для выживания недостаточно просто сохранять тепло и добывать пищу. Необходимо адаптироваться: если жители ослабнут – воодушевить их, если народу станет слишком много – найти новый дом. Лишь ответственный и решительный вождь сумеет привести племя к процветанию. Только что это за великое затмение, о котором всё шепчут шаманы?..',
        description_en:
            '120 thousand years ago, North America was covered with thick snow. Saber-toothed tigers roamed the cold deserts, and people huddled in caves and settlements. But to survive, it is not enough just to keep warm and get food. It is necessary to adapt: if the inhabitants weaken - inspire them, if there are too many people - find a new home. Only a responsible and decisive leader will be able to lead the tribe to prosperity. Just what is this great eclipse that shamans keep whispering about?..',
        price: 5990,
        discountPercentage: 1.0,
        rating: 5,
        stock: 789,
        GameTime: [60, 120],
        age: [12],
        gamers: [1, 4],
        brand: 'GaGa Games',
        category_ru: [
            'Приключенческие игры',
            'Стратегические игры',
            'Для одного',
            'Карточные игры',
            'Хардкорные игры',
            'Экономические',
        ],
        category_en: [
            'Adventure games',
            'Strategy games',
            'For one',
            'Card games',
            'Hardcore games',
            'Economic',
        ],
        thumbnail: vechnaya_zima,
        images: [
            vechnaya_zima_1,
            vechnaya_zima_2,
            vechnaya_zima_3,
            vechnaya_zima_4,
            vechnaya_zima_5,
            vechnaya_zima_6,
            vechnaya_zima_7,
            vechnaya_zima_8,
            vechnaya_zima_9,
            vechnaya_zima_10,
            vechnaya_zima_11,
            vechnaya_zima_12,
        ],
    },
    {
        id: 80,
        title_ru: 'Руины острова Арнак',
        title_en: 'Ruins of Arnak Island',
        subtittle_ru: 'Шляпа, лопата и приключения!',
        subtittle_en: 'Hat, shovel and adventure!',
        description_ru:
            'Возглавьте археологическую экспедицию, отправленную на необитаемый остров Арнак. Там найдены следы древней могущественной цивилизации. Вам предстоит исследовать загадочный остров, откопать таинственные артефакты, найти путь к затерянному среди джунглей храму и, конечно же, попасть не в одно приключение.',
        description_en:
            'Lead an archaeological expedition sent to the uninhabited island of Arnak. There are found traces of an ancient powerful civilization. You have to explore a mysterious island, dig up mysterious artifacts, find a way to a temple lost in the jungle and, of course, get into more than one adventure.',
        price: 4590,
        discountPercentage: 1.0,
        rating: 3,
        stock: 56,
        GameTime: [60, 120],
        age: [12],
        gamers: [1, 4],
        brand: 'GaGa Games',
        category_ru: [
            'Приключенческие игры',
            'Стратегические игры',
            'Для одного',
            'Семейные',
            'Экономические',
        ],
        category_en: ['Adventure games', 'Strategy games', 'For one', 'Family games', 'Economic'],
        thumbnail: Arnaks,
        images: [Arnaks_1, Arnaks_2, Arnaks_3, Arnaks_4, Arnaks_5, Arnaks_6],
    },
    {
        id: 81,
        title_ru: 'Талисман. Магическое приключение',
        title_en: 'Mascot. Magical adventure',
        subtittle_ru: '4-е издание легендарной игры',
        subtittle_en: '4th edition of the legendary game',
        description_ru:
            "Настольная игра 'Талисман' – это невероятное и опасное приключение в магическом мире, опасности которого поджидают за каждым поворотом. Ход за ходом на игровом поле происходят эпические события, в которых герои совершают подвиги и проходят суровые испытания.",
        description_en:
            "The board game 'Talisman' is an incredible and dangerous adventure in the magical world, the dangers of which await at every turn. Turn after turn, epic events take place on the playing field, in which heroes perform feats and undergo severe trials.",
        price: 4990,
        discountPercentage: 1.0,
        rating: 4,
        stock: 456,
        GameTime: [90, 120],
        age: [12],
        gamers: [2, 6],
        brand: 'Games Workshop',
        category_ru: ['Приключенческие игры', 'Игры для компании'],
        category_en: ['Adventure games', 'Games for the company'],
        thumbnail: Talisman,
        images: [
            Talisman_1,
            Talisman_2,
            Talisman_3,
            Talisman_4,
            Talisman_5,
            Talisman_6,
            Talisman_7,
        ],
    },
    {
        id: 82,
        title_ru: "Комикс-игра 'Оборотень'",
        title_en: "Comic game 'Werewolf'",
        subtittle_ru: 'Проклятье или сила?',
        subtittle_en: 'Curse or power?',
        description_ru:
            'Могучий маг отправляет своего ученика в лес, на поиски редкого существа – трёхрогого слизня. Но вместо него ученик натыкается на другое, не менее редкое существо: на оборотня, который кусает его и обращает в подобное себе чудовище.',
        description_en:
            'A powerful magician sends his student into the forest in search of a rare creature - a three-horned slug. But instead, the student stumbles upon another, no less rare creature: a werewolf who bites him and turns him into a similar monster.',
        price: 990,
        discountPercentage: 1.5,
        rating: 3,
        stock: 4,
        GameTime: [],
        age: [18],
        gamers: [1],
        brand: 'Hobby World',
        category_ru: ['Приключенческие игры', 'Книги-игры', 'Игры в дорогу'],
        category_en: ['Adventure games', 'Game books', 'Games on the road'],
        thumbnail: Oboroten,
        images: [Oboroten_1, Oboroten_2, Oboroten_3, Oboroten_4, Oboroten_5],
    },
    {
        id: 83,
        title_ru: 'Энциклопедия: Большое путешествие',
        title_en: 'Encyclopedia: Great Journey',
        subtittle_ru: 'Ещё больше открытий!',
        subtittle_en: 'More discoveries!',
        description_ru:
            'Экспедиция графа де Бюффона продолжается! Ну а как не продолжить, когда столько талантливых и пытливых умов присоединилось к экспедици? Энциклопедия полнится новыми открытиями, и на сей раз натуралистов занесёт ещё дальше – в среду обитания таких животных, многие из которых считались мифом.',
        description_en:
            "The Comte de Buffon's expedition continues! Well, why not continue when so many talented and inquisitive minds have joined the expedition? The encyclopedia is full of new discoveries, and this time it will take naturalists even further - into the habitat of such animals, many of which were considered a myth.",
        price: 990,
        discountPercentage: 1.0,
        rating: 4,
        stock: 77,
        GameTime: [25, 100],
        age: [13],
        gamers: [1, 4],
        brand: 'Hobby World',
        category_ru: ['Приключенческие игры', 'Стратегические игры', 'Для одного'],
        category_en: ['Adventure games', 'Strategy games', 'For one'],
        thumbnail: enciklopediya_bolshoe_puteshestvie,
        images: [
            enciklopediya_bolshoe_puteshestvie_1,
            enciklopediya_bolshoe_puteshestvie_2,
            enciklopediya_bolshoe_puteshestvie_3,
            enciklopediya_bolshoe_puteshestvie_4,
            enciklopediya_bolshoe_puteshestvie_5,
            enciklopediya_bolshoe_puteshestvie_6,
            enciklopediya_bolshoe_puteshestvie_7,
            enciklopediya_bolshoe_puteshestvie_8,
            enciklopediya_bolshoe_puteshestvie_9,
            enciklopediya_bolshoe_puteshestvie_10,
            enciklopediya_bolshoe_puteshestvie_11,
        ],
    },
    {
        id: 84,
        title_ru: 'Хеллбой',
        title_en: 'Hellboy',
        subtittle_ru: 'Станьте оперативником БРПД!',
        subtittle_en: 'Become a BRPD operative!',
        description_ru:
            "Настольная игра 'Хеллбой' – это кооперативное настольное приключение, в котором вам и вашим союзникам предстоит остановить древнее зло. Возьмите под своё управление легендарных членов БРПД (Бюро расследования паранормальной деятельности), сошедших со страниц культового комикса Майка Миньолы.",
        description_en:
            "The Hellboy Board Game is a co-op board adventure where you and your allies must stop an ancient evil. Take control of the legendary members of the BRPD (Bureau of Paranormal Investigation) descended from the pages of Mike Mignola's iconic comic strip.",
        price: 6990,
        discountPercentage: 1.0,
        rating: 5,
        stock: 234,
        GameTime: [60, 90],
        age: [14],
        gamers: [1, 4],
        brand: 'CMON',
        category_ru: [
            'Приключенческие игры',
            'Стратегические игры',
            'Игры для компании',
            'Кооперативные игры',
        ],
        category_en: ['Adventure games', 'Strategy games', 'Company games', 'Co-op games'],
        thumbnail: Hellboy,
        images: [
            Hellboy_1,
            Hellboy_2,
            Hellboy_3,
            Hellboy_4,
            Hellboy_5,
            Hellboy_6,
            Hellboy_7,
            Hellboy_8,
        ],
    },
    {
        id: 85,
        title_ru: 'Шакал: Архипелаг',
        title_en: 'Jackal: Archipelago',
        subtittle_ru: 'Ещё больше открытий',
        subtittle_en: 'Even more discoveries',
        description_ru:
            'Старый грозный пират Шакал, одно только имя которого держало в страхе все корабли испанских морей, решил надёжно спрятать все свои сокровища. Любой пират знает, что лучшее место, где можно это сделать – необитаемый остров.',
        description_en:
            'The formidable old pirate Jackal, whose name alone kept all the ships of the Spanish seas at bay, decided to safely hide all his treasures. Any pirate knows that the best place to do this is on a deserted island.',
        price: 1490,
        discountPercentage: 1.5,
        rating: 4,
        stock: 6,
        GameTime: [30, 45],
        age: [6],
        gamers: [2, 4],
        brand: 'Magellan',
        category_ru: ['Приключенческие игры', 'Семейные', 'Игры для компании'],
        category_en: ['Adventure games', 'Family games', 'Company games'],
        thumbnail: Shakal_Archipelag,
        images: [
            Shakal_Archipelag_1,
            Shakal_Archipelag_2,
            Shakal_Archipelag_3,
            Shakal_Archipelag_4,
            Shakal_Archipelag_5,
            Shakal_Archipelag_6,
            Shakal_Archipelag_7,
            Shakal_Archipelag_8,
            Shakal_Archipelag_9,
            Shakal_Archipelag_10,
        ],
    },
    {
        id: 86,
        title_ru: 'Эпоха облаков',
        title_en: 'Age of Clouds',
        subtittle_ru: 'Дирижабль, ага',
        subtittle_en: 'Airship, yeah',
        description_ru:
            "Это произошло 15 лет назад. Тайное общество под названием 'ОБЛАКО' совершило по всему миру несколько крупных террористических актов – поджоги огромных лесных массивов и подрывы нефтеперерабатывающих заводов. Мотивом действий членов 'ОБЛАКА' стала полная дестабилизация обстановки в мире, но какие конкретно цели они преследовали неясно до сих пор. Зато последствия их деятельности стали понятны сразу: тотальная экологическая катастрофа, погрузившая планету в ужасный хаос на многие десятилетия вперёд.",
        description_en:
            "This happened 15 years ago. A secret society called the CLOUD has carried out several major terrorist acts around the world - setting fire to huge forest areas and blowing up oil refineries. The motive for the actions of the 'CLOUDS' members was the complete destabilization of the situation in the world, but what specific goals they pursued is still unclear. But the consequences of their activities became immediately clear: a total ecological catastrophe that plunged the planet into terrible chaos for many decades to come.",
        price: 4990,
        discountPercentage: 1.0,
        rating: 5,
        stock: 78,
        GameTime: [60, 100],
        age: [10],
        gamers: [1, 4],
        brand: 'Horrible Games',
        category_ru: ['Приключенческие игры', 'Для одного', 'Стратегические игры'],
        category_en: ['Adventure games', 'For one', 'Strategy games'],
        thumbnail: epoha_oblakov,
        images: [
            epoha_oblakov_1,
            epoha_oblakov_2,
            epoha_oblakov_3,
            epoha_oblakov_4,
            epoha_oblakov_5,
            epoha_oblakov_6,
            epoha_oblakov_7,
        ],
    },
    {
        id: 87,
        title_ru: 'Палео: Новое начало',
        title_en: 'Paleo: A New Beginning',
        subtittle_ru: 'Пора выбираться из пещеры!',
        subtittle_en: 'Time to get out of the cave!',
        description_ru:
            'Не успели и глазом моргнуть, а со времён ваших первых приключений в каменном веке пролетели уже несколько тысяч лет! И вот вы стоите на пороге важных открытий, которые изменят жизнь вашего племени коренным образом.',
        description_en:
            'Before you even blink an eye, several thousand years have passed since your first adventures in the Stone Age! And now you are on the verge of important discoveries that will change the life of your tribe radically.',
        price: 1990,
        discountPercentage: 1.0,
        rating: 4,
        stock: 786,
        GameTime: [45, 60],
        age: [10],
        gamers: [2, 4],
        brand: 'Greater Than Games',
        category_ru: [
            'Приключенческие игры',
            'Карточные игры',
            'Кооперативные игры',
            'Стратегические игры',
        ],
        category_en: ['Adventure games', 'Card games', 'Co-op games', 'Strategy games'],
        thumbnail: Paleo_NB,
        images: [Paleo_NB_1, Paleo_NB_2, Paleo_NB_3, Paleo_NB_4],
    },
    {
        id: 88,
        title_ru: 'История рыцаря',
        title_en: 'History of the knight',
        subtittle_ru: 'Честь и слава!',
        subtittle_en: 'Honor and glory!',
        description_ru:
            'О, славный пятнадцатый век! Эпоха доблестных рыцарей, что отважно сражаются во имя своего государя, родины, Господа Бога и, конечно, красоты локонов своих прекрасных дам... Но попасть на турнир не так сложно, как выиграть его – этим и предстоит заняться молодым рыцарям, только получившим свой титул.',
        description_en:
            'Oh, glorious fifteenth century! The era of valiant knights who bravely fight in the name of their sovereign, motherland, the Lord God and, of course, the beauty of the curls of their beautiful ladies ... But getting into the tournament is not as difficult as winning it - this is what young knights who have just received their title.',
        price: 3990,
        discountPercentage: 1.4,
        rating: 3,
        stock: 67,
        GameTime: [30, 120],
        age: [13],
        gamers: [1, 4],
        brand: 'Lavka Games',
        category_ru: ['Стратегические игры', 'Для одного'],
        category_en: ['Strategy games', 'For one'],
        thumbnail: istoriya_ricarya,
        images: [
            istoriya_ricarya_1,
            istoriya_ricarya_2,
            istoriya_ricarya_3,
            istoriya_ricarya_4,
            istoriya_ricarya_5,
            istoriya_ricarya_6,
            istoriya_ricarya_7,
        ],
    },
    {
        id: 89,
        title_ru: 'Билет на поезд: Европа',
        title_en: 'Ticket to ride: Europe',
        subtittle_ru: 'Постройте железные дороги по всей Европе!',
        subtittle_en: 'Build railways across Europe!',
        description_ru:
            "Эта увлекательная игра предлагает захватывающее путешествие из дождливого Эдинбурга в солнечный Константинополь. В настольной игре 'Билет на поезд: Европа' Вы посетите величественные европейские города, осталось только взять билет на поезд.",
        description_en:
            "This exciting game offers an exciting journey from rainy Edinburgh to sunny Constantinople. In the board game 'Ticket To Ride: Europe' you will visit the majestic European cities, it remains only to take a train ticket.",
        price: 4990,
        discountPercentage: 1.0,
        rating: 5,
        stock: 900,
        GameTime: [30, 60],
        age: [8],
        gamers: [2, 5],
        brand: 'Asmodee',
        category_ru: ['Стратегические игры', 'Семейные', 'Игры для компании'],
        category_en: ['Strategy games', 'Family games', 'Company games'],
        thumbnail: Ticket_to_Ride_Europe,
        images: [
            Ticket_to_Ride_Europe_1,
            Ticket_to_Ride_Europe_2,
            Ticket_to_Ride_Europe_3,
            Ticket_to_Ride_Europe_4,
            Ticket_to_Ride_Europe_5,
            Ticket_to_Ride_Europe_6,
            Ticket_to_Ride_Europe_7,
            Ticket_to_Ride_Europe_8,
        ],
    },
    {
        id: 90,
        title_ru: 'Битва за Рокуган',
        title_en: 'Battle for Rokugan',
        subtittle_ru: 'Будьте мудрым даймё!',
        subtittle_en: 'Be a wise daimyo!',
        description_ru:
            'Захватите королевство и принесите честь и славу для своего клана в битве за Рокуган! В этой стратегической игре о завоеваниях земель и войнах за них, игроки оказываются в ролях настоящих даймё великих японских кланов, которые борются за богатые ресурсами земли Изумрудной Империи. Главы кланов должны грамотно распоряжаться доступными ресурсами, мудро планировать атаки своих армий и быть на шаг впереди своих соперников, чтобы вырвать уверенную победу.',
        description_en:
            "Take over the kingdom and bring honor and glory to your clan in the battle for Rokugan! In this strategy game of land conquest and warfare, players take on the role of real daimyo of Japan's great clans fighting for the resource-rich lands of the Emerald Empire. Clan leaders must wisely manage available resources, plan their armies' attacks wisely, and be one step ahead of their rivals in order to snatch a landslide victory.",
        price: 2990,
        discountPercentage: 1.1,
        rating: 4,
        stock: 96,
        GameTime: [60, 90],
        age: [13],
        gamers: [2, 5],
        brand: 'Fantasy Flight Games',
        category_ru: ['Стратегические игры', 'Для двоих', 'Игры для компании', 'Хардкорные игры'],
        category_en: ['Strategy games', 'For two', 'Games for the company', 'Hardcore games'],
        thumbnail: bitva_za_rokugan,
        images: [
            bitva_za_rokugan_1,
            bitva_za_rokugan_2,
            bitva_za_rokugan_3,
            bitva_za_rokugan_4,
            bitva_za_rokugan_5,
            bitva_za_rokugan_6,
            bitva_za_rokugan_7,
            bitva_za_rokugan_8,
        ],
    },
    {
        id: 91,
        title_ru: 'Игра Престолов',
        title_en: 'Game of Thrones',
        subtittle_ru: 'Второе издание знаменитой настольной стратегии',
        subtittle_en: 'The second edition of the famous board strategy',
        description_ru: 'Король Роберт Баратеон мертв, а земли Вестероса готовятся к сражениям…',
        description_en:
            'King Robert Baratheon is dead, and the lands of Westeros are preparing for battle...',
        price: 5490,
        discountPercentage: 1.0,
        rating: 3,
        stock: 346,
        GameTime: [120, 180],
        age: [13],
        gamers: [3, 6],
        brand: 'Fantasy Flight Games',
        category_ru: ['Стратегические игры', 'Хардкорные игры'],
        category_en: ['Strategy games', 'Hardcore games'],
        thumbnail: gameOfThrones,
        images: [
            gameOfThrones_1,
            gameOfThrones_2,
            gameOfThrones_3,
            gameOfThrones_4,
            gameOfThrones_5,
            gameOfThrones_6,
            gameOfThrones_7,
            gameOfThrones_8,
            gameOfThrones_9,
            gameOfThrones_10,
            gameOfThrones_11,
        ],
    },
    {
        id: 92,
        title_ru: 'Эверделл',
        title_en: 'Everdell',
        subtittle_ru: 'Сказки вечного леса',
        subtittle_en: 'Tales of the eternal forest',
        description_ru:
            'Когда-то давным-давно известный путешественник Коррин Эвертейл наткнулся на удивительную долину Эверделл. Его поразили местные красоты зелёных просторов, живых разговорчивых ручьёв и пышные кроны древних деревьев. Именно здесь он решил обосноваться и обустроить своё семейное гнездо. С тех самых пор его сородичи ведут насыщенную жизнь под тенью Вечного дерева.',
        description_en:
            'Once upon a time, the famous traveler Corrin Evertail stumbled upon the amazing Everdell Valley. He was struck by the local beauty of green expanses, lively talkative streams and lush crowns of ancient trees. It was here that he decided to settle down and equip his family nest. Since then, his relatives have led a rich life under the shadow of the Eternal Tree.',
        price: 5990,
        discountPercentage: 1.0,
        rating: 4,
        stock: 145,
        GameTime: [40, 80],
        age: [10],
        gamers: [1, 4],
        brand: 'Portal Games',
        category_ru: [
            'Стратегические игры',
            'Экономические',
            'Для одного',
            'Для двоих',
            'Семейные',
        ],
        category_en: ['Strategy games', 'Economic', 'For one', 'For two', 'Family games'],
        thumbnail: Ehverdell,
        images: [
            Ehverdell_1,
            Ehverdell_2,
            Ehverdell_3,
            Ehverdell_4,
            Ehverdell_5,
            Ehverdell_6,
            Ehverdell_7,
            Ehverdell_8,
            Ehverdell_9,
            Ehverdell_10,
        ],
    },
    {
        id: 93,
        title_ru: 'Маленький мир',
        title_en: 'Small World',
        subtittle_ru: 'Целый мир в большой коробке!',
        subtittle_en: 'The whole world in a big box!',
        description_ru:
            'Всё больше новых народов заселяет ваши земли, и всем приходится тесниться. А ведь предки завещали вам эти земли не просто так – они-то надеялись, что вы сможете построить сильную империю, которая покорит весь мир…',
        description_en:
            'More and more new peoples populate your lands, and everyone has to crowd. But the ancestors bequeathed these lands to you for a reason - they hoped that you would be able to build a strong empire that would conquer the whole world ...',
        price: 4990,
        discountPercentage: 1.0,
        rating: 4,
        stock: 555,
        GameTime: [40, 80],
        age: [8],
        gamers: [2, 5],
        brand: 'Экивоки',
        category_ru: ['Стратегические игры', 'Игры для компании', 'Семейные'],
        category_en: ['Strategy games', 'Games for the company', 'Family games'],
        thumbnail: Small_World,
        images: [
            Small_World_1,
            Small_World_2,
            Small_World_3,
            Small_World_4,
            Small_World_5,
            Small_World_6,
            Small_World_7,
            Small_World_8,
            Small_World_9,
            Small_World_10,
            Small_World_11,
            Small_World_12,
        ],
    },
    {
        id: 94,
        title_ru: 'Битоку',
        title_en: 'Bitoku',
        subtittle_ru: 'Станьте Великим Духом!',
        subtittle_en: 'Become a Great Spirit!',
        description_ru:
            'Давным-давно, ещё во времена наших далёких предков, в Лесу жил и справедливо правил мудрый Великий Дух. Одно лишь его существование заставляло жизнь вокруг наполняться жизнью и изобилием. Деяния Великого Духа не прошли бесследно, и сквозь столетия всё ещё отзываются в Лесу долгим эхом. Но ничто не вечно, и в условленный час Дух должен был покинуть Лес, растворившись в памяти времён. А на его место должен прийти битоку – достойный преемник, в котором мудрость Великого Духа продолжит поддерживать гармонию и спокойствие в Лесу.',
        description_en:
            'A long time ago, back in the days of our distant ancestors, the wise Great Spirit lived and rightly ruled in the Forest. Its mere existence made the life around filled with life and abundance. The deeds of the Great Spirit did not pass without a trace, and through the centuries they still echo in the Forest with a long echo. But nothing lasts forever, and at the appointed hour the Spirit had to leave the Forest, dissolving in the memory of times. And in his place should come the cue ball - a worthy successor, in which the wisdom of the Great Spirit will continue to maintain harmony and tranquility in the Forest.',
        price: 4990,
        discountPercentage: 1.0,
        rating: 5,
        stock: 555,
        GameTime: [120],
        age: [13],
        gamers: [1, 4],
        brand: 'Hobby World',
        category_ru: ['Стратегические игры', 'Для одного', 'Хардкорные игры'],
        category_en: ['Strategy games', 'For one', 'Hardcore games'],
        thumbnail: bitoku,
        images: [
            bitoku_1,
            bitoku_2,
            bitoku_3,
            bitoku_4,
            bitoku_5,
            bitoku_6,
            bitoku_7,
            bitoku_8,
            bitoku_9,
            bitoku_10,
            bitoku_11,
            bitoku_12,
            bitoku_13,
            bitoku_14,
            bitoku_15,
            bitoku_16,
        ],
    },
    {
        id: 95,
        title_ru: "'Цивилизация' Сида Мейера: Новый рассвет.",
        title_en: "'Civilization' Sid Meier: A New Dawn.",
        subtittle_ru: 'Новые пути к победе!',
        subtittle_en: 'New ways to win!',
        description_ru:
            'Ваша цивилизация стоит на пороге зарождения и её ждут бескрайние пространства открытий и земель! Вы встретитесь с другими народами и узнаете много нового, но вы бы никогда не добрались до этих мест, если бы исследователи не отважились выйти за пределы привычного... Вас ждёт Терра инкогнита!',
        description_en:
            'Your civilization is on the verge of birth, and endless spaces of discoveries and lands await it! You will meet other peoples and learn many new things, but you would never have reached these places if the explorers had not dared to go beyond the usual... Terra incognita awaits you!',
        price: 4490,
        discountPercentage: 1.2,
        rating: 5,
        stock: 561,
        GameTime: [120, 180],
        age: [15],
        gamers: [2, 5],
        brand: 'Fantasy Flight Games',
        category_ru: ['Стратегические игры', 'Экономические', 'Хардкорные игры'],
        category_en: ['Strategy games', 'Economic games', 'Hardcore games'],
        thumbnail: CIV02TerraIncognitaBox,
        images: [
            CIV02TerraIncognitaBox_1,
            CIV02TerraIncognitaBox_2,
            CIV02TerraIncognitaBox_3,
            CIV02TerraIncognitaBox_4,
            CIV02TerraIncognitaBox_5,
            CIV02TerraIncognitaBox_6,
            CIV02TerraIncognitaBox_7,
            CIV02TerraIncognitaBox_8,
        ],
    },
    {
        id: 96,
        title_ru: 'Индустрия',
        title_en: 'Industry',
        subtittle_ru: 'Станьте промышленным магнатом',
        subtittle_en: 'Become an industrial tycoon',
        description_ru:
            'Готовы попробовать себя в роли промышленника эпохи Второй индустриальной революции? Вам предстоит в течение четырёх раундов выступать в качестве состоятельного магната, который стремится опередить конкурентов, зарабатывая как можно больше денег, приобретая и модернизируя разнообразные предприятия, добывая и перерабатывая ресурсы.',
        description_en:
            'Ready to try yourself as an industrialist during the Second Industrial Revolution? You have to act as a wealthy tycoon for four rounds, who strives to get ahead of the competition, earning as much money as possible, acquiring and upgrading various enterprises, extracting and processing resources.',
        price: 1990,
        discountPercentage: 1.0,
        rating: 5,
        stock: 677,
        GameTime: [30, 60],
        age: [12],
        gamers: [2, 4],
        brand: 'Hobby World',
        category_ru: ['Стратегические игры', 'Экономические', 'Игры для компании'],
        category_en: ['Strategy games', 'Economic games', 'Company games'],
        thumbnail: Industry,
        images: [
            Industry_1,
            Industry_2,
            Industry_3,
            Industry_4,
            Industry_5,
            Industry_6,
            Industry_7,
            Industry_8,
            Industry_9,
        ],
    },
    {
        id: 97,
        title_ru: 'BattleTech',
        title_en: 'BattleTech',
        subtittle_ru: 'Битва за галактику начинается!',
        subtittle_en: 'The battle for the galaxy begins!',
        description_ru:
            'На дворе XXXI век – время, когда по всему освоенному человечеством космосу бушуют бесконечные войны. Звездные империи сражаются между собой с помощью боевых мехов, огромных человекоподобных титанов из металла, увешанных лазерами, автопушками, ракетами и другим, не менее смертоносным вооружением. Их боевой мощи достаточно, чтобы сравнять с землёй целый городской квартал! Ваша элитная команда мехвоинов управляет этими машинами разрушения. Гордо подняв знамена, они идут в бой, полные решимости приумножить силу и славу своей фракции.',
        description_en:
            'In the yard of the XXXI century is a time when endless wars rage throughout the space developed by mankind. Star empires fight among themselves with the help of battle mechs, huge humanoid titans made of metal, hung with lasers, autocannons, missiles and other equally deadly weapons. Their combat power is enough to level an entire city block to the ground! Your elite team of MechWarriors pilot these machines of destruction. Proudly raising their banners, they go into battle, determined to increase the strength and glory of their faction.',
        price: 3990,
        discountPercentage: 1.25,
        rating: 4,
        stock: 25,
        GameTime: [90, 120],
        age: [14],
        gamers: [2],
        brand: 'Hobby World',
        category_ru: ['Стратегические игры', 'Для двоих', 'Хардкорные игры', 'Дуэльные'],
        category_en: ['Strategy games', 'For two', 'Hardcore games', 'Dueling'],
        thumbnail: BattleTech,
        images: [BattleTech_1, BattleTech_2, BattleTech_3, BattleTech_4],
    },
    {
        id: 98,
        title_ru: 'Метро 2033',
        title_en: 'Metro 2033',
        subtittle_ru: 'Игра по одноименному роману Дмитрия Глуховского',
        subtittle_en: 'A game based on the novel of the same name by Dmitry Glukhovsky',
        description_ru:
            'Действие переносит нас в мир московской подземки после масштабной ядерной войны.  Это суровый мир, где идет постоянная война за выживание различных подземных группировок.',
        description_en:
            'The action takes us to the world of the Moscow subway after a large-scale nuclear war. This is a harsh world where there is a constant war for the survival of various underground groups.',
        price: 2490,
        discountPercentage: 1.0,
        rating: 5,
        stock: 168,
        GameTime: [60, 90],
        age: [12],
        gamers: [2, 6],
        brand: 'Hobby World',
        category_ru: ['Стратегические игры', 'Игры для компании'],
        category_en: ['Strategy games', 'Games for the company'],
        thumbnail: metro2033,
        images: [
            metro2033_1,
            metro2033_2,
            metro2033_3,
            metro2033_4,
            metro2033_5,
            metro2033_6,
            metro2033_7,
            metro2033_8,
            metro2033_9,
            metro2033_10,
            metro2033_11,
        ],
    },
    {
        id: 99,
        title_ru: '7 чудес',
        title_en: '7 wonders',
        subtittle_ru: 'Дневные и ночные стороны',
        subtittle_en: 'Day and night sides',
        description_ru:
            "Все слышали о семи чудесах света древнего мира, но к сожалению до нашего времени 'дожило' только одно из них. Эта игра позволит вам не только увидеть эти чудеса, но и приложить свою руку к их созданию!",
        description_en:
            'Everyone has heard about the seven wonders of the world of the ancient world, but unfortunately only one of them has survived to our time. This game will allow you not only to see these miracles, but also to have a hand in their creation!',
        price: 3490,
        discountPercentage: 1.0,
        rating: 4,
        stock: 678,
        GameTime: [30],
        age: [10],
        gamers: [3, 7],
        brand: 'Стиль Жизни',
        category_ru: [
            'Стратегические игры',
            'Семейные',
            'Игры для компании',
            'Карточные игры',
            'Экономические',
        ],
        category_en: ['Strategy games', 'Family games', 'Company games', 'Card games', 'Economic'],
        thumbnail: seven_Chudes,
        images: [
            seven_Chudes_1,
            seven_Chudes_2,
            seven_Chudes_3,
            seven_Chudes_4,
            seven_Chudes_5,
            seven_Chudes_6,
            seven_Chudes_7,
            seven_Chudes_8,
            seven_Chudes_9,
            seven_Chudes_10,
        ],
    },
    {
        id: 100,
        title_ru: 'Основатели Мрачной Гавани',
        title_en: 'The Founders of Grimhaven',
        subtittle_ru: 'Войдите в историю!',
        subtittle_en: 'Enter history!',
        description_ru:
            'Давным-давно, несколько сотен лет назад, после того как прогремела разрушительная Демоническая война, и все раздоры остались в прошлом, в мир пришла эпоха процветания. Теперь все расы должны объединиться и воздвигнуть величественный город, который впоследствии и станет легендарной Мрачной Гаванью.',
        description_en:
            'A long time ago, several hundred years ago, after the devastating Demon War broke out and all strife was left behind, an era of prosperity came to the world. Now all races must unite and build a majestic city, which will later become the legendary Grim Harbor.',
        price: 5490,
        discountPercentage: 1.5,
        rating: 5,
        stock: 983,
        GameTime: [120],
        age: [12],
        gamers: [1, 4],
        brand: 'Hobby World',
        category_ru: ['Стратегические игры', 'Хардкорные игры', 'Для одного'],
        category_en: ['Strategy Games', 'Hardcore Games', 'For One'],
        thumbnail: Osnovateli_Mrachnoy_Gavani,
        images: [
            Osnovateli_Mrachnoy_Gavani_1,
            Osnovateli_Mrachnoy_Gavani_2,
            Osnovateli_Mrachnoy_Gavani_3,
            Osnovateli_Mrachnoy_Gavani_4,
        ],
    },
    {
        id: 101,
        title_ru: "Судный день: проект 'Чистилище'",
        title_en: "Doomsday: Project 'Purgatory'",
        subtittle_ru: 'Восстание машин не остановить',
        subtittle_en: "The Rise of the Machines Can't Be Stopped",
        description_ru:
            "'Судный день: проект Чистилище' – дополнение к вечериночной игре о порабощении человека машиной. В неравной борьбе поможет лишь одно оружие – 'Чистилище'. Оно создаёт неведомый портал, открывающий чёрную дыру в пространственно-временном континууме. Однако есть одно но: какими будут последствия, когда данный проект осуществится – никому не известно.",
        description_en:
            "'Doomsday: Project Purgatory' is an addition to a party game about the enslavement of a man by a machine. In an unequal struggle, only one weapon will help - 'Purgatory'. It creates an unknown portal that opens a black hole in the space-time continuum. However, there is one thing: no one knows what the consequences will be when this project is implemented.",
        price: 590,
        discountPercentage: 1.2,
        rating: 3,
        stock: 200,
        GameTime: [15, 90],
        age: [13],
        gamers: [4, 16],
        brand: 'Magellan',
        category_ru: ['Детективные игры', 'Игры для компании', 'Мафия', 'Комоперативные игры'],
        category_en: [
            'Detective games',
            'Games for the company',
            'Mafia',
            'Party games',
            'Team games',
        ],
        thumbnail: Sudnyiy_den_proekt_Chistilische,
        images: [
            Sudnyiy_den_proekt_Chistilische_1,
            Sudnyiy_den_proekt_Chistilische_2,
            Sudnyiy_den_proekt_Chistilische_3,
            Sudnyiy_den_proekt_Chistilische_4,
            Sudnyiy_den_proekt_Chistilische_5,
            Sudnyiy_den_proekt_Chistilische_6,
            Sudnyiy_den_proekt_Chistilische_7,
            Sudnyiy_den_proekt_Chistilische_8,
            Sudnyiy_den_proekt_Chistilische_9,
            Sudnyiy_den_proekt_Chistilische_10,
            Sudnyiy_den_proekt_Chistilische_11,
        ],
    },
];
